import * as Do from "vue";
import { defineComponent as $t, h as Zn, getCurrentScope as El, onScopeDispose as kl, inject as xl, onMounted as mr, onUnmounted as Cl, Fragment as In, computed as Ye, watch as zo, ref as Ve, shallowRef as Al, createVNode as Ko, Text as Ll, openBlock as X, createElementBlock as te, createElementVNode as E, toDisplayString as j, unref as K, createTextVNode as Lt, renderList as fr, reactive as ea, normalizeClass as nn, createCommentVNode as Ue, withModifiers as Tl, withDirectives as Mo, vModelText as Ro, normalizeProps as Nl, guardReactiveProps as Ol, createBlock as Pl } from "vue";
/*!
  * shared v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function pt(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const os = {};
function Il(e) {
  os[e] || (os[e] = !0, pt(e));
}
const Ct = typeof window < "u";
let We, zt;
if (process.env.NODE_ENV !== "production") {
  const e = Ct && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (We = (t) => {
    e.mark(t);
  }, zt = (t, n, o) => {
    e.measure(t, n, o), e.clearMarks(n), e.clearMarks(o);
  });
}
const Sl = /\{([0-9a-zA-Z]+)\}/g;
function yo(e, ...t) {
  return t.length === 1 && Z(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Sl, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const At = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), $l = (e, t, n) => Dl({ l: e, k: t, s: n }), Dl = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Te = (e) => typeof e == "number" && isFinite(e), ta = (e) => pr(e) === "[object Date]", Jn = (e) => pr(e) === "[object RegExp]", _o = (e) => ie(e) && Object.keys(e).length === 0, Ce = Object.assign, Ml = Object.create, ce = (e = null) => Ml(e);
let rs;
const jt = () => rs || (rs = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : ce());
function ss(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function Rl(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const Bl = /^\s*javascript\s*(?::|&#0*58;?|&#x0*3a;?|&colon;?)/i, Fl = /^(?:href|src|action|formaction)$/i;
function wr(e) {
  return Bl.test(e);
}
function Ul(e) {
  const t = /url\s*\(/gi;
  let n = "", o = 0, r;
  for (; (r = t.exec(e)) !== null; ) {
    const s = r.index, a = t.lastIndex - 1;
    let i = a + 1, l = 1, w = null;
    for (; i < e.length; i++) {
      const d = e[i];
      if (w) {
        d === w && (w = null);
        continue;
      }
      if (d === '"' || d === "'")
        w = d;
      else if (d === "(")
        l++;
      else if (d === ")" && (l--, l === 0))
        break;
    }
    if (l !== 0)
      break;
    const h = e.slice(a + 1, i).trim(), v = h.startsWith('"') && h.endsWith('"') || h.startsWith("'") && h.endsWith("'") ? h.slice(1, -1).trim() : h;
    n += e.slice(o, s), n += wr(v) ? "url(about:blank)" : e.slice(s, i + 1), o = i + 1;
  }
  return n + e.slice(o);
}
function as(e, t) {
  if (Fl.test(e) && wr(t))
    return "about:blank";
  const n = e.toLowerCase() === "style" ? Ul(t) : t;
  return Rl(n);
}
function Vl(e) {
  return e = e.replace(/([\w:-]+)\s*=\s*"([^"]*)"/g, (n, o, r) => `${o}="${as(o, r)}"`), e = e.replace(/([\w:-]+)\s*=\s*'([^']*)'/g, (n, o, r) => `${o}='${as(o, r)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && pt("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), e = e.replace(/(\s+(?:href|src|action|formaction)\s*=\s*)([^\s"'=<>`]+)/gi, (n, o, r) => wr(r) ? `${o}about:blank` : n), e;
}
const Hl = Object.prototype.hasOwnProperty;
function nt(e, t) {
  return Hl.call(e, t);
}
const ye = Array.isArray, fe = (e) => typeof e == "function", M = (e) => typeof e == "string", ve = (e) => typeof e == "boolean", Z = (e) => e !== null && typeof e == "object", jl = (e) => Z(e) && fe(e.then) && fe(e.catch), na = Object.prototype.toString, pr = (e) => na.call(e), ie = (e) => pr(e) === "[object Object]", Yl = (e) => e == null ? "" : ye(e) || ie(e) && e.toString === na ? JSON.stringify(e, null, 2) : String(e);
function hr(e, t = "") {
  return e.reduce((n, o, r) => r === 0 ? n + o : n + t + o, "");
}
const is = 2;
function Wl(e, t = 0, n = e.length) {
  const o = e.split(/\r?\n/);
  let r = 0;
  const s = [];
  for (let a = 0; a < o.length; a++)
    if (r += o[a].length + 1, r >= t) {
      for (let i = a - is; i <= a + is || n > r; i++) {
        if (i < 0 || i >= o.length)
          continue;
        const l = i + 1;
        s.push(`${l}${" ".repeat(3 - String(l).length)}|  ${o[i]}`);
        const w = o[i].length;
        if (i === a) {
          const h = t - (r - w) + 1, v = Math.max(1, n > r ? w - h : n - t);
          s.push("   |  " + " ".repeat(h) + "^".repeat(v));
        } else if (i > a) {
          if (n > r) {
            const h = Math.max(Math.min(n - r, w), 1);
            s.push("   |  " + "^".repeat(h));
          }
          r += w + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
function oa() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, o) {
      const r = e.get(n);
      r && r.push(o) || e.set(n, [o]);
    },
    off(n, o) {
      const r = e.get(n);
      r && r.splice(r.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (e.get(n) || []).slice().map((r) => r(o)), (e.get("*") || []).slice().map((r) => r(n, o));
    }
  };
}
const Wn = (e) => !Z(e) || ye(e);
function Xn(e, t) {
  if (Wn(e) || Wn(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: o, des: r } = n.pop();
    Object.keys(o).forEach((s) => {
      s !== "__proto__" && (Z(o[s]) && !Z(r[s]) && (r[s] = Array.isArray(o[s]) ? [] : ce()), Wn(r[s]) || Wn(o[s]) ? r[s] = o[s] : n.push({ src: o[s], des: r[s] }));
    });
  }
}
/*!
  * message-compiler v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function ql(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Go(e, t, n) {
  return { start: e, end: t };
}
const q = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, zl = 17, Kl = {
  // tokenizer error messages
  [q.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [q.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [q.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [q.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [q.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [q.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [q.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [q.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [q.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [q.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [q.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [q.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [q.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [q.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [q.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [q.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function wn(e, t, n = {}) {
  const { domain: o, messages: r, args: s } = n, a = process.env.NODE_ENV !== "production" ? yo((r || Kl)[e] || "", ...s || []) : e, i = new SyntaxError(String(a));
  return i.code = e, t && (i.location = t), i.domain = o, i;
}
function Gl(e) {
  throw e;
}
const Xl = /<\/?[\w\s="/.':;#-\/]+>/, Zl = (e) => Xl.test(e), ut = " ", Jl = "\r", Ie = `
`, Ql = "\u2028", ec = "\u2029";
function tc(e) {
  const t = e;
  let n = 0, o = 1, r = 1, s = 0;
  const a = (x) => t[x] === Jl && t[x + 1] === Ie, i = (x) => t[x] === Ie, l = (x) => t[x] === ec, w = (x) => t[x] === Ql, h = (x) => a(x) || i(x) || l(x) || w(x), v = () => n, d = () => o, m = () => r, A = () => s, g = (x) => a(x) || l(x) || w(x) ? Ie : t[x], T = () => g(n), f = () => g(n + s);
  function b() {
    return s = 0, h(n) && (o++, r = 0), a(n) && n++, n++, r++, t[n];
  }
  function C() {
    return a(n + s) && s++, s++, t[n + s];
  }
  function p() {
    n = 0, o = 1, r = 1, s = 0;
  }
  function L(x = 0) {
    s = x;
  }
  function P() {
    const x = n + s;
    for (; x !== n; )
      b();
    s = 0;
  }
  return {
    index: v,
    line: d,
    column: m,
    peekOffset: A,
    charAt: g,
    currentChar: T,
    currentPeek: f,
    next: b,
    peek: C,
    reset: p,
    resetPeek: L,
    skipToPeek: P
  };
}
const yt = void 0, nc = ".", ls = "'", oc = "tokenizer";
function rc(e, t = {}) {
  const n = t.location !== !1, o = tc(e), r = () => o.index(), s = () => ql(o.line(), o.column(), o.index()), a = s(), i = r(), l = {
    currentType: 13,
    offset: i,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, w = () => l, { onError: h } = t;
  function v(c, u, N, ...D) {
    const me = w();
    if (u.column += N, u.offset += N, h) {
      const he = n ? Go(me.startLoc, u) : null, Q = wn(c, he, {
        domain: oc,
        args: D
      });
      h(Q);
    }
  }
  function d(c, u, N) {
    c.endLoc = s(), c.currentType = u;
    const D = { type: u };
    return n && (D.loc = Go(c.startLoc, c.endLoc)), N != null && (D.value = N), D;
  }
  const m = (c) => d(
    c,
    13
    /* TokenTypes.EOF */
  );
  function A(c, u) {
    return c.currentChar() === u ? (c.next(), u) : (v(q.EXPECTED_TOKEN, s(), 0, u), "");
  }
  function g(c) {
    let u = "";
    for (; c.currentPeek() === ut || c.currentPeek() === Ie; )
      u += c.currentPeek(), c.peek();
    return u;
  }
  function T(c) {
    const u = g(c);
    return c.skipToPeek(), u;
  }
  function f(c) {
    if (c === yt)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u === 95;
  }
  function b(c) {
    if (c === yt)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function C(c, u) {
    const { currentType: N } = u;
    if (N !== 2)
      return !1;
    g(c);
    const D = f(c.currentPeek());
    return c.resetPeek(), D;
  }
  function p(c, u) {
    const { currentType: N } = u;
    if (N !== 2)
      return !1;
    g(c);
    const D = c.currentPeek() === "-" ? c.peek() : c.currentPeek(), me = b(D);
    return c.resetPeek(), me;
  }
  function L(c, u) {
    const { currentType: N } = u;
    if (N !== 2)
      return !1;
    g(c);
    const D = c.currentPeek() === ls;
    return c.resetPeek(), D;
  }
  function P(c, u) {
    const { currentType: N } = u;
    if (N !== 7)
      return !1;
    g(c);
    const D = c.currentPeek() === ".";
    return c.resetPeek(), D;
  }
  function x(c, u) {
    const { currentType: N } = u;
    if (N !== 8)
      return !1;
    g(c);
    const D = f(c.currentPeek());
    return c.resetPeek(), D;
  }
  function z(c, u) {
    const { currentType: N } = u;
    if (!(N === 7 || N === 11))
      return !1;
    g(c);
    const D = c.currentPeek() === ":";
    return c.resetPeek(), D;
  }
  function H(c, u) {
    const { currentType: N } = u;
    if (N !== 9)
      return !1;
    const D = () => {
      const he = c.currentPeek();
      return he === "{" ? f(c.peek()) : he === "@" || he === "|" || he === ":" || he === "." || he === ut || !he ? !1 : he === Ie ? (c.peek(), D()) : Y(c, !1);
    }, me = D();
    return c.resetPeek(), me;
  }
  function U(c) {
    g(c);
    const u = c.currentPeek() === "|";
    return c.resetPeek(), u;
  }
  function Y(c, u = !0) {
    const N = (me = !1, he = "") => {
      const Q = c.currentPeek();
      return Q === "{" || Q === "@" || !Q ? me : Q === "|" ? !(he === ut || he === Ie) : Q === ut ? (c.peek(), N(!0, ut)) : Q === Ie ? (c.peek(), N(!0, Ie)) : !0;
    }, D = N();
    return u && c.resetPeek(), D;
  }
  function ne(c, u) {
    const N = c.currentChar();
    return N === yt ? yt : u(N) ? (c.next(), N) : null;
  }
  function Je(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36;
  }
  function W(c) {
    return ne(c, Je);
  }
  function $(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36 || // $
    u === 45;
  }
  function I(c) {
    return ne(c, $);
  }
  function F(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function S(c) {
    return ne(c, F);
  }
  function G(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57 || // 0-9
    u >= 65 && u <= 70 || // A-F
    u >= 97 && u <= 102;
  }
  function V(c) {
    return ne(c, G);
  }
  function J(c) {
    let u = "", N = "";
    for (; u = S(c); )
      N += u;
    return N;
  }
  function de(c) {
    let u = "";
    for (; ; ) {
      const N = c.currentChar();
      if (N === "\\") {
        const D = c.peek();
        D === "{" || D === "}" || D === "@" || D === "|" || D === "\\" ? (u += N + D, c.next(), c.next()) : (c.resetPeek(), u += N, c.next());
      } else {
        if (N === "{" || N === "}" || N === "@" || N === "|" || !N)
          break;
        if (N === ut || N === Ie)
          if (Y(c))
            u += N, c.next();
          else {
            if (U(c))
              break;
            u += N, c.next();
          }
        else
          u += N, c.next();
      }
    }
    return u;
  }
  function we(c) {
    T(c);
    let u = "", N = "";
    for (; u = I(c); )
      N += u;
    const D = c.currentChar();
    if (D && D !== "}" && D !== yt && D !== ut && D !== Ie && D !== "　") {
      const me = xe(c);
      return v(q.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, N + me), N + me;
    }
    return c.currentChar() === yt && v(q.UNTERMINATED_CLOSING_BRACE, s(), 0), N;
  }
  function ke(c) {
    T(c);
    let u = "";
    return c.currentChar() === "-" ? (c.next(), u += `-${J(c)}`) : u += J(c), c.currentChar() === yt && v(q.UNTERMINATED_CLOSING_BRACE, s(), 0), u;
  }
  function Pe(c) {
    return c !== ls && c !== Ie;
  }
  function bt(c) {
    T(c), A(c, "'");
    let u = "", N = "";
    for (; u = ne(c, Pe); )
      u === "\\" ? N += st(c) : N += u;
    const D = c.currentChar();
    return D === Ie || D === yt ? (v(q.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, s(), 0), D === Ie && (c.next(), A(c, "'")), N) : (A(c, "'"), N);
  }
  function st(c) {
    const u = c.currentChar();
    switch (u) {
      case "\\":
      case "'":
        return c.next(), `\\${u}`;
      case "u":
        return lt(c, u, 4);
      case "U":
        return lt(c, u, 6);
      default:
        return v(q.UNKNOWN_ESCAPE_SEQUENCE, s(), 0, u), "";
    }
  }
  function lt(c, u, N) {
    A(c, u);
    let D = "";
    for (let me = 0; me < N; me++) {
      const he = V(c);
      if (!he) {
        v(q.INVALID_UNICODE_ESCAPE_SEQUENCE, s(), 0, `\\${u}${D}${c.currentChar()}`);
        break;
      }
      D += he;
    }
    return `\\${u}${D}`;
  }
  function at(c) {
    return c !== "{" && c !== "}" && c !== ut && c !== Ie;
  }
  function xe(c) {
    T(c);
    let u = "", N = "";
    for (; u = ne(c, at); )
      N += u;
    return N;
  }
  function Qe(c) {
    let u = "", N = "";
    for (; u = W(c); )
      N += u;
    return N;
  }
  function vt(c) {
    const u = (N) => {
      const D = c.currentChar();
      return D === "{" || D === "@" || D === "|" || D === "(" || D === ")" || !D || D === ut ? N : (N += D, c.next(), u(N));
    };
    return u("");
  }
  function ct(c) {
    T(c);
    const u = A(
      c,
      "|"
      /* TokenChars.Pipe */
    );
    return T(c), u;
  }
  function xn(c, u) {
    let N = null;
    switch (c.currentChar()) {
      case "{":
        return u.braceNest >= 1 && v(q.NOT_ALLOW_NEST_PLACEHOLDER, s(), 0), c.next(), N = d(
          u,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), T(c), u.braceNest++, N;
      case "}":
        return u.braceNest > 0 && u.currentType === 2 && v(q.EMPTY_PLACEHOLDER, s(), 0), c.next(), N = d(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), u.braceNest--, u.braceNest > 0 && T(c), u.inLinked && u.braceNest === 0 && (u.inLinked = !1), N;
      case "@":
        return u.braceNest > 0 && v(q.UNTERMINATED_CLOSING_BRACE, s(), 0), N = Rt(c, u) || m(u), u.braceNest = 0, N;
      default: {
        let me = !0, he = !0, Q = !0;
        if (U(c))
          return u.braceNest > 0 && v(q.UNTERMINATED_CLOSING_BRACE, s(), 0), N = d(u, 1, ct(c)), u.braceNest = 0, u.inLinked = !1, N;
        if (u.braceNest > 0 && (u.currentType === 4 || u.currentType === 5 || u.currentType === 6))
          return v(q.UNTERMINATED_CLOSING_BRACE, s(), 0), u.braceNest = 0, Cn(c, u);
        if (me = C(c, u))
          return N = d(u, 4, we(c)), T(c), N;
        if (he = p(c, u))
          return N = d(u, 5, ke(c)), T(c), N;
        if (Q = L(c, u))
          return N = d(u, 6, bt(c)), T(c), N;
        if (!me && !he && !Q)
          return N = d(u, 12, xe(c)), v(q.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, N.value), T(c), N;
        break;
      }
    }
    return N;
  }
  function Rt(c, u) {
    const { currentType: N } = u;
    let D = null;
    const me = c.currentChar();
    switch ((N === 7 || N === 8 || N === 11 || N === 9) && (me === Ie || me === ut) && v(q.INVALID_LINKED_FORMAT, s(), 0), me) {
      case "@":
        return c.next(), D = d(
          u,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), u.inLinked = !0, D;
      case ".":
        return T(c), c.next(), d(
          u,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return T(c), c.next(), d(
          u,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return U(c) ? (D = d(u, 1, ct(c)), u.braceNest = 0, u.inLinked = !1, D) : P(c, u) || z(c, u) ? (T(c), Rt(c, u)) : x(c, u) ? (T(c), d(u, 11, Qe(c))) : H(c, u) ? (T(c), me === "{" ? xn(c, u) || D : d(u, 10, vt(c))) : (N === 7 && v(q.INVALID_LINKED_FORMAT, s(), 0), u.braceNest = 0, u.inLinked = !1, Cn(c, u));
    }
  }
  function Cn(c, u) {
    let N = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (u.braceNest > 0)
      return xn(c, u) || m(u);
    if (u.inLinked)
      return Rt(c, u) || m(u);
    switch (c.currentChar()) {
      case "{":
        return xn(c, u) || m(u);
      case "}":
        return v(q.UNBALANCED_CLOSING_BRACE, s(), 0), c.next(), d(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Rt(c, u) || m(u);
      default: {
        if (U(c))
          return N = d(u, 1, ct(c)), u.braceNest = 0, u.inLinked = !1, N;
        if (Y(c))
          return d(u, 0, de(c));
        break;
      }
    }
    return N;
  }
  function $o() {
    const { currentType: c, offset: u, startLoc: N, endLoc: D } = l;
    return l.lastType = c, l.lastOffset = u, l.lastStartLoc = N, l.lastEndLoc = D, l.offset = r(), l.startLoc = s(), o.currentChar() === yt ? d(
      l,
      13
      /* TokenTypes.EOF */
    ) : Cn(o, l);
  }
  return {
    nextToken: $o,
    currentOffset: r,
    currentPosition: s,
    context: w
  };
}
const sc = "parser", ac = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g, ic = /\\([\\@{}|])/g;
function lc(e, t) {
  return t;
}
function cc(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function uc(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function o(f, b, C, p, ...L) {
    const P = f.currentPosition();
    if (P.offset += p, P.column += p, n) {
      const x = t ? Go(C, P) : null, z = wn(b, x, {
        domain: sc,
        args: L
      });
      n(z);
    }
  }
  function r(f, b, C) {
    const p = { type: f };
    return t && (p.start = b, p.end = b, p.loc = { start: C, end: C }), p;
  }
  function s(f, b, C, p) {
    t && (f.end = b, f.loc && (f.loc.end = C));
  }
  function a(f, b) {
    const C = f.context(), p = r(3, C.offset, C.startLoc);
    return p.value = b.replace(ic, lc), s(p, f.currentOffset(), f.currentPosition()), p;
  }
  function i(f, b) {
    const C = f.context(), { lastOffset: p, lastStartLoc: L } = C, P = r(5, p, L);
    return P.index = parseInt(b, 10), f.nextToken(), s(P, f.currentOffset(), f.currentPosition()), P;
  }
  function l(f, b) {
    const C = f.context(), { lastOffset: p, lastStartLoc: L } = C, P = r(4, p, L);
    return P.key = b, f.nextToken(), s(P, f.currentOffset(), f.currentPosition()), P;
  }
  function w(f, b) {
    const C = f.context(), { lastOffset: p, lastStartLoc: L } = C, P = r(9, p, L);
    return P.value = b.replace(ac, cc), f.nextToken(), s(P, f.currentOffset(), f.currentPosition()), P;
  }
  function h(f) {
    const b = f.nextToken(), C = f.context(), { lastOffset: p, lastStartLoc: L } = C, P = r(8, p, L);
    return b.type !== 11 ? (o(f, q.UNEXPECTED_EMPTY_LINKED_MODIFIER, C.lastStartLoc, 0), P.value = "", s(P, p, L), {
      nextConsumeToken: b,
      node: P
    }) : (b.value == null && o(f, q.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, dt(b)), P.value = b.value || "", s(P, f.currentOffset(), f.currentPosition()), {
      node: P
    });
  }
  function v(f, b) {
    const C = f.context(), p = r(7, C.offset, C.startLoc);
    return p.value = b, s(p, f.currentOffset(), f.currentPosition()), p;
  }
  function d(f) {
    const b = f.context(), C = r(6, b.offset, b.startLoc);
    let p = f.nextToken();
    if (p.type === 8) {
      const L = h(f);
      C.modifier = L.node, p = L.nextConsumeToken || f.nextToken();
    }
    switch (p.type !== 9 && o(f, q.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(p)), p = f.nextToken(), p.type === 2 && (p = f.nextToken()), p.type) {
      case 10:
        p.value == null && o(f, q.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(p)), C.key = v(f, p.value || "");
        break;
      case 4:
        p.value == null && o(f, q.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(p)), C.key = l(f, p.value || "");
        break;
      case 5:
        p.value == null && o(f, q.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(p)), C.key = i(f, p.value || "");
        break;
      case 6:
        p.value == null && o(f, q.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(p)), C.key = w(f, p.value || "");
        break;
      default: {
        o(f, q.UNEXPECTED_EMPTY_LINKED_KEY, b.lastStartLoc, 0);
        const L = f.context(), P = r(7, L.offset, L.startLoc);
        return P.value = "", s(P, L.offset, L.startLoc), C.key = P, s(C, L.offset, L.startLoc), {
          nextConsumeToken: p,
          node: C
        };
      }
    }
    return s(C, f.currentOffset(), f.currentPosition()), {
      node: C
    };
  }
  function m(f) {
    const b = f.context(), C = b.currentType === 1 ? f.currentOffset() : b.offset, p = b.currentType === 1 ? b.endLoc : b.startLoc, L = r(2, C, p);
    L.items = [];
    let P = null;
    do {
      const H = P || f.nextToken();
      switch (P = null, H.type) {
        case 0:
          H.value == null && o(f, q.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(H)), L.items.push(a(f, H.value || ""));
          break;
        case 5:
          H.value == null && o(f, q.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(H)), L.items.push(i(f, H.value || ""));
          break;
        case 4:
          H.value == null && o(f, q.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(H)), L.items.push(l(f, H.value || ""));
          break;
        case 6:
          H.value == null && o(f, q.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(H)), L.items.push(w(f, H.value || ""));
          break;
        case 7: {
          const U = d(f);
          L.items.push(U.node), P = U.nextConsumeToken || null;
          break;
        }
      }
    } while (b.currentType !== 13 && b.currentType !== 1);
    const x = b.currentType === 1 ? b.lastOffset : f.currentOffset(), z = b.currentType === 1 ? b.lastEndLoc : f.currentPosition();
    return s(L, x, z), L;
  }
  function A(f, b, C, p) {
    const L = f.context();
    let P = p.items.length === 0;
    const x = r(1, b, C);
    x.cases = [], x.cases.push(p);
    do {
      const z = m(f);
      P || (P = z.items.length === 0), x.cases.push(z);
    } while (L.currentType !== 13);
    return P && o(f, q.MUST_HAVE_MESSAGES_IN_PLURAL, C, 0), s(x, f.currentOffset(), f.currentPosition()), x;
  }
  function g(f) {
    const b = f.context(), { offset: C, startLoc: p } = b, L = m(f);
    return b.currentType === 13 ? L : A(f, C, p, L);
  }
  function T(f) {
    const b = rc(f, Ce({}, e)), C = b.context(), p = r(0, C.offset, C.startLoc);
    return t && p.loc && (p.loc.source = f), p.body = g(b), e.onCacheKey && (p.cacheKey = e.onCacheKey(f)), C.currentType !== 13 && o(b, q.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, f[C.offset] || ""), s(p, b.currentOffset(), b.currentPosition()), p;
  }
  return { parse: T };
}
function dt(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function dc(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (s) => (n.helpers.add(s), s) };
}
function cs(e, t) {
  for (let n = 0; n < e.length; n++)
    gr(e[n], t);
}
function gr(e, t) {
  switch (e.type) {
    case 1:
      cs(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      cs(e.items, t);
      break;
    case 6: {
      gr(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function mc(e, t = {}) {
  const n = dc(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && gr(e.body, n);
  const o = n.context();
  e.helpers = Array.from(o.helpers);
}
function fc(e) {
  const t = e.body;
  return t.type === 2 ? us(t) : t.cases.forEach((n) => us(n)), e;
}
function us(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const o = e.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = hr(t);
      for (let n = 0; n < e.items.length; n++) {
        const o = e.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const wc = "minifier";
function tn(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      tn(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let o = 0; o < n.length; o++)
        tn(n[o]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let o = 0; o < n.length; o++)
        tn(n[o]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      tn(t.key), t.k = t.key, delete t.key, t.modifier && (tn(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw wn(q.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: wc,
          args: [e.type]
        });
  }
  delete e.type;
}
const pc = "parser";
function hc(e, t) {
  const { filename: n, breakLineCode: o, needIndent: r } = t, s = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: r,
    indentLevel: 0
  };
  s && e.loc && (a.source = e.loc.source);
  const i = () => a;
  function l(g, T) {
    a.code += g;
  }
  function w(g, T = !0) {
    const f = T ? o : "";
    l(r ? f + "  ".repeat(g) : f);
  }
  function h(g = !0) {
    const T = ++a.indentLevel;
    g && w(T);
  }
  function v(g = !0) {
    const T = --a.indentLevel;
    g && w(T);
  }
  function d() {
    w(a.indentLevel);
  }
  return {
    context: i,
    push: l,
    indent: h,
    deindent: v,
    newline: d,
    helper: (g) => `_${g}`,
    needIndent: () => a.needIndent
  };
}
function gc(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), ln(e, t.key), t.modifier ? (e.push(", "), ln(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function bc(e, t) {
  const { helper: n, needIndent: o } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const r = t.items.length;
  for (let s = 0; s < r && (ln(e, t.items[s]), s !== r - 1); s++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function vc(e, t) {
  const { helper: n, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const r = t.cases.length;
    for (let s = 0; s < r && (ln(e, t.cases[s]), s !== r - 1); s++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function yc(e, t) {
  t.body ? ln(e, t.body) : e.push("null");
}
function ln(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      yc(e, t);
      break;
    case 1:
      vc(e, t);
      break;
    case 2:
      bc(e, t);
      break;
    case 6:
      gc(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw wn(q.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: pc,
          args: [t.type]
        });
  }
}
const _c = (e, t = {}) => {
  const n = M(t.mode) ? t.mode : "normal", o = M(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const r = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, s = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], i = hc(e, {
    filename: o,
    breakLineCode: r,
    needIndent: s
  });
  i.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(s), a.length > 0 && (i.push(`const { ${hr(a.map((h) => `${h}: _${h}`), ", ")} } = ctx`), i.newline()), i.push("return "), ln(i, e), i.deindent(s), i.push("}"), delete e.helpers;
  const { code: l, map: w } = i.context();
  return {
    ast: e,
    code: l,
    map: w ? w.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Ec(e, t = {}) {
  const n = Ce({}, t), o = !!n.jit, r = !!n.minify, s = n.optimize == null ? !0 : n.optimize, i = uc(n).parse(e);
  return o ? (s && fc(i), r && tn(i), { ast: i, code: "" }) : (mc(i, n), _c(i, n));
}
/*!
  * core-base v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function kc() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (jt().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (jt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function it(e) {
  return Z(e) && br(e) === 0 && (nt(e, "b") || nt(e, "body"));
}
const ra = ["b", "body"];
function xc(e) {
  return Dt(e, ra);
}
const sa = ["c", "cases"];
function Cc(e) {
  return Dt(e, sa, []);
}
const aa = ["s", "static"];
function Ac(e) {
  return Dt(e, aa);
}
const ia = ["i", "items"];
function Lc(e) {
  return Dt(e, ia, []);
}
const la = ["t", "type"];
function br(e) {
  return Dt(e, la);
}
const ca = ["v", "value"];
function qn(e, t) {
  const n = Dt(e, ca);
  if (n != null)
    return n;
  throw Ln(t);
}
const ua = ["m", "modifier"];
function Tc(e) {
  return Dt(e, ua);
}
const da = ["k", "key"];
function Nc(e) {
  const t = Dt(e, da);
  if (t)
    return t;
  throw Ln(
    6
    /* NodeTypes.Linked */
  );
}
function Dt(e, t, n) {
  for (let o = 0; o < t.length; o++) {
    const r = t[o];
    if (nt(e, r) && e[r] != null)
      return e[r];
  }
  return n;
}
const ma = [
  ...ra,
  ...sa,
  ...aa,
  ...ia,
  ...da,
  ...ua,
  ...ca,
  ...la
];
function Ln(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Bo(e) {
  return (n) => Oc(n, e);
}
function Oc(e, t) {
  const n = xc(t);
  if (n == null)
    throw Ln(
      0
      /* NodeTypes.Resource */
    );
  if (br(n) === 1) {
    const s = Cc(n);
    return e.plural(s.reduce((a, i) => [
      ...a,
      ds(e, i)
    ], []));
  } else
    return ds(e, n);
}
function ds(e, t) {
  const n = Ac(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const o = Lc(t).reduce((r, s) => [...r, Xo(e, s)], []);
    return e.normalize(o);
  }
}
function Xo(e, t) {
  const n = br(t);
  switch (n) {
    case 3:
      return qn(t, n);
    case 9:
      return qn(t, n);
    case 4: {
      const o = t;
      if (nt(o, "k") && o.k)
        return e.interpolate(e.named(o.k));
      if (nt(o, "key") && o.key)
        return e.interpolate(e.named(o.key));
      throw Ln(n);
    }
    case 5: {
      const o = t;
      if (nt(o, "i") && Te(o.i))
        return e.interpolate(e.list(o.i));
      if (nt(o, "index") && Te(o.index))
        return e.interpolate(e.list(o.index));
      throw Ln(n);
    }
    case 6: {
      const o = t, r = Tc(o), s = Nc(o);
      return e.linked(Xo(e, s), r ? Xo(e, r) : void 0, e.type);
    }
    case 7:
      return qn(t, n);
    case 8:
      return qn(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const Pc = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Ic(e, t) {
  t && Zl(e) && pt(yo(Pc, { source: e }));
}
const Sc = (e) => e;
let zn = ce();
function $c(e, t = {}) {
  let n = !1;
  const o = t.onError || Gl;
  return t.onError = (r) => {
    n = !0, o(r);
  }, { ...Ec(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Dc(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && M(e)) {
    const n = ve(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Ic(e, n);
    const r = (t.onCacheKey || Sc)(e), s = zn[r];
    if (s)
      return s;
    const { ast: a, detectError: i } = $c(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = Bo(a);
    return i ? l : zn[r] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !it(e))
      return pt(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const o = zn[n];
      return o || (zn[n] = Bo(e));
    } else
      return Bo(e);
  }
}
let Tn = null;
function Mc(e) {
  Tn = e;
}
function Rc(e, t, n) {
  Tn && Tn.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Bc = /* @__PURE__ */ Fc("function:translate");
function Fc(e) {
  return (t) => Tn && Tn.emit(e, t);
}
const Se = {
  INVALID_ARGUMENT: zl,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, Uc = 24;
function _t(e) {
  return wn(e, null, process.env.NODE_ENV !== "production" ? { messages: Vc } : void 0);
}
const Vc = {
  [Se.INVALID_ARGUMENT]: "Invalid arguments",
  [Se.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Se.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Se.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Se.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Se.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Se.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function vr(e, t) {
  return t.locale != null ? ms(t.locale) : ms(e.locale);
}
let Fo;
function ms(e) {
  if (M(e))
    return e;
  if (fe(e)) {
    if (e.resolvedOnce && Fo != null)
      return Fo;
    if (e.constructor.name === "Function") {
      const t = e();
      if (jl(t))
        throw _t(Se.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Fo = t;
    } else
      throw _t(Se.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw _t(Se.NOT_SUPPORT_LOCALE_TYPE);
}
function Hc(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...ye(t) ? t : Z(t) ? Object.keys(t) : M(t) ? [t] : [n]
  ])];
}
function Zo(e, t, n) {
  const o = M(n) ? n : Qn, r = e;
  r.__localeChainCache || (r.__localeChainCache = /* @__PURE__ */ new Map());
  let s = r.__localeChainCache.get(o);
  if (!s) {
    s = [];
    let a = [n];
    for (; ye(a); )
      a = fs(s, a, t);
    const i = ye(t) || !ie(t) ? t : t.default ? t.default : null;
    a = M(i) ? [i] : i, ye(a) && fs(s, a, !1), r.__localeChainCache.set(o, s);
  }
  return s;
}
function fs(e, t, n) {
  let o = !0;
  for (let r = 0; r < t.length && ve(o); r++) {
    const s = t[r];
    M(s) && (o = jc(e, t[r], n));
  }
  return o;
}
function jc(e, t, n) {
  let o;
  const r = t.split("-");
  do {
    const s = r.join("-");
    o = Yc(e, s, n), r.splice(-1, 1);
  } while (r.length && o === !0);
  return o;
}
function Yc(e, t, n) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const r = t.replace(/!/g, "");
    e.push(r), (ye(n) || ie(n)) && n[r] && (o = n[r]);
  }
  return o;
}
const Mt = [];
Mt[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Mt[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Mt[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Mt[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Mt[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Mt[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Mt[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Wc = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function qc(e) {
  return Wc.test(e);
}
function zc(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Kc(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Gc(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : qc(t) ? zc(t) : "*" + t;
}
function Xc(e) {
  const t = [];
  let n = -1, o = 0, r = 0, s, a, i, l, w, h, v;
  const d = [];
  d[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = i : a += i;
  }, d[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, d[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    d[
      0
      /* Actions.APPEND */
    ](), r++;
  }, d[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (r > 0)
      r--, o = 4, d[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (r = 0, a === void 0 || (a = Gc(a), a === !1))
        return !1;
      d[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function m() {
    const A = e[n + 1];
    if (o === 5 && A === "'" || o === 6 && A === '"')
      return n++, i = "\\" + A, d[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, s = e[n], !(s === "\\" && m())) {
      if (l = Kc(s), v = Mt[o], w = v[l] || v.l || 8, w === 8 || (o = w[0], w[1] !== void 0 && (h = d[w[1]], h && (i = s, h() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const ws = /* @__PURE__ */ new Map();
function Zc(e, t) {
  return Z(e) ? e[t] : null;
}
function Jc(e, t) {
  if (!Z(e))
    return null;
  let n = ws.get(t);
  if (n || (n = Xc(t), n && ws.set(t, n)), !n)
    return null;
  const o = n.length;
  let r = e, s = 0;
  for (; s < o; ) {
    const a = n[s];
    if (ma.includes(a) && it(r) || !Z(r) || !nt(r, a))
      return null;
    const i = r[a];
    if (i === void 0 || fe(r))
      return null;
    r = i, s++;
  }
  return r;
}
const Le = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  INVALID_NUMBER_ARGUMENT: 8,
  INVALID_DATE_ARGUMENT: 9
}, en = 10, Qc = {
  [Le.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Le.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Le.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Le.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Le.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Le.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Le.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.",
  [Le.INVALID_NUMBER_ARGUMENT]: "Invalid argument for number formatting: expected a number but received '{value}'.",
  [Le.INVALID_DATE_ARGUMENT]: "Invalid argument for datetime formatting: expected a Date, number, or ISO string but received '{value}'."
};
function Et(e, ...t) {
  return yo(Qc[e], ...t);
}
const eu = "11.4.4", Eo = -1, Qn = "en-US", cn = "", ps = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function tu() {
  return {
    upper: (e, t) => t === "text" && M(e) ? e.toUpperCase() : t === "vnode" && Z(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && M(e) ? e.toLowerCase() : t === "vnode" && Z(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && M(e) ? ps(e) : t === "vnode" && Z(e) && "__v_isVNode" in e ? ps(e.children) : e
  };
}
let fa;
function nu(e) {
  fa = e;
}
let wa;
function ou(e) {
  wa = e;
}
let pa;
function ru(e) {
  pa = e;
}
let ha = null;
const su = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  ha = e;
}, au = /* @__NO_SIDE_EFFECTS__ */ () => ha;
let ga = null;
const hs = (e) => {
  ga = e;
}, iu = () => ga;
let gs = 0;
function lu(e = {}) {
  const t = fe(e.onWarn) ? e.onWarn : pt, n = M(e.version) ? e.version : eu, o = M(e.locale) || fe(e.locale) ? e.locale : Qn, r = fe(o) ? Qn : o, s = ye(e.fallbackLocale) || ie(e.fallbackLocale) || M(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : r, a = ie(e.messages) ? e.messages : Uo(r), i = ie(e.datetimeFormats) ? e.datetimeFormats : Uo(r), l = ie(e.numberFormats) ? e.numberFormats : Uo(r), w = Ce(ce(), e.modifiers, tu()), h = e.pluralRules || ce(), v = fe(e.missing) ? e.missing : null, d = ve(e.missingWarn) || Jn(e.missingWarn) ? e.missingWarn : !0, m = ve(e.fallbackWarn) || Jn(e.fallbackWarn) ? e.fallbackWarn : !0, A = !!e.fallbackFormat, g = !!e.unresolving, T = fe(e.postTranslation) ? e.postTranslation : null, f = ie(e.processor) ? e.processor : null, b = ve(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, C = !!e.escapeParameter, p = fe(e.messageCompiler) ? e.messageCompiler : fa;
  process.env.NODE_ENV !== "production" && fe(e.messageCompiler) && Il(Et(Le.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const L = fe(e.messageResolver) ? e.messageResolver : wa || Zc, P = fe(e.localeFallbacker) ? e.localeFallbacker : pa || Hc, x = Z(e.fallbackContext) ? e.fallbackContext : void 0, z = e, H = Z(z.__datetimeFormatters) ? z.__datetimeFormatters : /* @__PURE__ */ new Map(), U = Z(z.__numberFormatters) ? z.__numberFormatters : /* @__PURE__ */ new Map(), Y = Z(z.__meta) ? z.__meta : {};
  gs++;
  const ne = {
    version: n,
    cid: gs,
    locale: o,
    fallbackLocale: s,
    messages: a,
    modifiers: w,
    pluralRules: h,
    missing: v,
    missingWarn: d,
    fallbackWarn: m,
    fallbackFormat: A,
    unresolving: g,
    postTranslation: T,
    processor: f,
    warnHtmlMessage: b,
    escapeParameter: C,
    messageCompiler: p,
    messageResolver: L,
    localeFallbacker: P,
    fallbackContext: x,
    onWarn: t,
    __meta: Y
  };
  return ne.datetimeFormats = i, ne.numberFormats = l, ne.__datetimeFormatters = H, ne.__numberFormatters = U, process.env.NODE_ENV !== "production" && (ne.__v_emitter = z.__v_emitter != null ? z.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Rc(ne, n, Y), ne;
}
const Uo = (e) => ({ [e]: ce() });
function ko(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function ba(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function yr(e, t, n, o, r) {
  const { missing: s, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: r,
      groupId: `${r}:${t}`
    });
  }
  if (s !== null) {
    const i = s(e, n, t, r);
    return M(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && ba(o, t) && a(Et(Le.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function An(e, t, n) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function va(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function cu(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let o = n + 1; o < t.length; o++)
    if (va(e, t[o]))
      return !0;
  return !1;
}
const bs = typeof Intl < "u", ya = {
  dateTimeFormat: bs && typeof Intl.DateTimeFormat < "u",
  numberFormat: bs && typeof Intl.NumberFormat < "u"
};
function vs(e, ...t) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: r, onWarn: s, localeFallbacker: a } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !ya.dateTimeFormat)
    return s(Et(Le.CANNOT_FORMAT_DATE)), cn;
  if (!M(t[0]) && !ta(t[0]) && !Te(t[0]))
    return process.env.NODE_ENV !== "production" && s(Et(Le.INVALID_DATE_ARGUMENT, {
      value: String(t[0])
    })), cn;
  const [l, w, h, v] = Jo(...t), d = ve(h.missingWarn) ? h.missingWarn : e.missingWarn, m = ve(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, A = !!h.part, g = vr(e, h), T = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    g
  );
  if (!M(l) || l === "")
    return new Intl.DateTimeFormat(g.replace(/!/g, ""), v).format(w);
  let f = {}, b, C = null, p = g, L = null;
  const P = "datetime format";
  for (let H = 0; H < T.length; H++) {
    if (b = L = T[H], process.env.NODE_ENV !== "production" && g !== b && ko(m, l) && s(Et(Le.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: b
    })), process.env.NODE_ENV !== "production" && g !== b) {
      const U = e.__v_emitter;
      U && U.emit("fallback", {
        type: P,
        key: l,
        from: p,
        to: L,
        groupId: `${P}:${l}`
      });
    }
    if (f = n[b] || {}, C = f[l], ie(C))
      break;
    yr(e, l, b, d, P), p = L;
  }
  if (!ie(C) || !M(b))
    return o ? Eo : l;
  let x = `${b}__${l}`;
  _o(v) || (x = `${x}__${JSON.stringify(v)}`);
  let z = i.get(x);
  return z || (z = new Intl.DateTimeFormat(b, Ce({}, C, v)), i.set(x, z)), A ? z.formatToParts(w) : z.format(w);
}
const _a = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Jo(...e) {
  const [t, n, o, r] = e, s = ce();
  let a = ce(), i;
  if (M(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw _t(Se.INVALID_ISO_DATE_ARGUMENT);
    const w = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    i = new Date(w);
    try {
      i.toISOString();
    } catch {
      throw _t(Se.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (ta(t)) {
    if (isNaN(t.getTime()))
      throw _t(Se.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (Te(t))
    i = t;
  else
    throw _t(Se.INVALID_ARGUMENT);
  return M(n) ? s.key = n : ie(n) && Object.keys(n).forEach((l) => {
    _a.includes(l) ? a[l] = n[l] : s[l] = n[l];
  }), M(o) ? s.locale = o : ie(o) && (a = o), ie(r) && (a = r), [s.key || "", i, s, a];
}
function ys(e, t, n) {
  const o = e;
  for (const r in n) {
    const s = `${t}__${r}`;
    o.__datetimeFormatters.has(s) && o.__datetimeFormatters.delete(s);
  }
}
function _s(e, ...t) {
  const { numberFormats: n, unresolving: o, fallbackLocale: r, onWarn: s, localeFallbacker: a } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !ya.numberFormat)
    return s(Et(Le.CANNOT_FORMAT_NUMBER)), cn;
  if (!Te(t[0]))
    return process.env.NODE_ENV !== "production" && s(Et(Le.INVALID_NUMBER_ARGUMENT, {
      value: String(t[0])
    })), cn;
  const [l, w, h, v] = Qo(...t), d = ve(h.missingWarn) ? h.missingWarn : e.missingWarn, m = ve(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, A = !!h.part, g = vr(e, h), T = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    g
  );
  if (!M(l) || l === "")
    return new Intl.NumberFormat(g.replace(/!/g, ""), v).format(w);
  let f = {}, b, C = null, p = g, L = null;
  const P = "number format";
  for (let H = 0; H < T.length; H++) {
    if (b = L = T[H], process.env.NODE_ENV !== "production" && g !== b && ko(m, l) && s(Et(Le.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: b
    })), process.env.NODE_ENV !== "production" && g !== b) {
      const U = e.__v_emitter;
      U && U.emit("fallback", {
        type: P,
        key: l,
        from: p,
        to: L,
        groupId: `${P}:${l}`
      });
    }
    if (f = n[b] || {}, C = f[l], ie(C))
      break;
    yr(e, l, b, d, P), p = L;
  }
  if (!ie(C) || !M(b))
    return o ? Eo : l;
  let x = `${b}__${l}`;
  _o(v) || (x = `${x}__${JSON.stringify(v)}`);
  let z = i.get(x);
  return z || (z = new Intl.NumberFormat(b, Ce({}, C, v)), i.set(x, z)), A ? z.formatToParts(w) : z.format(w);
}
const Ea = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Qo(...e) {
  const [t, n, o, r] = e, s = ce();
  let a = ce();
  if (!Te(t))
    throw _t(Se.INVALID_ARGUMENT);
  const i = t;
  return M(n) ? s.key = n : ie(n) && Object.keys(n).forEach((l) => {
    Ea.includes(l) ? a[l] = n[l] : s[l] = n[l];
  }), M(o) ? s.locale = o : ie(o) && (a = o), ie(r) && (a = r), [s.key || "", i, s, a];
}
function Es(e, t, n) {
  const o = e;
  for (const r in n) {
    const s = `${t}__${r}`;
    o.__numberFormatters.has(s) && o.__numberFormatters.delete(s);
  }
}
const uu = (e) => e, du = (e) => "", mu = "text", fu = (e) => e.length === 0 ? "" : hr(e), wu = Yl;
function Vo(e, t) {
  return e = Math.abs(e), t === 2 ? e === 1 ? 0 : 1 : Math.min(e, 2);
}
function pu(e) {
  var n, o;
  const t = Te(e.pluralIndex) ? e.pluralIndex : -1;
  return Te((n = e.named) == null ? void 0 : n.count) ? e.named.count : Te((o = e.named) == null ? void 0 : o.n) ? e.named.n : t;
}
function hu(e = {}) {
  var f, b, C, p;
  const t = e.locale, n = pu(e), o = M(t) && fe((f = e.pluralRules) == null ? void 0 : f[t]) ? e.pluralRules[t] : Vo, r = o === Vo ? void 0 : Vo, s = (L) => L[o(n, L.length, r)], a = e.list || [], i = (L) => a[L], l = e.named || ce();
  Te(e.pluralIndex) && (l.count || (l.count = e.pluralIndex), l.n || (l.n = e.pluralIndex));
  const w = (L) => l[L];
  function h(L, P) {
    const x = fe(e.messages) ? e.messages(L, !!P) : Z(e.messages) ? e.messages[L] : !1;
    return x || (e.parent ? e.parent.message(L) : du);
  }
  const v = (L) => e.modifiers ? e.modifiers[L] : uu, d = fe((b = e.processor) == null ? void 0 : b.normalize) ? e.processor.normalize : fu, m = fe((C = e.processor) == null ? void 0 : C.interpolate) ? e.processor.interpolate : wu, A = M((p = e.processor) == null ? void 0 : p.type) ? e.processor.type : mu, T = {
    list: i,
    named: w,
    plural: s,
    linked: (L, ...P) => {
      const [x, z] = P;
      let H = "text", U = "";
      P.length === 1 ? Z(x) ? (U = x.modifier || U, H = x.type || H) : M(x) && (U = x || U) : P.length === 2 && (M(x) && (U = x || U), M(z) && (H = z || H));
      const Y = h(L, !0)(T), ne = Y === "" || Y === void 0 ? L : Y, Je = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        H === "vnode" && ye(ne) && U ? ne[0] : ne
      );
      return U ? v(U)(Je, H) : Je;
    },
    message: h,
    type: A,
    interpolate: m,
    normalize: d,
    values: Ce(ce(), a, l)
  };
  return T;
}
const ks = () => "", tt = (e) => fe(e);
function xs(e, ...t) {
  const { fallbackFormat: n, postTranslation: o, unresolving: r, messageCompiler: s, fallbackLocale: a, messages: i } = e, [l, w] = er(...t), h = ve(w.missingWarn) ? w.missingWarn : e.missingWarn, v = ve(w.fallbackWarn) ? w.fallbackWarn : e.fallbackWarn, d = ve(w.escapeParameter) ? w.escapeParameter : e.escapeParameter, m = !!w.resolvedMessage, A = M(w.default) || ve(w.default) ? ve(w.default) ? s ? l : () => l : w.default : n ? s ? l : () => l : null, g = n || A != null && (M(A) || fe(A)), T = vr(e, w);
  d && gu(w);
  let [f, b, C] = m ? [
    l,
    T,
    i[T] || ce()
  ] : ka(e, l, T, a, v, h), p = f, L = l;
  if (!m && !(M(p) || it(p) || tt(p)) && g && (p = A, L = p), !m && (!(M(p) || it(p) || tt(p)) || !M(b)))
    return r ? Eo : l;
  if (process.env.NODE_ENV !== "production" && M(p) && e.messageCompiler == null)
    return pt(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let P = !1;
  const x = () => {
    P = !0;
  }, z = tt(p) ? p : xa(e, l, b, p, L, x);
  if (P)
    return p;
  const H = _u(e, b, C, w), U = hu(H), Y = bu(e, z, U);
  let ne = o ? o(Y, l) : Y;
  if (d && M(ne) && (ne = Vl(ne)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const Je = {
      timestamp: Date.now(),
      key: M(l) ? l : tt(p) ? p.key : "",
      locale: b || (tt(p) ? p.locale : ""),
      format: M(p) ? p : tt(p) ? p.source : "",
      message: ne
    };
    Je.meta = Ce({}, e.__meta, /* @__PURE__ */ au() || {}), Bc(Je);
  }
  return ne;
}
function gu(e) {
  ye(e.list) ? e.list = e.list.map((t) => M(t) ? ss(t) : t) : Z(e.named) && Object.keys(e.named).forEach((t) => {
    M(e.named[t]) && (e.named[t] = ss(e.named[t]));
  });
}
function ka(e, t, n, o, r, s) {
  const { messages: a, onWarn: i, messageResolver: l, localeFallbacker: w } = e, h = w(e, o, n);
  let v = ce(), d, m = null, A = n, g = null;
  const T = "translate";
  for (let f = 0; f < h.length; f++) {
    d = g = h[f], process.env.NODE_ENV !== "production" && n !== d && !va(n, d) && ko(r, t) && i(Et(Le.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: d
    }));
    const b = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
    process.env.NODE_ENV !== "production" && n !== d && b && b.emit("fallback", {
      type: T,
      key: t,
      from: A,
      to: g,
      groupId: `${T}:${t}`
    }), v = a[d] || ce();
    let C = null, p, L;
    if (process.env.NODE_ENV !== "production" && Ct && b && (C = window.performance.now(), p = "intlify-message-resolve-start", L = "intlify-message-resolve-end", We && We(p)), (m = l(v, t)) === null && (m = v[t]), process.env.NODE_ENV !== "production" && Ct && b) {
      const P = window.performance.now();
      b && C && m && b.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: m,
        time: P - C,
        groupId: `${T}:${t}`
      }), p && L && We && zt && (We(L), zt("intlify message resolve", p, L));
    }
    if (M(m) || it(m) || tt(m))
      break;
    if (!cu(d, h)) {
      const P = yr(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        d,
        s,
        T
      );
      P !== t && (m = P);
    }
    A = g;
  }
  return [m, d, v];
}
function xa(e, t, n, o, r, s) {
  const { messageCompiler: a, warnHtmlMessage: i } = e;
  if (tt(o)) {
    const m = o;
    return m.locale = m.locale || n, m.key = m.key || t, m;
  }
  if (a == null) {
    const m = () => o;
    return m.locale = n, m.key = t, m;
  }
  const l = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let w = null, h, v;
  process.env.NODE_ENV !== "production" && Ct && l && (w = window.performance.now(), h = "intlify-message-compilation-start", v = "intlify-message-compilation-end", We && We(h));
  const d = a(o, vu(e, n, r, o, i, s));
  if (process.env.NODE_ENV !== "production" && Ct && l) {
    const m = window.performance.now();
    l && w && l.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: m - w,
      groupId: `translate:${t}`
    }), h && v && We && zt && (We(v), zt("intlify message compilation", h, v));
  }
  return d.locale = n, d.key = t, d.source = o, d;
}
function bu(e, t, n) {
  const o = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let r = null, s, a;
  process.env.NODE_ENV !== "production" && Ct && o && (r = window.performance.now(), s = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", We && We(s));
  const i = t(n);
  if (process.env.NODE_ENV !== "production" && Ct && o) {
    const l = window.performance.now();
    o && r && o.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: l - r,
      groupId: `translate:${t.key}`
    }), s && a && We && zt && (We(a), zt("intlify message evaluation", s, a));
  }
  return i;
}
function er(...e) {
  const [t, n, o] = e, r = ce();
  if (!M(t) && !Te(t) && !tt(t) && !it(t))
    throw _t(Se.INVALID_ARGUMENT);
  const s = Te(t) ? String(t) : (tt(t), t);
  return Te(n) ? r.plural = n : M(n) ? r.default = n : ie(n) && !_o(n) ? r.named = n : ye(n) && (r.list = n), Te(o) ? r.plural = o : M(o) ? r.default = o : ie(o) && Ce(r, o), [s, r];
}
function vu(e, t, n, o, r, s) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: r,
    onError: (a) => {
      if (s && s(a), process.env.NODE_ENV !== "production") {
        const i = yu(o), l = a.location && i && Wl(i, a.location.start.offset, a.location.end.offset), w = e.__v_emitter;
        w && i && w.emit("compile-error", {
          message: i,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        });
        const h = `Message compilation error: ${a.message}`;
        throw new SyntaxError(l ? `${h}
${l}` : h);
      }
      throw a;
    },
    onCacheKey: (a) => $l(t, n, a)
  };
}
function yu(e) {
  if (M(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function _u(e, t, n, o) {
  const { modifiers: r, pluralRules: s, messageResolver: a, fallbackLocale: i, fallbackWarn: l, missingWarn: w, fallbackContext: h } = e, d = {
    locale: t,
    modifiers: r,
    pluralRules: s,
    messages: (m, A) => {
      let g = a(n, m);
      if (g == null && (h || A)) {
        const [T, , f] = ka(
          h || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          m,
          t,
          i,
          l,
          w
        );
        g = T ?? a(f, m);
      }
      if (M(g) || it(g)) {
        let T = !1;
        const b = xa(e, m, t, g, m, () => {
          T = !0;
        });
        return T ? ks : b;
      } else return tt(g) ? g : ks;
    }
  };
  return e.processor && (d.processor = e.processor), o.list && (d.list = o.list), o.named && (d.named = o.named), Te(o.plural) && (d.pluralIndex = o.plural), d;
}
kc();
/*!
  * vue-i18n v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
const Eu = "11.4.4";
function ku() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (jt().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (jt().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (jt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (jt().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Ae = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Uc,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function rn(e, ...t) {
  return wn(e, null, process.env.NODE_ENV !== "production" ? { messages: xu, args: t } : void 0);
}
const xu = {
  [Ae.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Ae.INVALID_ARGUMENT]: "Invalid argument",
  [Ae.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Ae.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Ae.UNEXPECTED_ERROR]: "Unexpected error",
  [Ae.REQUIRED_VALUE]: "Required in value: {0}",
  [Ae.INVALID_VALUE]: "Invalid value",
  [Ae.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Ae.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Ae.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Ae.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, tr = /* @__PURE__ */ At("__translateVNode"), nr = /* @__PURE__ */ At("__datetimeParts"), or = /* @__PURE__ */ At("__numberParts"), Nn = /* @__PURE__ */ At("__enableEmitter"), On = /* @__PURE__ */ At("__disableEmitter"), Cu = At("__setPluralRules"), Ca = /* @__PURE__ */ At("__injectWithOption"), on = /* @__PURE__ */ At("__dispose"), wt = {
  FALLBACK_TO_ROOT: en,
  // 10
  NOT_FOUND_PARENT_SCOPE: en + 1,
  IGNORE_OBJ_FLATTEN: en + 2,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: en + 3,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: en + 4,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: en + 5
}, Au = {
  [wt.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [wt.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [wt.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [wt.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [wt.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [wt.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function eo(e, ...t) {
  return yo(Au[e], ...t);
}
function Pn(e) {
  if (!Z(e) || it(e))
    return e;
  for (const t in e)
    if (nt(e, t))
      if (!t.includes("."))
        Z(e[t]) && Pn(e[t]);
      else {
        const n = t.split("."), o = n.length - 1;
        let r = e, s = !1;
        for (let a = 0; a < o; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in r || (r[n[a]] = ce()), !Z(r[n[a]])) {
            process.env.NODE_ENV !== "production" && pt(eo(wt.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), s = !0;
            break;
          }
          r = r[n[a]];
        }
        if (s || (it(r) ? ma.includes(n[o]) || delete e[t] : (r[n[o]] = e[t], delete e[t])), !it(r)) {
          const a = r[n[o]];
          Z(a) && Pn(a);
        }
      }
  return e;
}
function Aa(e, t) {
  const { messages: n, __i18n: o, messageResolver: r, flatJson: s } = t, a = ie(n) ? n : ye(o) ? ce() : { [e]: ce() };
  if (ye(o) && o.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: l, resource: w } = i;
      l ? (a[l] = a[l] || ce(), Xn(w, a[l])) : Xn(w, a);
    } else
      M(i) && Xn(JSON.parse(i), a);
  }), r == null && s)
    for (const i in a)
      nt(a, i) && Pn(a[i]);
  return a;
}
function La(e) {
  return e.type;
}
function Lu(e, t, n) {
  let o = Z(t.messages) ? t.messages : ce();
  "__i18nGlobal" in n && (o = Aa(e.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const r = Object.keys(o);
  r.length && r.forEach((s) => {
    e.mergeLocaleMessage(s, o[s]);
  });
  {
    if (Z(t.datetimeFormats)) {
      const s = Object.keys(t.datetimeFormats);
      s.length && s.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (Z(t.numberFormats)) {
      const s = Object.keys(t.numberFormats);
      s.length && s.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function Cs(e) {
  return Ko(Ll, null, e, 0);
}
function _r() {
  const e = "currentInstance";
  return e in Do ? Do[e] : Do.getCurrentInstance();
}
const As = "__INTLIFY_META__", Ls = () => [], Tu = () => !1;
let Ts = 0;
function Ns(e) {
  return (t, n, o, r) => e(n, o, _r() || void 0, r);
}
const Nu = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = _r();
  let t = null;
  return e && (t = La(e)[As]) ? { [As]: t } : null;
};
function Os(e = {}) {
  const { __root: t, __injectWithOption: n } = e, o = t === void 0, r = e.flatJson, s = Ct ? Ve : Al;
  let a = ve(e.inheritLocale) ? e.inheritLocale : !0;
  const i = s(
    // prettier-ignore
    t && a ? t.locale.value : M(e.locale) ? e.locale : Qn
  ), l = s(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : M(e.fallbackLocale) || ye(e.fallbackLocale) || ie(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), w = s(Aa(i.value, e)), h = s(ie(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), v = s(ie(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let d = t ? t.missingWarn : ve(e.missingWarn) || Jn(e.missingWarn) ? e.missingWarn : !0, m = t ? t.fallbackWarn : ve(e.fallbackWarn) || Jn(e.fallbackWarn) ? e.fallbackWarn : !0, A = t ? t.fallbackRoot : ve(e.fallbackRoot) ? e.fallbackRoot : !0, g = !!e.fallbackFormat, T = fe(e.missing) ? e.missing : null, f = fe(e.missing) ? Ns(e.missing) : null, b = fe(e.postTranslation) ? e.postTranslation : null, C = t ? t.warnHtmlMessage : ve(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, p = !!e.escapeParameter;
  const L = t ? t.modifiers : ie(e.modifiers) ? e.modifiers : {};
  let P = e.pluralRules || t && t.pluralRules, x;
  x = (() => {
    o && hs(null);
    const k = {
      version: Eu,
      locale: i.value,
      fallbackLocale: l.value,
      messages: w.value,
      modifiers: L,
      pluralRules: P,
      missing: f === null ? void 0 : f,
      missingWarn: d,
      fallbackWarn: m,
      fallbackFormat: g,
      unresolving: !0,
      postTranslation: b === null ? void 0 : b,
      warnHtmlMessage: C,
      escapeParameter: p,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    k.datetimeFormats = h.value, k.numberFormats = v.value, k.__datetimeFormatters = ie(x) ? x.__datetimeFormatters : void 0, k.__numberFormatters = ie(x) ? x.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (k.__v_emitter = ie(x) ? x.__v_emitter : void 0);
    const O = lu(k);
    return o && hs(O), O;
  })(), An(x, i.value, l.value);
  function H() {
    return [
      i.value,
      l.value,
      w.value,
      h.value,
      v.value
    ];
  }
  const U = Ye({
    get: () => i.value,
    set: (k) => {
      x.locale = k, i.value = k;
    }
  }), Y = Ye({
    get: () => l.value,
    set: (k) => {
      x.fallbackLocale = k, l.value = k, An(x, i.value, k);
    }
  }), ne = Ye(() => w.value), Je = /* @__PURE__ */ Ye(() => h.value), W = /* @__PURE__ */ Ye(() => v.value);
  function $() {
    return fe(b) ? b : null;
  }
  function I(k) {
    b = k, x.postTranslation = k;
  }
  function F() {
    return T;
  }
  function S(k) {
    k !== null && (f = Ns(k)), T = k, x.missing = f;
  }
  function G(k, O) {
    return k !== "translate" || !O.resolvedMessage;
  }
  const V = (k, O, ee, pe, Bt, Ft) => {
    H();
    let et;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (x.fallbackContext = t ? iu() : void 0), et = k(x);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (x.fallbackContext = void 0);
    }
    if (ee !== "translate exists" && // for not `te` (e.g `t`)
    Te(et) && et === Eo || ee === "translate exists" && !et) {
      const [Ut, _l] = O();
      if (process.env.NODE_ENV !== "production" && t && M(Ut) && G(ee, _l) && (A && (ko(m, Ut) || ba(d, Ut)) && pt(eo(wt.FALLBACK_TO_ROOT, {
        key: Ut,
        type: ee
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: ns } = x;
        ns && A && ns.emit("fallback", {
          type: ee,
          key: Ut,
          to: "global",
          groupId: `${ee}:${Ut}`
        });
      }
      return t && A ? pe(t) : Bt(Ut);
    } else {
      if (Ft(et))
        return et;
      throw rn(Ae.UNEXPECTED_RETURN_TYPE);
    }
  };
  function J(...k) {
    return V((O) => Reflect.apply(xs, null, [O, ...k]), () => er(...k), "translate", (O) => Reflect.apply(O.t, O, [...k]), (O) => O, (O) => M(O));
  }
  function de(...k) {
    const [O, ee, pe] = k;
    if (pe && !Z(pe))
      throw rn(Ae.INVALID_ARGUMENT);
    return J(O, ee, Ce({ resolvedMessage: !0 }, pe || {}));
  }
  function we(...k) {
    return V((O) => Reflect.apply(vs, null, [O, ...k]), () => Jo(...k), "datetime format", (O) => Reflect.apply(O.d, O, [...k]), () => cn, (O) => M(O) || ye(O));
  }
  function ke(...k) {
    return V((O) => Reflect.apply(_s, null, [O, ...k]), () => Qo(...k), "number format", (O) => Reflect.apply(O.n, O, [...k]), () => cn, (O) => M(O) || ye(O));
  }
  function Pe(k) {
    return k.map((O) => M(O) || Te(O) || ve(O) ? Cs(String(O)) : O);
  }
  const st = {
    normalize: Pe,
    interpolate: (k) => k,
    type: "vnode"
  };
  function lt(...k) {
    return V((O) => {
      let ee;
      const pe = O;
      try {
        pe.processor = st, ee = Reflect.apply(xs, null, [pe, ...k]);
      } finally {
        pe.processor = null;
      }
      return ee;
    }, () => er(...k), "translate", (O) => O[tr](...k), (O) => [Cs(O)], (O) => ye(O));
  }
  function at(...k) {
    return V((O) => Reflect.apply(_s, null, [O, ...k]), () => Qo(...k), "number format", (O) => O[or](...k), Ls, (O) => M(O) || ye(O));
  }
  function xe(...k) {
    return V((O) => Reflect.apply(vs, null, [O, ...k]), () => Jo(...k), "datetime format", (O) => O[nr](...k), Ls, (O) => M(O) || ye(O));
  }
  function Qe(k) {
    P = k, x.pluralRules = P;
  }
  function vt(k, O) {
    return V(() => {
      if (!k)
        return !1;
      const ee = M(O) ? O : i.value, pe = M(O) ? [ee] : Zo(x, l.value, ee);
      for (let Bt = 0; Bt < pe.length; Bt++) {
        const Ft = Rt(pe[Bt]);
        let et = x.messageResolver(Ft, k);
        if (et === null && (et = Ft[k]), it(et) || tt(et) || M(et))
          return !0;
      }
      return !1;
    }, () => [k], "translate exists", (ee) => Reflect.apply(ee.te, ee, [k, O]), Tu, (ee) => ve(ee));
  }
  function ct(k) {
    let O = null;
    const ee = Zo(x, l.value, i.value);
    for (let pe = 0; pe < ee.length; pe++) {
      const Bt = w.value[ee[pe]] || {}, Ft = x.messageResolver(Bt, k);
      if (Ft != null) {
        O = Ft;
        break;
      }
    }
    return O;
  }
  function xn(k) {
    const O = ct(k);
    return O ?? (t ? t.tm(k) || {} : {});
  }
  function Rt(k) {
    return w.value[k] || {};
  }
  function Cn(k, O) {
    if (r) {
      const ee = { [k]: O };
      for (const pe in ee)
        nt(ee, pe) && Pn(ee[pe]);
      O = ee[k];
    }
    w.value[k] = O, x.messages = w.value;
  }
  function $o(k, O) {
    w.value[k] = w.value[k] || {};
    const ee = { [k]: O };
    if (r)
      for (const pe in ee)
        nt(ee, pe) && Pn(ee[pe]);
    O = ee[k], Xn(O, w.value[k]), x.messages = w.value;
  }
  function c(k) {
    return h.value[k] || {};
  }
  function u(k, O) {
    h.value[k] = O, x.datetimeFormats = h.value, ys(x, k, O);
  }
  function N(k, O) {
    h.value[k] = Ce(h.value[k] || {}, O), x.datetimeFormats = h.value, ys(x, k, O);
  }
  function D(k) {
    return v.value[k] || {};
  }
  function me(k, O) {
    v.value[k] = O, x.numberFormats = v.value, Es(x, k, O);
  }
  function he(k, O) {
    v.value[k] = Ce(v.value[k] || {}, O), x.numberFormats = v.value, Es(x, k, O);
  }
  Ts++, t && Ct && (zo(t.locale, (k) => {
    a && (i.value = k, x.locale = k, An(x, i.value, l.value));
  }), zo(t.fallbackLocale, (k) => {
    a && (l.value = k, x.fallbackLocale = k, An(x, i.value, l.value));
  }));
  const Q = {
    id: Ts,
    locale: U,
    fallbackLocale: Y,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(k) {
      a = k, k && t && (i.value = t.locale.value, l.value = t.fallbackLocale.value, An(x, i.value, l.value));
    },
    get availableLocales() {
      return Object.keys(w.value).sort();
    },
    messages: ne,
    get modifiers() {
      return L;
    },
    get pluralRules() {
      return P || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return d;
    },
    set missingWarn(k) {
      d = k, x.missingWarn = d;
    },
    get fallbackWarn() {
      return m;
    },
    set fallbackWarn(k) {
      m = k, x.fallbackWarn = m;
    },
    get fallbackRoot() {
      return A;
    },
    set fallbackRoot(k) {
      A = k;
    },
    get fallbackFormat() {
      return g;
    },
    set fallbackFormat(k) {
      g = k, x.fallbackFormat = g;
    },
    get warnHtmlMessage() {
      return C;
    },
    set warnHtmlMessage(k) {
      C = k, x.warnHtmlMessage = k;
    },
    get escapeParameter() {
      return p;
    },
    set escapeParameter(k) {
      p = k, x.escapeParameter = k;
    },
    t: J,
    getLocaleMessage: Rt,
    setLocaleMessage: Cn,
    mergeLocaleMessage: $o,
    getPostTranslationHandler: $,
    setPostTranslationHandler: I,
    getMissingHandler: F,
    setMissingHandler: S,
    [Cu]: Qe
  };
  return Q.datetimeFormats = Je, Q.numberFormats = W, Q.rt = de, Q.te = vt, Q.tm = xn, Q.d = we, Q.n = ke, Q.getDateTimeFormat = c, Q.setDateTimeFormat = u, Q.mergeDateTimeFormat = N, Q.getNumberFormat = D, Q.setNumberFormat = me, Q.mergeNumberFormat = he, Q[Ca] = n, Q[tr] = lt, Q[nr] = xe, Q[or] = at, process.env.NODE_ENV !== "production" && (Q[Nn] = (k) => {
    x.__v_emitter = k;
  }, Q[On] = () => {
    x.__v_emitter = void 0;
  }), Q;
}
function to(e, t) {
}
const Er = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Ou({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, r) => [
    ...o,
    // prettier-ignore
    ...r.type === In ? r.children : [r]
  ], []) : t.reduce((n, o) => {
    const r = e[o];
    return r && (n[o] = r()), n;
  }, ce());
}
function Ta() {
  return In;
}
Ce({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => Te(e) || !isNaN(e)
  }
}, Er);
function Pu(e) {
  return ye(e) && !M(e[0]);
}
function Na(e, t, n, o) {
  const { slots: r, attrs: s } = t;
  return () => {
    const a = () => {
      const w = { part: !0 };
      let h = ce();
      e.locale && (w.locale = e.locale), M(e.format) ? w.key = e.format : Z(e.format) && (M(e.format.key) && (w.key = e.format.key), h = Object.keys(e.format).reduce((m, A) => n.includes(A) ? Ce(ce(), m, { [A]: e.format[A] }) : m, ce()));
      const v = o(e.value, w, h);
      let d = [w.key];
      return ye(v) ? d = v.map((m, A) => {
        const g = r[m.type], T = g ? g({ [m.type]: m.value, index: A, parts: v }) : [m.value];
        return Pu(T) && (T[0].key = `${m.type}-${A}`), T;
      }) : M(v) && (d = [v]), d;
    }, i = Ce(ce(), s), l = M(e.tag) || Z(e.tag) ? e.tag : Ta();
    return Z(l) ? Zn(l, i, { default: a }) : Zn(l, i, a());
  };
}
Ce({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Er);
const Iu = /* @__PURE__ */ At("global-vue-i18n");
function pn(e = {}) {
  const t = _r();
  if (t == null)
    throw rn(Ae.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw rn(Ae.NOT_INSTALLED);
  const n = Su(t), o = Du(n), r = La(t), s = $u(e, r);
  if (s === "global")
    return Lu(o, e, r), o;
  if (s === "parent") {
    let l = Ps(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && pt(eo(wt.NOT_FOUND_PARENT_SCOPE)), l = o), l;
  }
  if (s === "isolated") {
    if (n.mode !== "composition")
      throw rn(Ae.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const l = n, w = Ce({}, e), h = Ps(n, t);
    w.__root = h || o;
    const v = Os(w);
    l.__composerExtend && (v[on] = l.__composerExtend(v));
    let d = null;
    if (process.env.NODE_ENV !== "production") {
      d = oa();
      const A = v;
      A[Nn] && A[Nn](d), d.on("*", to);
    }
    return El() && kl(() => {
      if (process.env.NODE_ENV !== "production") {
        d && d.off("*", to);
        const g = v;
        g[On] && g[On]();
      }
      const A = v[on];
      A && (A(), delete v[on]);
    }), v;
  }
  const a = n;
  let i = a.__getInstance(t);
  if (i == null) {
    const l = Ce({}, e);
    "__i18n" in r && (l.__i18n = r.__i18n), o && (l.__root = o), i = Os(l), a.__composerExtend && (i[on] = a.__composerExtend(i)), Ru(a, t, i), a.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && s === "local" && pt(eo(wt.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function Su(e) {
  const t = xl(e.isCE ? Iu : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw rn(e.isCE ? Ae.NOT_INSTALLED_WITH_PROVIDE : Ae.UNEXPECTED_ERROR);
  return t;
}
function $u(e, t) {
  return _o(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Du(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Ps(e, t, n = !1) {
  let o = null;
  const r = t.root;
  let s = Mu(t, n);
  for (; s != null; ) {
    const a = e;
    if (e.mode === "composition")
      o = a.__getInstance(s);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = a.__getInstance(s);
      i != null && (o = i.__composer, n && o && !o[Ca] && (o = null));
    }
    if (o != null || r === s)
      break;
    s = s.parent;
  }
  return o;
}
function Mu(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Ru(e, t, n) {
  let o = null;
  mr(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, o = oa();
      const r = n;
      r[Nn] && r[Nn](o), o.on("*", to);
    }
  }, t), Cl(() => {
    const r = n;
    process.env.NODE_ENV !== "production" && (o && o.off("*", to), r[On] && r[On](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const s = r[on];
    s && (s(), delete r[on]);
  }, t);
}
Ce({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Er);
ku();
nu(Dc);
ou(Jc);
ru(Zo);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = jt();
  e.__INTLIFY__ = !0, Mc(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function Bu(e) {
  const t = Ve([]), n = Ve(!1), o = Ve(null), r = async () => {
    n.value = !0, o.value = null;
    try {
      t.value = await e.getWeeklyReport();
    } catch (i) {
      o.value = i.message || "無法載入營收報表";
    } finally {
      n.value = !1;
    }
  }, s = Ye(() => t.value.reduce((i, l) => i + parseFloat(l.total_amount), 0)), a = Ye(() => t.value.reduce((i, l) => i + l.order_count, 0));
  return {
    reports: t,
    isLoading: n,
    reportError: o,
    fetchWeeklyData: r,
    weeklyTotalRevenue: s,
    weeklyTotalOrders: a
  };
}
const Fu = { class: "p-6 max-w-4xl mx-auto bg-gray-50" }, Uu = { class: "mb-8" }, Vu = { class: "text-3xl font-black text-gray-900" }, Hu = { class: "text-gray-700" }, ju = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" }, Yu = { class: "bg-blue-700 p-6 rounded-3xl text-white shadow-xl" }, Wu = { class: "text-blue-100 font-medium" }, qu = { class: "text-4xl font-black mt-2" }, zu = { class: "bg-white p-6 rounded-3xl border border-gray-100 shadow-sm" }, Ku = { class: "text-gray-700 font-medium" }, Gu = { class: "text-4xl font-black mt-2 text-gray-700" }, Xu = { class: "text-lg" }, Zu = {
  key: 0,
  class: "text-center py-20"
}, Ju = { class: "mt-4 text-blue-700 font-bold" }, Qu = {
  key: 1,
  class: "bg-red-50 text-red-700 p-4 rounded-2xl border border-red-100"
}, ed = {
  key: 2,
  class: "bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden"
}, td = { class: "w-full text-left" }, nd = { class: "bg-gray-50 border-b border-gray-100" }, od = { class: "px-6 py-4 text-gray-700 font-bold" }, rd = { class: "px-6 py-4 text-gray-700 font-bold" }, sd = { class: "px-6 py-4 text-gray-700 font-bold text-right" }, ad = { class: "divide-y divide-gray-50" }, id = { class: "px-6 py-4 font-medium text-gray-700" }, ld = { class: "px-6 py-4 text-gray-700" }, cd = { class: "px-6 py-4 text-right font-bold text-blue-700" }, xb = /* @__PURE__ */ $t({
  __name: "RevenueReportPage",
  props: {
    revenueApi: {}
  },
  setup(e) {
    const { t, locale: n } = pn(), o = e, {
      reports: r,
      isLoading: s,
      reportError: a,
      fetchWeeklyData: i,
      weeklyTotalRevenue: l,
      weeklyTotalOrders: w
    } = Bu(o.revenueApi);
    return mr(() => {
      i();
    }), (h, v) => (X(), te("div", Fu, [
      E("header", Uu, [
        E("h1", Vu, j(K(t)("report.title")), 1),
        E("p", Hu, j(K(t)("report.subtitle")), 1)
      ]),
      E("div", ju, [
        E("div", Yu, [
          E("p", Wu, j(K(t)("report.weeklyRevenue")), 1),
          E("h2", qu, "$ " + j(K(l).toLocaleString()), 1)
        ]),
        E("div", zu, [
          E("p", Ku, j(K(t)("report.weeklyOrders")), 1),
          E("h2", Gu, [
            Lt(j(K(w)) + " ", 1),
            E("span", Xu, j(K(t)("report.orderUnit")), 1)
          ])
        ])
      ]),
      K(s) ? (X(), te("div", Zu, [
        v[0] || (v[0] = E("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-4 border-blue-700 border-t-transparent" }, null, -1)),
        E("p", Ju, j(K(t)("common.calculating")), 1)
      ])) : K(a) ? (X(), te("div", Qu, j(K(a)), 1)) : (X(), te("div", ed, [
        E("table", td, [
          E("thead", nd, [
            E("tr", null, [
              E("th", od, j(K(t)("report.dateCol")), 1),
              E("th", rd, j(K(t)("report.ordersCol")), 1),
              E("th", sd, j(K(t)("report.revenueCol")), 1)
            ])
          ]),
          E("tbody", ad, [
            (X(!0), te(In, null, fr(K(r), (d) => (X(), te("tr", {
              key: d.report_date,
              class: "hover:bg-gray-50 transition"
            }, [
              E("td", id, j(new Date(d.report_date).toLocaleDateString(K(n))), 1),
              E("td", ld, j(d.order_count) + " " + j(K(t)("report.orderUnit")), 1),
              E("td", cd, " $ " + j(parseFloat(d.total_amount).toLocaleString()), 1)
            ]))), 128))
          ])
        ])
      ]))
    ]));
  }
});
function ud(e) {
  const t = Ve(null), n = Ve(null), o = Ve(!1), r = Ve(null);
  return {
    paymentInfo: t,
    isLoading: o,
    paymentError: r,
    fetchPaymentInfo: async () => {
      o.value = !0, r.value = null;
      try {
        t.value = await e.getMerchantPaymentInfo();
      } catch (h) {
        r.value = h.message || "無法載入金流資訊";
      } finally {
        o.value = !1;
      }
    },
    fetchPaymentInfoPaginated: async (h) => {
      o.value = !0, r.value = null;
      try {
        const v = await e.getMerchantPaymentInfoPaginated(h);
        let d = {
          data: [],
          total: 0,
          page: (h == null ? void 0 : h.page) || 1,
          limit: (h == null ? void 0 : h.limit) || 10
        };
        if (Array.isArray(v))
          d = {
            data: v,
            total: Number(v.total ?? v.length),
            page: (h == null ? void 0 : h.page) || 1,
            limit: (h == null ? void 0 : h.limit) || 10
          };
        else if (v && typeof v == "object" && "data" in v) {
          const m = v;
          d = {
            data: Array.isArray(m.data) ? m.data : [],
            total: Number(m.total ?? 0),
            page: Number(m.page || (h == null ? void 0 : h.page) || 1),
            limit: Number(m.limit || (h == null ? void 0 : h.limit) || 10)
          };
        }
        return t.value = d.data, n.value = d, d;
      } catch (v) {
        throw r.value = v.message || "無法載入金流資訊", v;
      } finally {
        o.value = !1;
      }
    },
    createInvoice: async (h) => await e.createInvoice(h),
    queryCompanyName: async (h) => await e.queryCompanyName(h),
    voidPayment: async (h) => await e.voidPayment(h)
  };
}
var kr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Oa = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(kr, function() {
    var n = 1e3, o = 6e4, r = 36e5, s = "millisecond", a = "second", i = "minute", l = "hour", w = "day", h = "week", v = "month", d = "quarter", m = "year", A = "date", g = "Invalid Date", T = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, f = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, b = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(W) {
      var $ = ["th", "st", "nd", "rd"], I = W % 100;
      return "[" + W + ($[(I - 20) % 10] || $[I] || $[0]) + "]";
    } }, C = function(W, $, I) {
      var F = String(W);
      return !F || F.length >= $ ? W : "" + Array($ + 1 - F.length).join(I) + W;
    }, p = { s: C, z: function(W) {
      var $ = -W.utcOffset(), I = Math.abs($), F = Math.floor(I / 60), S = I % 60;
      return ($ <= 0 ? "+" : "-") + C(F, 2, "0") + ":" + C(S, 2, "0");
    }, m: function W($, I) {
      if ($.date() < I.date()) return -W(I, $);
      var F = 12 * (I.year() - $.year()) + (I.month() - $.month()), S = $.clone().add(F, v), G = I - S < 0, V = $.clone().add(F + (G ? -1 : 1), v);
      return +(-(F + (I - S) / (G ? S - V : V - S)) || 0);
    }, a: function(W) {
      return W < 0 ? Math.ceil(W) || 0 : Math.floor(W);
    }, p: function(W) {
      return { M: v, y: m, w: h, d: w, D: A, h: l, m: i, s: a, ms: s, Q: d }[W] || String(W || "").toLowerCase().replace(/s$/, "");
    }, u: function(W) {
      return W === void 0;
    } }, L = "en", P = {};
    P[L] = b;
    var x = "$isDayjsObject", z = function(W) {
      return W instanceof ne || !(!W || !W[x]);
    }, H = function W($, I, F) {
      var S;
      if (!$) return L;
      if (typeof $ == "string") {
        var G = $.toLowerCase();
        P[G] && (S = G), I && (P[G] = I, S = G);
        var V = $.split("-");
        if (!S && V.length > 1) return W(V[0]);
      } else {
        var J = $.name;
        P[J] = $, S = J;
      }
      return !F && S && (L = S), S || !F && L;
    }, U = function(W, $) {
      if (z(W)) return W.clone();
      var I = typeof $ == "object" ? $ : {};
      return I.date = W, I.args = arguments, new ne(I);
    }, Y = p;
    Y.l = H, Y.i = z, Y.w = function(W, $) {
      return U(W, { locale: $.$L, utc: $.$u, x: $.$x, $offset: $.$offset });
    };
    var ne = function() {
      function W(I) {
        this.$L = H(I.locale, null, !0), this.parse(I), this.$x = this.$x || I.x || {}, this[x] = !0;
      }
      var $ = W.prototype;
      return $.parse = function(I) {
        this.$d = function(F) {
          var S = F.date, G = F.utc;
          if (S === null) return /* @__PURE__ */ new Date(NaN);
          if (Y.u(S)) return /* @__PURE__ */ new Date();
          if (S instanceof Date) return new Date(S);
          if (typeof S == "string" && !/Z$/i.test(S)) {
            var V = S.match(T);
            if (V) {
              var J = V[2] - 1 || 0, de = (V[7] || "0").substring(0, 3);
              return G ? new Date(Date.UTC(V[1], J, V[3] || 1, V[4] || 0, V[5] || 0, V[6] || 0, de)) : new Date(V[1], J, V[3] || 1, V[4] || 0, V[5] || 0, V[6] || 0, de);
            }
          }
          return new Date(S);
        }(I), this.init();
      }, $.init = function() {
        var I = this.$d;
        this.$y = I.getFullYear(), this.$M = I.getMonth(), this.$D = I.getDate(), this.$W = I.getDay(), this.$H = I.getHours(), this.$m = I.getMinutes(), this.$s = I.getSeconds(), this.$ms = I.getMilliseconds();
      }, $.$utils = function() {
        return Y;
      }, $.isValid = function() {
        return this.$d.toString() !== g;
      }, $.isSame = function(I, F) {
        var S = U(I);
        return this.startOf(F) <= S && S <= this.endOf(F);
      }, $.isAfter = function(I, F) {
        return U(I) < this.startOf(F);
      }, $.isBefore = function(I, F) {
        return this.endOf(F) < U(I);
      }, $.$g = function(I, F, S) {
        return Y.u(I) ? this[F] : this.set(S, I);
      }, $.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, $.valueOf = function() {
        return this.$d.getTime();
      }, $.startOf = function(I, F) {
        var S = this, G = !!Y.u(F) || F, V = Y.p(I), J = function(at, xe) {
          var Qe = Y.w(S.$u ? Date.UTC(S.$y, xe, at) : new Date(S.$y, xe, at), S);
          return G ? Qe : Qe.endOf(w);
        }, de = function(at, xe) {
          return Y.w(S.toDate()[at].apply(S.toDate("s"), (G ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(xe)), S);
        }, we = this.$W, ke = this.$M, Pe = this.$D, bt = "set" + (this.$u ? "UTC" : "");
        switch (V) {
          case m:
            return G ? J(1, 0) : J(31, 11);
          case v:
            return G ? J(1, ke) : J(0, ke + 1);
          case h:
            var st = this.$locale().weekStart || 0, lt = (we < st ? we + 7 : we) - st;
            return J(G ? Pe - lt : Pe + (6 - lt), ke);
          case w:
          case A:
            return de(bt + "Hours", 0);
          case l:
            return de(bt + "Minutes", 1);
          case i:
            return de(bt + "Seconds", 2);
          case a:
            return de(bt + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, $.endOf = function(I) {
        return this.startOf(I, !1);
      }, $.$set = function(I, F) {
        var S, G = Y.p(I), V = "set" + (this.$u ? "UTC" : ""), J = (S = {}, S[w] = V + "Date", S[A] = V + "Date", S[v] = V + "Month", S[m] = V + "FullYear", S[l] = V + "Hours", S[i] = V + "Minutes", S[a] = V + "Seconds", S[s] = V + "Milliseconds", S)[G], de = G === w ? this.$D + (F - this.$W) : F;
        if (G === v || G === m) {
          var we = this.clone().set(A, 1);
          we.$d[J](de), we.init(), this.$d = we.set(A, Math.min(this.$D, we.daysInMonth())).$d;
        } else J && this.$d[J](de);
        return this.init(), this;
      }, $.set = function(I, F) {
        return this.clone().$set(I, F);
      }, $.get = function(I) {
        return this[Y.p(I)]();
      }, $.add = function(I, F) {
        var S, G = this;
        I = Number(I);
        var V = Y.p(F), J = function(ke) {
          var Pe = U(G);
          return Y.w(Pe.date(Pe.date() + Math.round(ke * I)), G);
        };
        if (V === v) return this.set(v, this.$M + I);
        if (V === m) return this.set(m, this.$y + I);
        if (V === w) return J(1);
        if (V === h) return J(7);
        var de = (S = {}, S[i] = o, S[l] = r, S[a] = n, S)[V] || 1, we = this.$d.getTime() + I * de;
        return Y.w(we, this);
      }, $.subtract = function(I, F) {
        return this.add(-1 * I, F);
      }, $.format = function(I) {
        var F = this, S = this.$locale();
        if (!this.isValid()) return S.invalidDate || g;
        var G = I || "YYYY-MM-DDTHH:mm:ssZ", V = Y.z(this), J = this.$H, de = this.$m, we = this.$M, ke = S.weekdays, Pe = S.months, bt = S.meridiem, st = function(xe, Qe, vt, ct) {
          return xe && (xe[Qe] || xe(F, G)) || vt[Qe].slice(0, ct);
        }, lt = function(xe) {
          return Y.s(J % 12 || 12, xe, "0");
        }, at = bt || function(xe, Qe, vt) {
          var ct = xe < 12 ? "AM" : "PM";
          return vt ? ct.toLowerCase() : ct;
        };
        return G.replace(f, function(xe, Qe) {
          return Qe || function(vt) {
            switch (vt) {
              case "YY":
                return String(F.$y).slice(-2);
              case "YYYY":
                return Y.s(F.$y, 4, "0");
              case "M":
                return we + 1;
              case "MM":
                return Y.s(we + 1, 2, "0");
              case "MMM":
                return st(S.monthsShort, we, Pe, 3);
              case "MMMM":
                return st(Pe, we);
              case "D":
                return F.$D;
              case "DD":
                return Y.s(F.$D, 2, "0");
              case "d":
                return String(F.$W);
              case "dd":
                return st(S.weekdaysMin, F.$W, ke, 2);
              case "ddd":
                return st(S.weekdaysShort, F.$W, ke, 3);
              case "dddd":
                return ke[F.$W];
              case "H":
                return String(J);
              case "HH":
                return Y.s(J, 2, "0");
              case "h":
                return lt(1);
              case "hh":
                return lt(2);
              case "a":
                return at(J, de, !0);
              case "A":
                return at(J, de, !1);
              case "m":
                return String(de);
              case "mm":
                return Y.s(de, 2, "0");
              case "s":
                return String(F.$s);
              case "ss":
                return Y.s(F.$s, 2, "0");
              case "SSS":
                return Y.s(F.$ms, 3, "0");
              case "Z":
                return V;
            }
            return null;
          }(xe) || V.replace(":", "");
        });
      }, $.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, $.diff = function(I, F, S) {
        var G, V = this, J = Y.p(F), de = U(I), we = (de.utcOffset() - this.utcOffset()) * o, ke = this - de, Pe = function() {
          return Y.m(V, de);
        };
        switch (J) {
          case m:
            G = Pe() / 12;
            break;
          case v:
            G = Pe();
            break;
          case d:
            G = Pe() / 3;
            break;
          case h:
            G = (ke - we) / 6048e5;
            break;
          case w:
            G = (ke - we) / 864e5;
            break;
          case l:
            G = ke / r;
            break;
          case i:
            G = ke / o;
            break;
          case a:
            G = ke / n;
            break;
          default:
            G = ke;
        }
        return S ? G : Y.a(G);
      }, $.daysInMonth = function() {
        return this.endOf(v).$D;
      }, $.$locale = function() {
        return P[this.$L];
      }, $.locale = function(I, F) {
        if (!I) return this.$L;
        var S = this.clone(), G = H(I, F, !0);
        return G && (S.$L = G), S;
      }, $.clone = function() {
        return Y.w(this.$d, this);
      }, $.toDate = function() {
        return new Date(this.valueOf());
      }, $.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, $.toISOString = function() {
        return this.$d.toISOString();
      }, $.toString = function() {
        return this.$d.toUTCString();
      }, W;
    }(), Je = ne.prototype;
    return U.prototype = Je, [["$ms", s], ["$s", a], ["$m", i], ["$H", l], ["$W", w], ["$M", v], ["$y", m], ["$D", A]].forEach(function(W) {
      Je[W[1]] = function($) {
        return this.$g($, W[0], W[1]);
      };
    }), U.extend = function(W, $) {
      return W.$i || (W($, ne, U), W.$i = !0), U;
    }, U.locale = H, U.isDayjs = z, U.unix = function(W) {
      return U(1e3 * W);
    }, U.en = P[L], U.Ls = P, U.p = {}, U;
  });
})(Oa);
var dd = Oa.exports;
const Pa = /* @__PURE__ */ xr(dd);
var Ia = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(kr, function() {
    var n = "minute", o = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
    return function(s, a, i) {
      var l = a.prototype;
      i.utc = function(g) {
        var T = { date: g, utc: !0, args: arguments };
        return new a(T);
      }, l.utc = function(g) {
        var T = i(this.toDate(), { locale: this.$L, utc: !0 });
        return g ? T.add(this.utcOffset(), n) : T;
      }, l.local = function() {
        return i(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var w = l.parse;
      l.parse = function(g) {
        g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), w.call(this, g);
      };
      var h = l.init;
      l.init = function() {
        if (this.$u) {
          var g = this.$d;
          this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
        } else h.call(this);
      };
      var v = l.utcOffset;
      l.utcOffset = function(g, T) {
        var f = this.$utils().u;
        if (f(g)) return this.$u ? 0 : f(this.$offset) ? v.call(this) : this.$offset;
        if (typeof g == "string" && (g = function(L) {
          L === void 0 && (L = "");
          var P = L.match(o);
          if (!P) return null;
          var x = ("" + P[0]).match(r) || ["-", 0, 0], z = x[0], H = 60 * +x[1] + +x[2];
          return H === 0 ? 0 : z === "+" ? H : -H;
        }(g), g === null)) return this;
        var b = Math.abs(g) <= 16 ? 60 * g : g;
        if (b === 0) return this.utc(T);
        var C = this.clone();
        if (T) return C.$offset = b, C.$u = !1, C;
        var p = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (C = this.local().add(b + p, n)).$offset = b, C.$x.$localOffset = p, C;
      };
      var d = l.format;
      l.format = function(g) {
        var T = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return d.call(this, T);
      }, l.valueOf = function() {
        var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * g;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var m = l.toDate;
      l.toDate = function(g) {
        return g === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : m.call(this);
      };
      var A = l.diff;
      l.diff = function(g, T, f) {
        if (g && this.$u === g.$u) return A.call(this, g, T, f);
        var b = this.local(), C = i(g).local();
        return A.call(b, C, T, f);
      };
    };
  });
})(Ia);
var md = Ia.exports;
const fd = /* @__PURE__ */ xr(md);
var Sa = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(kr, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, o = {};
    return function(r, s, a) {
      var i, l = function(d, m, A) {
        A === void 0 && (A = {});
        var g = new Date(d), T = function(f, b) {
          b === void 0 && (b = {});
          var C = b.timeZoneName || "short", p = f + "|" + C, L = o[p];
          return L || (L = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: f, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: C }), o[p] = L), L;
        }(m, A);
        return T.formatToParts(g);
      }, w = function(d, m) {
        for (var A = l(d, m), g = [], T = 0; T < A.length; T += 1) {
          var f = A[T], b = f.type, C = f.value, p = n[b];
          p >= 0 && (g[p] = parseInt(C, 10));
        }
        var L = g[3], P = L === 24 ? 0 : L, x = g[0] + "-" + g[1] + "-" + g[2] + " " + P + ":" + g[4] + ":" + g[5] + ":000", z = +d;
        return (a.utc(x).valueOf() - (z -= z % 1e3)) / 6e4;
      }, h = s.prototype;
      h.tz = function(d, m) {
        d === void 0 && (d = i);
        var A, g = this.utcOffset(), T = this.toDate(), f = T.toLocaleString("en-US", { timeZone: d }), b = Math.round((T - new Date(f)) / 1e3 / 60), C = 15 * -Math.round(T.getTimezoneOffset() / 15) - b;
        if (!Number(C)) A = this.utcOffset(0, m);
        else if (A = a(f, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(C, !0), m) {
          var p = A.utcOffset();
          A = A.add(g - p, "minute");
        }
        return A.$x.$timezone = d, A;
      }, h.offsetName = function(d) {
        var m = this.$x.$timezone || a.tz.guess(), A = l(this.valueOf(), m, { timeZoneName: d }).find(function(g) {
          return g.type.toLowerCase() === "timezonename";
        });
        return A && A.value;
      };
      var v = h.startOf;
      h.startOf = function(d, m) {
        if (!this.$x || !this.$x.$timezone) return v.call(this, d, m);
        var A = a(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return v.call(A, d, m).tz(this.$x.$timezone, !0);
      }, a.tz = function(d, m, A) {
        var g = A && m, T = A || m || i, f = w(+a(), T);
        if (typeof d != "string") return a(d).tz(T);
        var b = function(P, x, z) {
          var H = P - 60 * x * 1e3, U = w(H, z);
          if (x === U) return [H, x];
          var Y = w(H -= 60 * (U - x) * 1e3, z);
          return U === Y ? [H, U] : [P - 60 * Math.min(U, Y) * 1e3, Math.max(U, Y)];
        }(a.utc(d, g).valueOf(), f, T), C = b[0], p = b[1], L = a(C).utcOffset(p);
        return L.$x.$timezone = T, L;
      }, a.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, a.tz.setDefault = function(d) {
        i = d;
      };
    };
  });
})(Sa);
var wd = Sa.exports;
const pd = /* @__PURE__ */ xr(wd);
Pa.extend(fd);
Pa.extend(pd);
/*!
* sweetalert2 v11.26.17
* Released under the MIT License.
*/
function $a(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function hd(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Is(e, t) {
  return e.get($a(e, t));
}
function gd(e, t, n) {
  hd(e, t), t.set(e, n);
}
function bd(e, t, n) {
  return e.set($a(e, t), n), n;
}
const vd = 100, R = {}, yd = () => {
  R.previousActiveElement instanceof HTMLElement ? (R.previousActiveElement.focus(), R.previousActiveElement = null) : document.body && document.body.focus();
}, _d = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  R.restoreFocusTimeout = setTimeout(() => {
    yd(), t();
  }, vd), window.scrollTo(n, o);
}), Da = "swal2-", Ed = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], y = Ed.reduce(
  (e, t) => (e[t] = Da + t, e),
  /** @type {SwalClasses} */
  {}
), kd = ["success", "warning", "info", "question", "error"], no = kd.reduce(
  (e, t) => (e[t] = Da + t, e),
  /** @type {SwalIcons} */
  {}
), Ma = "SweetAlert2:", Cr = (e) => e.charAt(0).toUpperCase() + e.slice(1), Me = (e) => {
  console.warn(`${Ma} ${typeof e == "object" ? e.join(" ") : e}`);
}, Xt = (e) => {
  console.error(`${Ma} ${e}`);
}, Ss = [], xd = (e) => {
  Ss.includes(e) || (Ss.push(e), Me(e));
}, Ra = (e, t = null) => {
  xd(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, xo = (e) => typeof e == "function" ? e() : e, Ar = (e) => e && typeof e.toPromise == "function", Sn = (e) => Ar(e) ? e.toPromise() : Promise.resolve(e), Lr = (e) => e && Promise.resolve(e) === e, Be = () => document.body.querySelector(`.${y.container}`), $n = (e) => {
  const t = Be();
  return t ? t.querySelector(e) : null;
}, Ke = (e) => $n(`.${e}`), se = () => Ke(y.popup), hn = () => Ke(y.icon), Cd = () => Ke(y["icon-content"]), Ba = () => Ke(y.title), Tr = () => Ke(y["html-container"]), Fa = () => Ke(y.image), Nr = () => Ke(y["progress-steps"]), Co = () => Ke(y["validation-message"]), ht = () => (
  /** @type {HTMLButtonElement} */
  $n(`.${y.actions} .${y.confirm}`)
), gn = () => (
  /** @type {HTMLButtonElement} */
  $n(`.${y.actions} .${y.cancel}`)
), Zt = () => (
  /** @type {HTMLButtonElement} */
  $n(`.${y.actions} .${y.deny}`)
), Ad = () => Ke(y["input-label"]), bn = () => $n(`.${y.loader}`), Dn = () => Ke(y.actions), Ua = () => Ke(y.footer), Ao = () => Ke(y["timer-progress-bar"]), Or = () => Ke(y.close), Ld = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, Pr = () => {
  const e = se();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((s, a) => {
    const i = parseInt(s.getAttribute("tabindex") || "0"), l = parseInt(a.getAttribute("tabindex") || "0");
    return i > l ? 1 : i < l ? -1 : 0;
  }), o = e.querySelectorAll(Ld), r = Array.from(o).filter((s) => s.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(r))].filter((s) => He(s));
}, Ir = () => kt(document.body, y.shown) && !kt(document.body, y["toast-shown"]) && !kt(document.body, y["no-backdrop"]), Lo = () => {
  const e = se();
  return e ? kt(e, y.toast) : !1;
}, Td = () => {
  const e = se();
  return e ? e.hasAttribute("data-loading") : !1;
}, Ge = (e, t) => {
  if (e.textContent = "", t) {
    const n = new DOMParser().parseFromString(t, "text/html"), o = n.querySelector("head");
    o && Array.from(o.childNodes).forEach((s) => {
      e.appendChild(s);
    });
    const r = n.querySelector("body");
    r && Array.from(r.childNodes).forEach((s) => {
      s instanceof HTMLVideoElement || s instanceof HTMLAudioElement ? e.appendChild(s.cloneNode(!0)) : e.appendChild(s);
    });
  }
}, kt = (e, t) => {
  if (!t)
    return !1;
  const n = t.split(/\s+/);
  for (let o = 0; o < n.length; o++)
    if (!e.classList.contains(n[o]))
      return !1;
  return !0;
}, Nd = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(y).includes(n) && !Object.values(no).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, qe = (e, t, n) => {
  if (Nd(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Me(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    oe(e, o);
  }
}, To = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${y.popup} > .${y[t]}`);
    case "checkbox":
      return e.querySelector(`.${y.popup} > .${y.checkbox} input`);
    case "radio":
      return e.querySelector(`.${y.popup} > .${y.radio} input:checked`) || e.querySelector(`.${y.popup} > .${y.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${y.popup} > .${y.range} input`);
    default:
      return e.querySelector(`.${y.popup} > .${y.input}`);
  }
}, Va = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Ha = (e, t, n) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((o) => {
    Array.isArray(e) ? e.forEach((r) => {
      n ? r.classList.add(o) : r.classList.remove(o);
    }) : n ? e.classList.add(o) : e.classList.remove(o);
  }));
}, oe = (e, t) => {
  Ha(e, t, !0);
}, ot = (e, t) => {
  Ha(e, t, !1);
}, Tt = (e, t) => {
  const n = Array.from(e.children);
  for (let o = 0; o < n.length; o++) {
    const r = n[o];
    if (r instanceof HTMLElement && kt(r, t))
      return r;
  }
}, Wt = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || parseInt(`${n}`) === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, Ne = (e, t = "flex") => {
  e && (e.style.display = t);
}, $e = (e) => {
  e && (e.style.display = "none");
}, Sr = (e, t = "block") => {
  e && new MutationObserver(() => {
    Mn(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, $s = (e, t, n, o) => {
  const r = e.querySelector(t);
  r && r.style.setProperty(n, o);
}, Mn = (e, t, n = "flex") => {
  t ? Ne(e, n) : $e(e);
}, He = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Od = () => !He(ht()) && !He(Zt()) && !He(gn()), rr = (e) => e.scrollHeight > e.clientHeight, Pd = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (rr(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, ja = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, $r = (e, t = !1) => {
  const n = Ao();
  n && He(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, Id = () => {
  const e = Ao();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, Sd = () => typeof window > "u" || typeof document > "u", $d = `
 <div aria-labelledby="${y.title}" aria-describedby="${y["html-container"]}" class="${y.popup}" tabindex="-1">
   <button type="button" class="${y.close}"></button>
   <ul class="${y["progress-steps"]}"></ul>
   <div class="${y.icon}"></div>
   <img class="${y.image}" />
   <h2 class="${y.title}" id="${y.title}"></h2>
   <div class="${y["html-container"]}" id="${y["html-container"]}"></div>
   <input class="${y.input}" id="${y.input}" />
   <input type="file" class="${y.file}" />
   <div class="${y.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${y.select}" id="${y.select}"></select>
   <div class="${y.radio}"></div>
   <label class="${y.checkbox}">
     <input type="checkbox" id="${y.checkbox}" />
     <span class="${y.label}"></span>
   </label>
   <textarea class="${y.textarea}" id="${y.textarea}"></textarea>
   <div class="${y["validation-message"]}" id="${y["validation-message"]}"></div>
   <div class="${y.actions}">
     <div class="${y.loader}"></div>
     <button type="button" class="${y.confirm}"></button>
     <button type="button" class="${y.deny}"></button>
     <button type="button" class="${y.cancel}"></button>
   </div>
   <div class="${y.footer}"></div>
   <div class="${y["timer-progress-bar-container"]}">
     <div class="${y["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), Dd = () => {
  const e = Be();
  return e ? (e.remove(), ot([document.documentElement, document.body], [
    y["no-backdrop"],
    y["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    y["has-column"]
  ]), !0) : !1;
}, Vt = () => {
  R.currentInstance && R.currentInstance.resetValidationMessage();
}, Md = () => {
  const e = se();
  if (!e)
    return;
  const t = Tt(e, y.input), n = Tt(e, y.file), o = e.querySelector(`.${y.range} input`), r = e.querySelector(`.${y.range} output`), s = Tt(e, y.select), a = e.querySelector(`.${y.checkbox} input`), i = Tt(e, y.textarea);
  t && (t.oninput = Vt), n && (n.onchange = Vt), s && (s.onchange = Vt), a && (a.onchange = Vt), i && (i.oninput = Vt), o && r && (o.oninput = () => {
    Vt(), r.value = o.value;
  }, o.onchange = () => {
    Vt(), r.value = o.value;
  });
}, Rd = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, Bd = (e) => {
  const t = se();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, Fd = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (oe(Be(), y.rtl), R.isRTL = !0);
}, Ud = (e) => {
  const t = Dd();
  if (Sd()) {
    Xt("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = y.container, t && oe(n, y["no-transition"]), Ge(n, $d), n.dataset.swal2Theme = e.theme;
  const o = Rd(e.target || "body");
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), Bd(e), Fd(o), Md();
}, Dr = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? Vd(e, t) : e && Ge(t, e);
}, Vd = (e, t) => {
  "jquery" in e ? Hd(t, e) : Ge(t, e.toString());
}, Hd = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, jd = (e, t) => {
  const n = Dn(), o = bn();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? $e(n) : Ne(n), qe(n, t, "actions"), Yd(n, o, t), Ge(o, t.loaderHtml || ""), qe(o, t, "loader"));
};
function Yd(e, t, n) {
  const o = ht(), r = Zt(), s = gn();
  !o || !r || !s || (jo(o, "confirm", n), jo(r, "deny", n), jo(s, "cancel", n), Wd(o, r, s, n), n.reverseButtons && (n.toast ? (e.insertBefore(s, o), e.insertBefore(r, o)) : (e.insertBefore(s, t), e.insertBefore(r, t), e.insertBefore(o, t))));
}
function Wd(e, t, n, o) {
  if (!o.buttonsStyling) {
    ot([e, t, n], y.styled);
    return;
  }
  oe([e, t, n], y.styled), o.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", o.confirmButtonColor), o.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", o.denyButtonColor), o.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", o.cancelButtonColor), Ho(e), Ho(t), Ho(n);
}
function Ho(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function jo(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    Cr(t)
  );
  Mn(e, n[`show${o}Button`], "inline-block"), Ge(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = y[t], qe(e, n, `${t}Button`);
}
const qd = (e, t) => {
  const n = Or();
  n && (Ge(n, t.closeButtonHtml || ""), qe(n, t, "closeButton"), Mn(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, zd = (e, t) => {
  const n = Be();
  n && (Kd(n, t.backdrop), Gd(n, t.position), Xd(n, t.grow), qe(n, t, "container"));
};
function Kd(e, t) {
  typeof t == "string" ? e.style.background = t : t || oe([document.documentElement, document.body], y["no-backdrop"]);
}
function Gd(e, t) {
  t && (t in y ? oe(e, y[t]) : (Me('The "position" parameter is not valid, defaulting to "center"'), oe(e, y.center)));
}
function Xd(e, t) {
  t && oe(e, y[`grow-${t}`]);
}
var ue = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const Zd = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], Jd = (e, t) => {
  const n = se();
  if (!n)
    return;
  const o = ue.innerParams.get(e), r = !o || t.input !== o.input;
  Zd.forEach((s) => {
    const a = Tt(n, y[s]);
    a && (tm(s, t.inputAttributes), a.className = y[s], r && $e(a));
  }), t.input && (r && Qd(t), nm(t));
}, Qd = (e) => {
  if (!e.input)
    return;
  if (!ge[e.input]) {
    Xt(`Unexpected type of input! Expected ${Object.keys(ge).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Ya(e.input);
  if (!t)
    return;
  const n = ge[e.input](t, e);
  Ne(t), e.inputAutoFocus && setTimeout(() => {
    Va(n);
  });
}, em = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const n = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(n) || e.removeAttribute(n);
  }
}, tm = (e, t) => {
  const n = se();
  if (!n)
    return;
  const o = To(n, e);
  if (o) {
    em(o);
    for (const r in t)
      o.setAttribute(r, t[r]);
  }
}, nm = (e) => {
  if (!e.input)
    return;
  const t = Ya(e.input);
  t && qe(t, e, "input");
}, Mr = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, Rn = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), r = y["input-label"];
    o.setAttribute("for", e.id), o.className = r, typeof n.customClass == "object" && oe(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, Ya = (e) => {
  const t = se();
  if (t)
    return Tt(t, y[
      /** @type {SwalClass} */
      e
    ] || y.input);
}, oo = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : Lr(t) || Me(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, ge = {};
ge.text = ge.email = ge.password = ge.number = ge.tel = ge.url = ge.search = ge.date = ge["datetime-local"] = ge.time = ge.week = ge.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return oo(n, t.inputValue), Rn(n, n, t), Mr(n, t), n.type = /** @type {string} */
  t.input, n;
};
ge.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return Rn(n, n, t), Mr(n, t), n;
};
ge.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), o = n.querySelector("input"), r = n.querySelector("output");
  return o && (oo(o, t.inputValue), o.type = /** @type {string} */
  t.input, Rn(
    o,
    /** @type {Input} */
    e,
    t
  )), r && oo(r, t.inputValue), /** @type {Input} */
  e;
};
ge.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    Ge(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, n.appendChild(o);
  }
  return Rn(n, n, t), n;
};
ge.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
ge.checkbox = (e, t) => {
  const n = se();
  if (!n)
    throw new Error("Popup not found");
  const o = To(n, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const r = (
    /** @type {HTMLElement} */
    e.querySelector("span")
  );
  if (r) {
    const s = t.inputPlaceholder || t.inputLabel;
    s && Ge(r, s);
  }
  return o;
};
ge.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  oo(n, t.inputValue), Mr(n, t), Rn(n, n, t);
  const o = (r) => parseInt(window.getComputedStyle(r).marginLeft) + parseInt(window.getComputedStyle(r).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const r = se();
      if (!r)
        return;
      const s = parseInt(window.getComputedStyle(r).width), a = () => {
        if (!document.body.contains(n))
          return;
        const i = n.offsetWidth + o(n), l = se();
        l && (i > s ? l.style.width = `${i}px` : Wt(l, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const om = (e, t) => {
  const n = Tr();
  n && (Sr(n), qe(n, t, "htmlContainer"), t.html ? (Dr(t.html, n), Ne(n, "block")) : t.text ? (n.textContent = t.text, Ne(n, "block")) : $e(n), Jd(e, t));
}, rm = (e, t) => {
  const n = Ua();
  n && (Sr(n), Mn(n, !!t.footer, "block"), t.footer && Dr(t.footer, n), qe(n, t, "footer"));
}, sm = (e, t) => {
  const n = ue.innerParams.get(e), o = hn();
  if (o) {
    if (n && t.icon === n.icon) {
      Ms(o, t), Ds(o, t);
      return;
    }
    if (!t.icon && !t.iconHtml) {
      $e(o);
      return;
    }
    if (t.icon && Object.keys(no).indexOf(t.icon) === -1) {
      Xt(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), $e(o);
      return;
    }
    Ne(o), Ms(o, t), Ds(o, t), oe(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Wa);
  }
}, Ds = (e, t) => {
  for (const [n, o] of Object.entries(no))
    t.icon !== n && ot(e, o);
  oe(e, t.icon && no[t.icon]), lm(e, t), Wa(), qe(e, t, "icon");
}, Wa = () => {
  const e = se();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let o = 0; o < n.length; o++)
    n[o].style.backgroundColor = t;
}, am = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, im = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, Ms = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = Rs(t.iconHtml) : t.icon === "success" ? (o = am(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = im : t.icon && (o = Rs({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && Ge(e, o);
}, lm = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      $s(e, n, "background-color", t.iconColor);
    $s(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, Rs = (e) => `<div class="${y["icon-content"]}">${e}</div>`, cm = (e, t) => {
  const n = Fa();
  if (n) {
    if (!t.imageUrl) {
      $e(n);
      return;
    }
    Ne(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), Wt(n, "width", t.imageWidth), Wt(n, "height", t.imageHeight), n.className = y.image, qe(n, t, "image");
  }
};
let Rr = !1, qa = 0, za = 0, Ka = 0, Ga = 0;
const um = (e) => {
  e.addEventListener("mousedown", ro), document.body.addEventListener("mousemove", so), e.addEventListener("mouseup", ao), e.addEventListener("touchstart", ro), document.body.addEventListener("touchmove", so), e.addEventListener("touchend", ao);
}, dm = (e) => {
  e.removeEventListener("mousedown", ro), document.body.removeEventListener("mousemove", so), e.removeEventListener("mouseup", ao), e.removeEventListener("touchstart", ro), document.body.removeEventListener("touchmove", so), e.removeEventListener("touchend", ao);
}, ro = (e) => {
  const t = se();
  if (!t)
    return;
  const n = hn();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Rr = !0;
    const o = Xa(e);
    qa = o.clientX, za = o.clientY, Ka = parseInt(t.style.insetInlineStart) || 0, Ga = parseInt(t.style.insetBlockStart) || 0, oe(t, "swal2-dragging");
  }
}, so = (e) => {
  const t = se();
  if (t && Rr) {
    let {
      clientX: n,
      clientY: o
    } = Xa(e);
    const r = n - qa;
    t.style.insetInlineStart = `${Ka + (R.isRTL ? -r : r)}px`, t.style.insetBlockStart = `${Ga + (o - za)}px`;
  }
}, ao = () => {
  const e = se();
  Rr = !1, ot(e, "swal2-dragging");
}, Xa = (e) => {
  let t = 0, n = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, n = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, n = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: n
  };
}, mm = (e, t) => {
  const n = Be(), o = se();
  if (!(!n || !o)) {
    if (t.toast) {
      Wt(n, "width", t.width), o.style.width = "100%";
      const r = bn();
      r && o.insertBefore(r, hn());
    } else
      Wt(o, "width", t.width);
    Wt(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), $e(Co()), fm(o, t), t.draggable && !t.toast ? (oe(o, y.draggable), um(o)) : (ot(o, y.draggable), dm(o));
  }
}, fm = (e, t) => {
  const n = t.showClass || {};
  e.className = `${y.popup} ${He(e) ? n.popup : ""}`, t.toast ? (oe([document.documentElement, document.body], y["toast-shown"]), oe(e, y.toast)) : oe(e, y.modal), qe(e, t, "popup"), typeof t.customClass == "string" && oe(e, t.customClass), t.icon && oe(e, y[`icon-${t.icon}`]);
}, wm = (e, t) => {
  const n = Nr();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: r
  } = t;
  if (!o || o.length === 0 || r === void 0) {
    $e(n);
    return;
  }
  Ne(n), n.textContent = "", r >= o.length && Me("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((s, a) => {
    const i = pm(s);
    if (n.appendChild(i), a === r && oe(i, y["active-progress-step"]), a !== o.length - 1) {
      const l = hm(t);
      n.appendChild(l);
    }
  });
}, pm = (e) => {
  const t = document.createElement("li");
  return oe(t, y["progress-step"]), Ge(t, e), t;
}, hm = (e) => {
  const t = document.createElement("li");
  return oe(t, y["progress-step-line"]), e.progressStepsDistance && Wt(t, "width", e.progressStepsDistance), t;
}, gm = (e, t) => {
  const n = Ba();
  n && (Sr(n), Mn(n, !!(t.title || t.titleText), "block"), t.title && Dr(t.title, n), t.titleText && (n.innerText = t.titleText), qe(n, t, "title"));
}, Za = (e, t) => {
  var n;
  mm(e, t), zd(e, t), wm(e, t), sm(e, t), cm(e, t), gm(e, t), qd(e, t), om(e, t), jd(e, t), rm(e, t);
  const o = se();
  typeof t.didRender == "function" && o && t.didRender(o), (n = R.eventEmitter) === null || n === void 0 || n.emit("didRender", o);
}, bm = () => He(se()), Ja = () => {
  var e;
  return (e = ht()) === null || e === void 0 ? void 0 : e.click();
}, vm = () => {
  var e;
  return (e = Zt()) === null || e === void 0 ? void 0 : e.click();
}, ym = () => {
  var e;
  return (e = gn()) === null || e === void 0 ? void 0 : e.click();
}, vn = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), Qa = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, _m = (e, t, n) => {
  if (Qa(e), !t.toast) {
    const o = (s) => km(t, s, n);
    e.keydownHandler = o;
    const r = t.keydownListenerCapture ? window : se();
    if (r) {
      e.keydownTarget = r, e.keydownListenerCapture = t.keydownListenerCapture;
      const s = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", s, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, sr = (e, t) => {
  var n;
  const o = Pr();
  if (o.length) {
    e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus();
    return;
  }
  (n = se()) === null || n === void 0 || n.focus();
}, ei = ["ArrowRight", "ArrowDown"], Em = ["ArrowLeft", "ArrowUp"], km = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? xm(t, e) : t.key === "Tab" ? Cm(t) : [...ei, ...Em].includes(t.key) ? Am(t.key) : t.key === "Escape" && Lm(t, e, n)));
}, xm = (e, t) => {
  if (!xo(t.allowEnterKey))
    return;
  const n = se();
  if (!n || !t.input)
    return;
  const o = To(n, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    Ja(), e.preventDefault();
  }
}, Cm = (e) => {
  const t = e.target, n = Pr();
  let o = -1;
  for (let r = 0; r < n.length; r++)
    if (t === n[r]) {
      o = r;
      break;
    }
  e.shiftKey ? sr(o, -1) : sr(o, 1), e.stopPropagation(), e.preventDefault();
}, Am = (e) => {
  const t = Dn(), n = ht(), o = Zt(), r = gn();
  if (!t || !n || !o || !r)
    return;
  const s = [n, o, r];
  if (document.activeElement instanceof HTMLElement && !s.includes(document.activeElement))
    return;
  const a = ei.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let l = 0; l < t.children.length; l++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && He(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, Lm = (e, t, n) => {
  e.preventDefault(), xo(t.allowEscapeKey) && n(vn.esc);
};
var un = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const Tm = () => {
  const e = Be();
  Array.from(document.body.children).forEach((t) => {
    t.contains(e) || (t.hasAttribute("aria-hidden") && t.setAttribute("data-previous-aria-hidden", t.getAttribute("aria-hidden") || ""), t.setAttribute("aria-hidden", "true"));
  });
}, ti = () => {
  Array.from(document.body.children).forEach((e) => {
    e.hasAttribute("data-previous-aria-hidden") ? (e.setAttribute("aria-hidden", e.getAttribute("data-previous-aria-hidden") || ""), e.removeAttribute("data-previous-aria-hidden")) : e.removeAttribute("aria-hidden");
  });
}, ni = typeof window < "u" && !!window.GestureEvent, Nm = () => {
  if (ni && !kt(document.body, y.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, oe(document.body, y.iosfix), Om();
  }
}, Om = () => {
  const e = Be();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = Pm(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, Pm = (e) => {
  const t = e.target, n = Be(), o = Tr();
  return !n || !o || Im(e) || Sm(e) ? !1 : t === n || !rr(n) && t instanceof HTMLElement && !Pd(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(rr(o) && // #1944
  o.contains(t));
}, Im = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), Sm = (e) => e.touches && e.touches.length > 1, $m = () => {
  if (kt(document.body, y.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    ot(document.body, y.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, Dm = () => {
  const e = document.createElement("div");
  e.className = y["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let sn = null;
const Mm = (e) => {
  sn === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (sn = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${sn + Dm()}px`);
}, Rm = () => {
  sn !== null && (document.body.style.paddingRight = `${sn}px`, sn = null);
};
function oi(e, t, n, o) {
  Lo() ? Bs(e, o) : (_d(n).then(() => Bs(e, o)), Qa(R)), ni ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), Ir() && (Rm(), $m(), ti()), Bm();
}
function Bm() {
  ot([document.documentElement, document.body], [y.shown, y["height-auto"], y["no-backdrop"], y["toast-shown"]]);
}
function Nt(e) {
  e = Um(e);
  const t = un.swalPromiseResolve.get(this), n = Fm(this);
  this.isAwaitingPromise ? e.isDismissed || (Bn(this), t(e)) : n && t(e);
}
const Fm = (e) => {
  const t = se();
  if (!t)
    return !1;
  const n = ue.innerParams.get(e);
  if (!n || kt(t, n.hideClass.popup))
    return !1;
  ot(t, n.showClass.popup), oe(t, n.hideClass.popup);
  const o = Be();
  return ot(o, n.showClass.backdrop), oe(o, n.hideClass.backdrop), Vm(e, t, n), !0;
};
function ri(e) {
  const t = un.swalPromiseReject.get(this);
  Bn(this), t && t(e);
}
const Bn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, ue.innerParams.get(e) || e._destroy());
}, Um = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), Vm = (e, t, n) => {
  var o;
  const r = Be(), s = ja(t);
  typeof n.willClose == "function" && n.willClose(t), (o = R.eventEmitter) === null || o === void 0 || o.emit("willClose", t), s && r ? Hm(e, t, r, !!n.returnFocus, n.didClose) : r && oi(e, r, !!n.returnFocus, n.didClose);
}, Hm = (e, t, n, o, r) => {
  R.swalCloseEventFinishedCallback = oi.bind(null, e, n, o, r);
  const s = function(a) {
    if (a.target === t) {
      var i;
      (i = R.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(R), delete R.swalCloseEventFinishedCallback, t.removeEventListener("animationend", s), t.removeEventListener("transitionend", s);
    }
  };
  t.addEventListener("animationend", s), t.addEventListener("transitionend", s);
}, Bs = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = R.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, dn = (e) => {
  let t = se();
  if (t || new ir(), t = se(), !t)
    return;
  const n = bn();
  Lo() ? $e(hn()) : jm(t, e), Ne(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, jm = (e, t) => {
  const n = Dn(), o = bn();
  !n || !o || (!t && He(ht()) && (t = ht()), Ne(n), t && ($e(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), oe([e, n], y.loading));
}, Ym = (e, t) => {
  t.input === "select" || t.input === "radio" ? Gm(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (Ar(t.inputValue) || Lr(t.inputValue)) && (dn(ht()), Xm(e, t));
}, Wm = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return qm(n);
    case "radio":
      return zm(n);
    case "file":
      return Km(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, qm = (e) => e.checked ? 1 : 0, zm = (e) => e.checked ? e.value : null, Km = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, Gm = (e, t) => {
  const n = se();
  if (!n)
    return;
  const o = (r) => {
    t.input === "select" ? Zm(n, io(r), t) : t.input === "radio" && Jm(n, io(r), t);
  };
  Ar(t.inputOptions) || Lr(t.inputOptions) ? (dn(ht()), Sn(t.inputOptions).then((r) => {
    e.hideLoading(), o(r);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : Xt(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Xm = (e, t) => {
  const n = e.getInput();
  n && ($e(n), Sn(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, Ne(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    Xt(`Error in inputValue promise: ${o}`), n.value = "", Ne(n), n.focus(), e.hideLoading();
  }));
};
function Zm(e, t, n) {
  const o = Tt(e, y.select);
  if (!o)
    return;
  const r = (s, a, i) => {
    const l = document.createElement("option");
    l.value = i, Ge(l, a), l.selected = si(i, n.inputValue), s.appendChild(l);
  };
  t.forEach((s) => {
    const a = s[0], i = s[1];
    if (Array.isArray(i)) {
      const l = document.createElement("optgroup");
      l.label = a, l.disabled = !1, o.appendChild(l), i.forEach((w) => r(l, w[1], w[0]));
    } else
      r(o, i, a);
  }), o.focus();
}
function Jm(e, t, n) {
  const o = Tt(e, y.radio);
  if (!o)
    return;
  t.forEach((s) => {
    const a = s[0], i = s[1], l = document.createElement("input"), w = document.createElement("label");
    l.type = "radio", l.name = y.radio, l.value = a, si(a, n.inputValue) && (l.checked = !0);
    const h = document.createElement("span");
    Ge(h, i), h.className = y.label, w.appendChild(l), w.appendChild(h), o.appendChild(w);
  });
  const r = o.querySelectorAll("input");
  r.length && r[0].focus();
}
const io = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((n, o) => {
    let r = n;
    typeof r == "object" && (r = io(r)), t.push([o, r]);
  }) : Object.keys(e).forEach((n) => {
    let o = e[n];
    typeof o == "object" && (o = io(o)), t.push([n, o]);
  }), t;
}, si = (e, t) => !!t && t !== null && t !== void 0 && t.toString() === e.toString(), Qm = (e) => {
  const t = ue.innerParams.get(e);
  e.disableButtons(), t.input ? ai(e, "confirm") : Fr(e, !0);
}, ef = (e) => {
  const t = ue.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? ai(e, "deny") : Br(e, !1);
}, tf = (e, t) => {
  e.disableButtons(), t(vn.cancel);
}, ai = (e, t) => {
  const n = ue.innerParams.get(e);
  if (!n.input) {
    Xt(`The "input" parameter is needed to be set when using returnInputValueOn${Cr(t)}`);
    return;
  }
  const o = e.getInput(), r = Wm(e, n);
  n.inputValidator ? nf(e, r, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? Br(e, r) : Fr(e, r);
}, nf = (e, t, n) => {
  const o = ue.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Sn(o.inputValidator(t, o.validationMessage))).then((r) => {
    e.enableButtons(), e.enableInput(), r ? e.showValidationMessage(r) : n === "deny" ? Br(e, t) : Fr(e, t);
  });
}, Br = (e, t) => {
  const n = ue.innerParams.get(e);
  n.showLoaderOnDeny && dn(Zt()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Sn(n.preDeny(t, n.validationMessage))).then((o) => {
    o === !1 ? (e.hideLoading(), Bn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof o > "u" ? t : o
      }
    );
  }).catch((o) => ii(e, o))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, Fs = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, ii = (e, t) => {
  e.rejectPromise(t);
}, Fr = (e, t) => {
  const n = ue.innerParams.get(e);
  n.showLoaderOnConfirm && dn(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Sn(n.preConfirm(t, n.validationMessage))).then((o) => {
    He(Co()) || o === !1 ? (e.hideLoading(), Bn(e)) : Fs(e, typeof o > "u" ? t : o);
  }).catch((o) => ii(e, o))) : Fs(e, t);
};
function lo() {
  const e = ue.innerParams.get(this);
  if (!e)
    return;
  const t = ue.domCache.get(this);
  $e(t.loader), Lo() ? e.icon && Ne(hn()) : of(t), ot([t.popup, t.actions], y.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const of = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? Ne(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : Od() && $e(e.actions);
};
function li() {
  const e = ue.innerParams.get(this), t = ue.domCache.get(this);
  return t ? To(t.popup, e.input) : null;
}
function ci(e, t, n) {
  const o = ue.domCache.get(e);
  t.forEach((r) => {
    o[r].disabled = n;
  });
}
function ui(e, t) {
  const n = se();
  if (!(!n || !e))
    if (e.type === "radio") {
      const o = n.querySelectorAll(`[name="${y.radio}"]`);
      for (let r = 0; r < o.length; r++)
        o[r].disabled = t;
    } else
      e.disabled = t;
}
function di() {
  ci(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function mi() {
  ci(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function fi() {
  ui(this.getInput(), !1);
}
function wi() {
  ui(this.getInput(), !0);
}
function pi(e) {
  const t = ue.domCache.get(this), n = ue.innerParams.get(this);
  Ge(t.validationMessage, e), t.validationMessage.className = y["validation-message"], n.customClass && n.customClass.validationMessage && oe(t.validationMessage, n.customClass.validationMessage), Ne(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", y["validation-message"]), Va(o), oe(o, y.inputerror));
}
function hi() {
  const e = ue.domCache.get(this);
  e.validationMessage && $e(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), ot(t, y.inputerror));
}
const Ot = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, rf = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], sf = {
  allowEnterKey: void 0
}, af = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], gi = (e) => Object.prototype.hasOwnProperty.call(Ot, e), bi = (e) => rf.indexOf(e) !== -1, vi = (e) => sf[e], lf = (e) => {
  gi(e) || Me(`Unknown parameter "${e}"`);
}, cf = (e) => {
  af.includes(e) && Me(`The parameter "${e}" is incompatible with toasts`);
}, uf = (e) => {
  const t = vi(e);
  t && Ra(e, t);
}, yi = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Me('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Me(`Invalid theme "${e.theme}"`);
  for (const t in e)
    lf(t), e.toast && cf(t), uf(t);
};
function _i(e) {
  const t = Be(), n = se(), o = ue.innerParams.get(this);
  if (!n || kt(n, o.hideClass.popup)) {
    Me("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const r = df(e), s = Object.assign({}, o, r);
  yi(s), t && (t.dataset.swal2Theme = s.theme), Za(this, s), ue.innerParams.set(this, s), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const df = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (bi(n)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = o[n];
    } else
      Me(`Invalid parameter to update: ${n}`);
  }), t;
};
function Ei() {
  var e;
  const t = ue.domCache.get(this), n = ue.innerParams.get(this);
  if (!n) {
    ki(this);
    return;
  }
  t.popup && R.swalCloseEventFinishedCallback && (R.swalCloseEventFinishedCallback(), delete R.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = R.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), mf(this);
}
const mf = (e) => {
  ki(e), delete e.params, delete R.keydownHandler, delete R.keydownTarget, delete R.currentInstance;
}, ki = (e) => {
  e.isAwaitingPromise ? (Yo(ue, e), e.isAwaitingPromise = !0) : (Yo(un, e), Yo(ue, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Yo = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var ff = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: Ei,
  close: Nt,
  closeModal: Nt,
  closePopup: Nt,
  closeToast: Nt,
  disableButtons: mi,
  disableInput: wi,
  disableLoading: lo,
  enableButtons: di,
  enableInput: fi,
  getInput: li,
  handleAwaitingPromise: Bn,
  hideLoading: lo,
  rejectPromise: ri,
  resetValidationMessage: hi,
  showValidationMessage: pi,
  update: _i
});
const wf = (e, t, n) => {
  e.toast ? pf(e, t, n) : (gf(t), bf(t), vf(e, t, n));
}, pf = (e, t, n) => {
  t.popup.onclick = () => {
    e && (hf(e) || e.timer || e.input) || n(vn.close);
  };
}, hf = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let co = !1;
const gf = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (co = !0);
    };
  };
}, bf = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (co = !0);
    };
  };
}, vf = (e, t, n) => {
  t.container.onclick = (o) => {
    if (co) {
      co = !1;
      return;
    }
    o.target === t.container && xo(e.allowOutsideClick) && n(vn.backdrop);
  };
}, yf = (e) => typeof e == "object" && e.jquery, Us = (e) => e instanceof Element || yf(e), _f = (e) => {
  const t = {};
  return typeof e[0] == "object" && !Us(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const r = e[o];
    typeof r == "string" || Us(r) ? t[n] = r : r !== void 0 && Xt(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof r}`);
  }), t;
};
function Ef(...e) {
  return new this(...e);
}
function kf(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, r) {
      return super._main(o, Object.assign({}, e, r));
    }
  }
  return t;
}
const xf = () => R.timeout && R.timeout.getTimerLeft(), xi = () => {
  if (R.timeout)
    return Id(), R.timeout.stop();
}, Ci = () => {
  if (R.timeout) {
    const e = R.timeout.start();
    return $r(e), e;
  }
}, Cf = () => {
  const e = R.timeout;
  return e && (e.running ? xi() : Ci());
}, Af = (e) => {
  if (R.timeout) {
    const t = R.timeout.increase(e);
    return $r(t, !0), t;
  }
}, Lf = () => !!(R.timeout && R.timeout.isRunning());
let Vs = !1;
const ar = {};
function Tf(e = "data-swal-template") {
  ar[e] = this, Vs || (document.body.addEventListener("click", Nf), Vs = !0);
}
const Nf = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in ar) {
      const o = t.getAttribute && t.getAttribute(n);
      if (o) {
        ar[n].fire({
          template: o
        });
        return;
      }
    }
};
class Of {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...r) => {
      this.removeListener(t, o), n.apply(this, r);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (r) {
          console.error(r);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), r = o.indexOf(n);
    r > -1 && o.splice(r, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
R.eventEmitter = new Of();
const Pf = (e, t) => {
  R.eventEmitter && R.eventEmitter.on(e, t);
}, If = (e, t) => {
  R.eventEmitter && R.eventEmitter.once(e, t);
}, Sf = (e, t) => {
  if (R.eventEmitter) {
    if (!e) {
      R.eventEmitter.reset();
      return;
    }
    t ? R.eventEmitter.removeListener(e, t) : R.eventEmitter.removeAllListeners(e);
  }
};
var $f = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: _f,
  bindClickHandler: Tf,
  clickCancel: ym,
  clickConfirm: Ja,
  clickDeny: vm,
  enableLoading: dn,
  fire: Ef,
  getActions: Dn,
  getCancelButton: gn,
  getCloseButton: Or,
  getConfirmButton: ht,
  getContainer: Be,
  getDenyButton: Zt,
  getFocusableElements: Pr,
  getFooter: Ua,
  getHtmlContainer: Tr,
  getIcon: hn,
  getIconContent: Cd,
  getImage: Fa,
  getInputLabel: Ad,
  getLoader: bn,
  getPopup: se,
  getProgressSteps: Nr,
  getTimerLeft: xf,
  getTimerProgressBar: Ao,
  getTitle: Ba,
  getValidationMessage: Co,
  increaseTimer: Af,
  isDeprecatedParameter: vi,
  isLoading: Td,
  isTimerRunning: Lf,
  isUpdatableParameter: bi,
  isValidParameter: gi,
  isVisible: bm,
  mixin: kf,
  off: Sf,
  on: Pf,
  once: If,
  resumeTimer: Ci,
  showLoading: dn,
  stopTimer: xi,
  toggleTimer: Cf
});
class Df {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const Ai = ["swal-title", "swal-html", "swal-footer"], Mf = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return Yf(n), Object.assign(Rf(n), Bf(n), Ff(n), Uf(n), Vf(n), Hf(n), jf(n, Ai));
}, Rf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((n) => {
    Kt(n, ["name", "value"]);
    const o = (
      /** @type {keyof SweetAlertOptions} */
      n.getAttribute("name")
    ), r = n.getAttribute("value");
    !o || !r || (o in Ot && typeof Ot[
      /** @type {keyof typeof defaultParams} */
      o
    ] == "boolean" ? t[o] = r !== "false" : o in Ot && typeof Ot[
      /** @type {keyof typeof defaultParams} */
      o
    ] == "object" ? t[o] = JSON.parse(r) : t[o] = r);
  }), t;
}, Bf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((n) => {
    const o = (
      /** @type {keyof SweetAlertOptions} */
      n.getAttribute("name")
    ), r = n.getAttribute("value");
    !o || !r || (t[o] = new Function(`return ${r}`)());
  }), t;
}, Ff = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((n) => {
    Kt(n, ["type", "color", "aria-label"]);
    const o = n.getAttribute("type");
    if (!(!o || !["confirm", "cancel", "deny"].includes(o))) {
      if (t[`${o}ButtonText`] = n.innerHTML, t[`show${Cr(o)}Button`] = !0, n.hasAttribute("color")) {
        const r = n.getAttribute("color");
        r !== null && (t[`${o}ButtonColor`] = r);
      }
      if (n.hasAttribute("aria-label")) {
        const r = n.getAttribute("aria-label");
        r !== null && (t[`${o}ButtonAriaLabel`] = r);
      }
    }
  }), t;
}, Uf = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  return n && (Kt(n, ["src", "width", "height", "alt"]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
}, Vf = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (Kt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, Hf = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (Kt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((r) => {
    Kt(r, ["value"]);
    const s = r.getAttribute("value");
    if (!s)
      return;
    const a = r.innerHTML;
    t.inputOptions[s] = a;
  })), t;
}, jf = (e, t) => {
  const n = {};
  for (const o in t) {
    const r = t[o], s = e.querySelector(r);
    s && (Kt(s, []), n[r.replace(/^swal-/, "")] = s.innerHTML.trim());
  }
  return n;
}, Yf = (e) => {
  const t = Ai.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Me(`Unrecognized element <${o}>`);
  });
}, Kt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Me([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, Li = 10, Wf = (e) => {
  var t, n;
  const o = Be(), r = se();
  if (!o || !r)
    return;
  typeof e.willOpen == "function" && e.willOpen(r), (t = R.eventEmitter) === null || t === void 0 || t.emit("willOpen", r);
  const s = window.getComputedStyle(document.body).overflowY;
  if (Kf(o, r, e), setTimeout(() => {
    qf(o, r);
  }, Li), Ir() && (zf(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, s), Tm()), !Lo() && !R.previousActiveElement && (R.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const a = e.didOpen;
    setTimeout(() => a(r));
  }
  (n = R.eventEmitter) === null || n === void 0 || n.emit("didOpen", r);
}, uo = (e) => {
  const t = se();
  if (!t || e.target !== t)
    return;
  const n = Be();
  n && (t.removeEventListener("animationend", uo), t.removeEventListener("transitionend", uo), n.style.overflowY = "auto", ot(n, y["no-transition"]));
}, qf = (e, t) => {
  ja(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", uo), t.addEventListener("transitionend", uo)) : e.style.overflowY = "auto";
}, zf = (e, t, n) => {
  Nm(), t && n !== "hidden" && Mm(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Kf = (e, t, n) => {
  var o;
  (o = n.showClass) !== null && o !== void 0 && o.backdrop && oe(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), Ne(t, "grid"), setTimeout(() => {
    var r;
    (r = n.showClass) !== null && r !== void 0 && r.popup && oe(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, Li)) : Ne(t, "grid"), oe([document.documentElement, document.body], y.shown), n.heightAuto && n.backdrop && !n.toast && oe([document.documentElement, document.body], y["height-auto"]);
};
var Hs = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function Gf(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Hs.email), e.input === "url" && (e.inputValidator = Hs.url));
}
function Xf(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Me('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Zf(e) {
  Gf(e), e.showLoaderOnConfirm && !e.preConfirm && Me(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), Xf(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), Ud(e);
}
let mt;
var Kn = /* @__PURE__ */ new WeakMap();
class _e {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (gd(
      this,
      Kn,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    mt = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, bd(Kn, this, this._main(mt.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (yi(Object.assign({}, n, t)), R.currentInstance) {
      const s = un.swalPromiseResolve.get(R.currentInstance), {
        isAwaitingPromise: a
      } = R.currentInstance;
      R.currentInstance._destroy(), a || s({
        isDismissed: !0
      }), Ir() && ti();
    }
    R.currentInstance = mt;
    const o = Qf(t, n);
    Zf(o), Object.freeze(o), R.timeout && (R.timeout.stop(), delete R.timeout), clearTimeout(R.restoreFocusTimeout);
    const r = ew(mt);
    return Za(mt, o), ue.innerParams.set(mt, o), Jf(mt, r, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  then(t) {
    return Is(Kn, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return Is(Kn, this).finally(t);
  }
}
const Jf = (e, t, n) => new Promise((o, r) => {
  const s = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  un.swalPromiseResolve.set(e, o), un.swalPromiseReject.set(e, r), t.confirmButton.onclick = () => {
    Qm(e);
  }, t.denyButton.onclick = () => {
    ef(e);
  }, t.cancelButton.onclick = () => {
    tf(e, s);
  }, t.closeButton.onclick = () => {
    s(vn.close);
  }, wf(n, t, s), _m(R, n, s), Ym(e, n), Wf(n), tw(R, n, s), nw(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), Qf = (e, t) => {
  const n = Mf(e), o = Object.assign({}, Ot, t, n, e);
  return o.showClass = Object.assign({}, Ot.showClass, o.showClass), o.hideClass = Object.assign({}, Ot.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, ew = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        se()
      ),
      container: (
        /** @type {HTMLElement} */
        Be()
      ),
      actions: (
        /** @type {HTMLElement} */
        Dn()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        ht()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        Zt()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        gn()
      ),
      loader: (
        /** @type {HTMLElement} */
        bn()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        Or()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        Co()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        Nr()
      )
    }
  );
  return ue.domCache.set(e, t), t;
}, tw = (e, t, n) => {
  const o = Ao();
  $e(o), t.timer && (e.timeout = new Df(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (Ne(o), qe(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && $r(
      /** @type {number} */
      t.timer
    );
  })));
}, nw = (e, t) => {
  if (!t.toast) {
    if (!xo(t.allowEnterKey)) {
      Ra("allowEnterKey"), sw();
      return;
    }
    ow(e) || rw(e, t) || sr(-1, 1);
  }
}, ow = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && He(n))
      return n.focus(), !0;
  return !1;
}, rw = (e, t) => t.focusDeny && He(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && He(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && He(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, sw = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
_e.prototype.disableButtons = mi;
_e.prototype.enableButtons = di;
_e.prototype.getInput = li;
_e.prototype.disableInput = wi;
_e.prototype.enableInput = fi;
_e.prototype.hideLoading = lo;
_e.prototype.disableLoading = lo;
_e.prototype.showValidationMessage = pi;
_e.prototype.resetValidationMessage = hi;
_e.prototype.close = Nt;
_e.prototype.closePopup = Nt;
_e.prototype.closeModal = Nt;
_e.prototype.closeToast = Nt;
_e.prototype.rejectPromise = ri;
_e.prototype.update = _i;
_e.prototype._destroy = Ei;
Object.assign(_e, $f);
Object.keys(ff).forEach((e) => {
  _e[e] = function(...t) {
    if (mt && mt[e])
      return mt[e](...t);
  };
});
_e.DismissReason = vn;
_e.version = "11.26.17";
const ir = _e;
ir.default = ir;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const aw = (e) => {
  if (!/^\d{8}$/.test(e)) return !1;
  const t = [1, 2, 1, 2, 1, 2, 4, 1];
  let n = 0, o = 0;
  for (let r = 0; r < 8; r++) {
    const s = parseInt(e.charAt(r), 10) * t[r];
    if (s >= 10) {
      const a = Math.floor(s / 10), i = s % 10;
      r === 6 && a === 7 ? (n += 7, o += 8) : (n += a + i, o += a + i);
    } else
      n += s, o += s;
  }
  return n % 5 === 0 || o % 5 === 0;
}, iw = (e) => {
  let t = e.replace(/\D/g, "");
  t.length > 8 && (t = t.slice(0, 8));
  let n = "", o = !1;
  return t.length === 8 ? aw(t) ? o = !0 : n = "統編格式檢查錯誤，請確認號碼" : t.length > 0 && (n = `統編需為 8 位數字（目前已輸入 ${t.length} 碼）`), { value: t, error: n, isReady: o };
};
function lw(e) {
  const {
    paymentInfo: t,
    isLoading: n,
    paymentError: o,
    fetchPaymentInfoPaginated: r,
    createInvoice: s,
    queryCompanyName: a,
    voidPayment: i
  } = ud(e), l = Ve(void 0), w = ea({
    currentPage: 1,
    totalPages: 1,
    limit: 10
  }), h = Ye(() => t.value ? Array.isArray(t.value) ? t.value : [t.value] : []), v = Ye(() => {
    let A = 0, g = 0, T = 0, f = 0;
    return h.value.forEach((b) => {
      const C = String(b.rtn_code);
      C === "1" ? (A += b.trade_amt ? Number(b.trade_amt) : 0, g++) : C === "0" ? T++ : f++;
    }), { totalAmount: A, successCount: g, pendingCount: T, failedCount: f };
  }), d = async (A = 1) => {
    try {
      const g = {
        page: A,
        limit: w.limit,
        rtn_code: l.value
      }, T = await r(g);
      w.currentPage = T.page, w.totalPages = T.total > 0 ? Math.ceil(T.total / T.limit) : 1;
    } catch {
    }
  };
  return {
    isLoading: n,
    paymentError: o,
    paymentsList: h,
    filterRtnCode: l,
    pagination: w,
    stats: v,
    loadPaymentInfo: d,
    changeFilter: async (A) => {
      l.value = A, await d(1);
    },
    createInvoice: s,
    queryCompanyName: a,
    voidPayment: i
  };
}
const cw = { class: "w-full bg-linear-to-br from-blue-700 to-blue-800 p-6 rounded-3xl text-white shadow-xl" }, uw = { class: "text-3xl sm:text-4xl font-black mt-2" }, dw = { class: "grid grid-cols-3 gap-2 text-center text-xs sm:text-sm" }, mw = { class: "bg-white/10 p-3 rounded-2xl" }, fw = { class: "text-lg font-bold mt-1" }, ww = { class: "bg-white/10 p-3 rounded-2xl" }, pw = { class: "text-lg font-bold mt-1" }, hw = { class: "bg-white/10 p-3 rounded-2xl" }, gw = { class: "text-lg font-bold mt-1" }, bw = /* @__PURE__ */ $t({
  __name: "PaymentStats",
  props: {
    totalAmount: {},
    successCount: {},
    pendingCount: {},
    failedCount: {}
  },
  setup(e) {
    return (t, n) => (X(), te("div", cw, [
      n[3] || (n[3] = E("p", { class: "text-blue-100 opacity-90 font-medium text-sm" }, "總交易金額 (台幣)", -1)),
      E("h2", uw, "$ " + j(e.totalAmount.toLocaleString()), 1),
      n[4] || (n[4] = E("hr", { class: "border-white opacity-20 my-4" }, null, -1)),
      E("div", dw, [
        E("div", mw, [
          n[0] || (n[0] = E("p", { class: "text-blue-100 opacity-80" }, "成功", -1)),
          E("p", fw, j(e.successCount) + " 筆", 1)
        ]),
        E("div", ww, [
          n[1] || (n[1] = E("p", { class: "text-blue-100 opacity-80" }, "處理中", -1)),
          E("p", pw, j(e.pendingCount) + " 筆", 1)
        ]),
        E("div", hw, [
          n[2] || (n[2] = E("p", { class: "text-blue-100 opacity-80" }, "失敗", -1)),
          E("p", gw, j(e.failedCount) + " 筆", 1)
        ])
      ])
    ]));
  }
}), vw = { class: "w-full flex flex-col sm:flex-row sm:items-center justify-between gap-3 border-b border-gray-100 pb-4" }, yw = { class: "min-w-0 flex-1" }, _w = { class: "font-mono font-bold text-gray-700 text-sm sm:text-base mt-0.5 break-all" }, Ew = {
  key: 0,
  class: "min-w-0 flex-1"
}, kw = { class: "flex items-start" }, xw = { class: "grid grid-cols-2 gap-4 text-sm border-b border-gray-100 pb-4" }, Cw = { class: "text-lg sm:text-xl font-black text-gray-700 mt-1" }, Aw = { class: "text-gray-700 font-medium mt-1 text-xs sm:text-sm" }, Lw = { class: "text-xs text-gray-700 opacity-60 block mt-0.5" }, Tw = {
  key: 0,
  class: "bg-gray-50 rounded-2xl p-4"
}, Nw = { class: "flex items-center justify-between mb-2" }, Ow = { class: "text-xs font-bold text-gray-700 uppercase tracking-wider" }, Pw = { class: "text-xs bg-white text-gray-700 font-bold px-2 py-0.5 rounded-md border border-gray-200" }, Iw = { class: "flex flex-col gap-1.5" }, Sw = { class: "select-all break-all" }, $w = {
  key: 1,
  class: "text-xs text-gray-700 font-medium bg-gray-50 p-3 rounded-2xl text-center"
}, Dw = {
  key: 2,
  class: "bg-blue-50/50 rounded-2xl p-4 border border-blue-100"
}, Mw = { class: "flex items-center justify-between mb-3" }, Rw = {
  key: 0,
  class: "flex items-center gap-2"
}, Bw = { class: "flex items-center gap-2" }, Fw = ["href"], Uw = { class: "grid grid-cols-2 gap-y-3 gap-x-4 text-[11px]" }, Vw = { class: "font-mono font-bold text-gray-700" }, Hw = { class: "font-medium text-gray-700" }, jw = { key: 0 }, Yw = { class: "font-mono font-bold text-gray-700" }, Ww = { key: 1 }, qw = { class: "font-bold text-gray-700" }, zw = { key: 2 }, Kw = { class: "font-mono font-bold text-gray-700" }, Gw = {
  key: 0,
  class: "mt-3 pt-3 border-t border-red-100 flex flex-col gap-1"
}, Xw = { class: "text-[11px] text-red-600 font-medium" }, Zw = {
  key: 0,
  class: "bg-red-50 px-1 py-0.5 rounded mr-1"
}, Jw = /* @__PURE__ */ $t({
  __name: "PaymentCard",
  props: {
    payment: {}
  },
  emits: ["clickCard"],
  setup(e, { emit: t }) {
    const { t: n } = pn(), o = e, r = t, s = {
      1: { text: "交易成功", className: "bg-green-100 text-green-700 border-green-200" },
      0: { text: "尚未付款", className: "bg-gray-100 text-black border-blue-700" },
      "-1": { text: "作廢", className: "bg-yellow-100 text-red-700 border-yellow-700" },
      default: { text: "交易失敗", className: "bg-rose-100 text-red-700 border-rose-200" }
    }, a = {
      issued: "已開立",
      voided: "已作廢",
      init: "新建立",
      cancelled: "已折讓",
      failed: "開立失敗"
    }, i = {
      COUNTER: { text: "櫃檯結帳", className: "bg-purple-50 text-purple-700 border-purple-200" },
      ONLINE: { text: "線上支付", className: "bg-indigo-50 text-indigo-700 border-indigo-200" },
      default: { text: "未知管道", className: "bg-gray-50 text-gray-600 border-gray-200" }
    }, l = Ye(() => String(o.payment.rtn_code) === "1"), w = Ye(() => {
      const d = String(o.payment.rtn_code);
      return d in s ? s[d] : s.default;
    }), h = Ye(() => {
      const d = o.payment.checkout_type;
      return d ? d in i ? i[d] : { text: d, className: i.default.className } : i.default;
    }), v = Ye(() => {
      var m;
      const d = (m = o.payment.invoice_transaction) == null ? void 0 : m.status;
      return d === "issued" ? "bg-blue-100 text-blue-700 border-blue-200" : d === "failed" ? "bg-red-100 text-red-700 border-red-200" : "bg-gray-100 text-gray-500 border-gray-200";
    });
    return (d, m) => {
      var A;
      return X(), te("div", {
        onClick: m[1] || (m[1] = (g) => r("clickCard", e.payment)),
        class: nn([
          "bg-white rounded-3xl border border-gray-100 p-5 sm:p-6 shadow-sm hover:shadow-md transition-all duration-200 space-y-4",
          l.value ? "cursor-pointer hover:border-blue-300" : ""
        ])
      }, [
        E("div", vw, [
          E("div", yw, [
            m[2] || (m[2] = E("p", { class: "text-xs text-gray-700 opacity-60 uppercase tracking-wider" }, "交易編號", -1)),
            E("p", _w, j(e.payment.merchant_trade_no), 1)
          ]),
          e.payment.checkout_type ? (X(), te("div", Ew, [
            E("span", {
              class: nn([h.value.className, "px-2.5 py-1 rounded-lg text-xs font-semibold border whitespace-nowrap"])
            }, j(h.value.text), 3)
          ])) : Ue("", !0),
          E("div", kw, [
            E("span", {
              class: nn([w.value.className, "px-3 py-1.5 rounded-full text-xs font-black border whitespace-nowrap"])
            }, j(w.value.text), 3)
          ])
        ]),
        E("div", xw, [
          E("div", null, [
            m[3] || (m[3] = E("p", { class: "text-gray-700 opacity-60 text-xs" }, "交易金額", -1)),
            E("p", Cw, " $ " + j(e.payment.trade_amt ? Number(e.payment.trade_amt).toLocaleString() : "0"), 1)
          ]),
          E("div", null, [
            m[4] || (m[4] = E("p", { class: "text-gray-700 opacity-60 text-xs" }, "建立時間", -1)),
            E("p", Aw, [
              Lt(j(e.payment.created_at ? new Date(e.payment.created_at).toLocaleDateString() : "-") + " ", 1),
              E("span", Lw, j(e.payment.created_at ? new Date(e.payment.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : ""), 1)
            ])
          ])
        ]),
        (A = e.payment.order_ids) != null && A.length ? (X(), te("div", Tw, [
          E("div", Nw, [
            E("p", Ow, j(K(n)("ecpay.associatedOrders") || "關聯系統訂單ID"), 1),
            E("span", Pw, j(e.payment.order_ids.length) + " 筆 ", 1)
          ]),
          E("div", Iw, [
            (X(!0), te(In, null, fr(e.payment.order_ids, (g) => (X(), te("div", {
              key: g,
              class: "flex items-center gap-2 bg-white px-3 py-1.5 rounded-xl border border-gray-100 text-xs font-mono text-gray-700 shadow-xs"
            }, [
              m[5] || (m[5] = E("span", { class: "w-1.5 h-1.5 bg-blue-700 rounded-full shrink-0" }, null, -1)),
              E("span", Sw, j(g.slice(-3)), 1)
            ]))), 128))
          ])
        ])) : (X(), te("div", $w, " ⚠️ 找不到關聯的訂單交易紀錄 ")),
        e.payment.invoice_transaction ? (X(), te("div", Dw, [
          E("div", Mw, [
            e.payment.invoice_transaction.status === "issued" ? (X(), te("div", Rw, [...m[6] || (m[6] = [
              E("svg", {
                class: "w-4 h-4 text-blue-700",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                E("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                })
              ], -1),
              E("p", { class: "text-xs font-bold text-blue-700 uppercase tracking-wider" }, "電子發票已開立", -1)
            ])])) : Ue("", !0),
            E("div", Bw, [
              E("span", {
                class: nn([v.value, "px-2 py-0.5 rounded text-[10px] font-bold border"])
              }, j(a[e.payment.invoice_transaction.status] || "未知狀態"), 3),
              e.payment.invoice_transaction.print_html ? (X(), te("a", {
                key: 0,
                href: e.payment.invoice_transaction.print_html,
                target: "_blank",
                onClick: m[0] || (m[0] = Tl(() => {
                }, ["stop"])),
                class: "text-[10px] bg-blue-700 text-white font-bold px-2 py-0.5 rounded hover:bg-blue-800 transition-colors"
              }, " 📄 檢視發票 ", 8, Fw)) : Ue("", !0)
            ])
          ]),
          E("div", Uw, [
            E("div", null, [
              m[7] || (m[7] = E("p", { class: "text-gray-500 mb-0.5" }, "發票號碼", -1)),
              E("p", Vw, j(e.payment.invoice_transaction.invoice_no), 1)
            ]),
            E("div", null, [
              m[8] || (m[8] = E("p", { class: "text-gray-500 mb-0.5" }, "開立日期", -1)),
              E("p", Hw, j(e.payment.invoice_transaction.invoice_date ? new Date(e.payment.invoice_transaction.invoice_date).toLocaleDateString() : "-"), 1)
            ]),
            e.payment.invoice_transaction.customer_identifier ? (X(), te("div", jw, [
              m[9] || (m[9] = E("p", { class: "text-gray-500 mb-0.5" }, "買方統編", -1)),
              E("p", Yw, j(e.payment.invoice_transaction.customer_identifier), 1)
            ])) : Ue("", !0),
            e.payment.invoice_transaction.customer_name ? (X(), te("div", Ww, [
              m[10] || (m[10] = E("p", { class: "text-gray-500 mb-0.5" }, "買受人名稱", -1)),
              E("p", qw, j(e.payment.invoice_transaction.customer_name), 1)
            ])) : Ue("", !0),
            e.payment.invoice_transaction.carrier_num ? (X(), te("div", zw, [
              m[11] || (m[11] = E("p", { class: "text-gray-500 mb-0.5" }, "載具號碼", -1)),
              E("p", Kw, j(e.payment.invoice_transaction.carrier_num), 1)
            ])) : Ue("", !0)
          ]),
          e.payment.invoice_transaction.status === "failed" && (e.payment.invoice_transaction.error_message || e.payment.invoice_transaction.error_code) ? (X(), te("div", Gw, [
            m[12] || (m[12] = E("div", { class: "flex items-center gap-1.5 text-red-700" }, [
              E("svg", {
                class: "w-3.5 h-3.5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                E("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ]),
              E("p", { class: "text-[10px] font-black uppercase tracking-wider" }, "開立失敗原因")
            ], -1)),
            E("p", Xw, [
              e.payment.invoice_transaction.error_code ? (X(), te("span", Zw, "[" + j(e.payment.invoice_transaction.error_code) + "]", 1)) : Ue("", !0),
              Lt(" " + j(e.payment.invoice_transaction.error_message), 1)
            ])
          ])) : Ue("", !0)
        ])) : Ue("", !0)
      ], 2);
    };
  }
});
/*!
* sweetalert2 v11.26.25
* Released under the MIT License.
*/
function Ti(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function Qw(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function js(e, t) {
  return e.get(Ti(e, t));
}
function ep(e, t, n) {
  Qw(e, t), t.set(e, n);
}
function tp(e, t, n) {
  return e.set(Ti(e, t), n), n;
}
const np = 100, B = {}, op = () => {
  B.previousActiveElement instanceof HTMLElement ? (B.previousActiveElement.focus(), B.previousActiveElement = null) : document.body && document.body.focus();
}, rp = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  B.restoreFocusTimeout = setTimeout(() => {
    op(), t();
  }, np), window.scrollTo(n, o);
}), Ni = "swal2-", sp = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], _ = sp.reduce(
  (e, t) => (e[t] = Ni + t, e),
  /** @type {SwalClasses} */
  {}
), ap = ["success", "warning", "info", "question", "error"], mo = ap.reduce(
  (e, t) => (e[t] = Ni + t, e),
  /** @type {SwalIcons} */
  {}
), Oi = "SweetAlert2:", Ur = (e) => e.charAt(0).toUpperCase() + e.slice(1), Re = (e) => {
  console.warn(`${Oi} ${typeof e == "object" ? e.join(" ") : e}`);
}, Jt = (e) => {
  console.error(`${Oi} ${e}`);
}, Ys = [], ip = (e) => {
  Ys.includes(e) || (Ys.push(e), Re(e));
}, Pi = (e, t = null) => {
  ip(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, No = (e) => typeof e == "function" ? e() : e, Vr = (e) => e && typeof e.toPromise == "function", Fn = (e) => Vr(e) ? e.toPromise() : Promise.resolve(e), Hr = (e) => e && Promise.resolve(e) === e, lp = () => navigator.userAgent.includes("Firefox"), Fe = () => document.body.querySelector(`.${_.container}`), Un = (e) => {
  const t = Fe();
  return t ? t.querySelector(e) : null;
}, Xe = (e) => Un(`.${e}`), ae = () => Xe(_.popup), yn = () => Xe(_.icon), cp = () => Xe(_["icon-content"]), Ii = () => Xe(_.title), jr = () => Xe(_["html-container"]), Si = () => Xe(_.image), Yr = () => Xe(_["progress-steps"]), Oo = () => Xe(_["validation-message"]), gt = () => (
  /** @type {HTMLButtonElement} */
  Un(`.${_.actions} .${_.confirm}`)
), _n = () => (
  /** @type {HTMLButtonElement} */
  Un(`.${_.actions} .${_.cancel}`)
), Qt = () => (
  /** @type {HTMLButtonElement} */
  Un(`.${_.actions} .${_.deny}`)
), up = () => Xe(_["input-label"]), En = () => Un(`.${_.loader}`), Vn = () => Xe(_.actions), $i = () => Xe(_.footer), Po = () => Xe(_["timer-progress-bar"]), Wr = () => Xe(_.close), dp = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, qr = () => {
  const e = ae();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((s, a) => {
    const i = parseInt(s.getAttribute("tabindex") || "0"), l = parseInt(a.getAttribute("tabindex") || "0");
    return i > l ? 1 : i < l ? -1 : 0;
  }), o = e.querySelectorAll(dp), r = Array.from(o).filter((s) => s.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(r))].filter((s) => je(s));
}, zr = () => xt(document.body, _.shown) && !xt(document.body, _["toast-shown"]) && !xt(document.body, _["no-backdrop"]), Io = () => {
  const e = ae();
  return e ? xt(e, _.toast) : !1;
}, mp = () => {
  const e = ae();
  return e ? e.hasAttribute("data-loading") : !1;
}, Ze = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), r = o.querySelector("head");
    r && Array.from(r.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const s = o.querySelector("body");
    s && Array.from(s.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, xt = (e, t) => t ? t.split(/\s+/).every((n) => e.classList.contains(n)) : !1, fp = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(_).includes(n) && !Object.values(mo).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, ze = (e, t, n) => {
  if (fp(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Re(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    re(e, o);
  }
}, So = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${_.popup} > .${_[t]}`);
    case "checkbox":
      return e.querySelector(`.${_.popup} > .${_.checkbox} input`);
    case "radio":
      return e.querySelector(`.${_.popup} > .${_.radio} input:checked`) || e.querySelector(`.${_.popup} > .${_.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${_.popup} > .${_.range} input`);
    default:
      return e.querySelector(`.${_.popup} > .${_.input}`);
  }
}, Di = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Mi = (e, t, n) => {
  if (!e || !t)
    return;
  const o = typeof t == "string" ? t.split(/\s+/).filter(Boolean) : t;
  (Array.isArray(e) ? e : [e]).forEach((s) => {
    o.forEach((a) => {
      n ? s.classList.add(a) : s.classList.remove(a);
    });
  });
}, re = (e, t) => {
  Mi(e, t, !0);
}, rt = (e, t) => {
  Mi(e, t, !1);
}, Pt = (e, t) => (
  /** @type {HTMLElement | undefined} */
  Array.from(e.children).find((n) => n instanceof HTMLElement && xt(n, t))
), qt = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || n === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, Oe = (e, t = "flex") => {
  e && (e.style.display = t);
}, De = (e) => {
  e && (e.style.display = "none");
}, Kr = (e, t = "block") => {
  e && new MutationObserver(() => {
    Hn(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, Ws = (e, t, n, o) => {
  const r = e.querySelector(t);
  r && r.style.setProperty(n, o);
}, Hn = (e, t, n = "flex") => {
  t ? Oe(e, n) : De(e);
}, je = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), wp = () => !je(gt()) && !je(Qt()) && !je(_n()), lr = (e) => e.scrollHeight > e.clientHeight, pp = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (lr(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, Ri = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, Gr = (e, t = !1) => {
  const n = Po();
  n && je(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, hp = () => {
  const e = Po();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, gp = () => typeof window > "u" || typeof document > "u", bp = `
 <div aria-labelledby="${_.title}" aria-describedby="${_["html-container"]}" class="${_.popup}" tabindex="-1">
   <button type="button" class="${_.close}"></button>
   <ul class="${_["progress-steps"]}"></ul>
   <div class="${_.icon}"></div>
   <img class="${_.image}" />
   <h2 class="${_.title}" id="${_.title}"></h2>
   <div class="${_["html-container"]}" id="${_["html-container"]}"></div>
   <input class="${_.input}" id="${_.input}" />
   <input type="file" class="${_.file}" />
   <div class="${_.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${_.select}" id="${_.select}"></select>
   <div class="${_.radio}"></div>
   <label class="${_.checkbox}">
     <input type="checkbox" id="${_.checkbox}" />
     <span class="${_.label}"></span>
   </label>
   <textarea class="${_.textarea}" id="${_.textarea}"></textarea>
   <div class="${_["validation-message"]}" id="${_["validation-message"]}"></div>
   <div class="${_.actions}">
     <div class="${_.loader}"></div>
     <button type="button" class="${_.confirm}"></button>
     <button type="button" class="${_.deny}"></button>
     <button type="button" class="${_.cancel}"></button>
   </div>
   <div class="${_.footer}"></div>
   <div class="${_["timer-progress-bar-container"]}">
     <div class="${_["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), vp = () => {
  const e = Fe();
  return e ? (e.remove(), rt([document.documentElement, document.body], [
    _["no-backdrop"],
    _["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    _["has-column"]
  ]), !0) : !1;
}, Ht = () => {
  B.currentInstance && B.currentInstance.resetValidationMessage();
}, yp = () => {
  const e = ae();
  if (!e)
    return;
  const t = Pt(e, _.input), n = Pt(e, _.file), o = e.querySelector(`.${_.range} input`), r = e.querySelector(`.${_.range} output`), s = Pt(e, _.select), a = e.querySelector(`.${_.checkbox} input`), i = Pt(e, _.textarea);
  t && (t.oninput = Ht), n && (n.onchange = Ht), s && (s.onchange = Ht), a && (a.onchange = Ht), i && (i.oninput = Ht), o && r && (o.oninput = () => {
    Ht(), r.value = o.value;
  }, o.onchange = () => {
    Ht(), r.value = o.value;
  });
}, _p = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, Ep = (e) => {
  const t = ae();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, kp = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (re(Fe(), _.rtl), B.isRTL = !0);
}, xp = (e) => {
  const t = vp();
  if (gp()) {
    Jt("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = _.container, t && re(n, _["no-transition"]), Ze(n, bp), n.dataset.swal2Theme = e.theme;
  const o = _p(e.target || "body");
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), Ep(e), kp(o), yp();
}, Xr = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? Cp(e, t) : e && Ze(t, e);
}, Cp = (e, t) => {
  "jquery" in e ? Ap(t, e) : Ze(t, e.toString());
}, Ap = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, Lp = (e, t) => {
  const n = Vn(), o = En();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? De(n) : Oe(n), ze(n, t, "actions"), Tp(n, o, t), Ze(o, t.loaderHtml || ""), ze(o, t, "loader"));
};
function Tp(e, t, n) {
  const o = gt(), r = Qt(), s = _n();
  !o || !r || !s || (Wo(o, "confirm", n), Wo(r, "deny", n), Wo(s, "cancel", n), Np(o, r, s, n), n.reverseButtons && (n.toast ? (e.insertBefore(s, o), e.insertBefore(r, o)) : (e.insertBefore(s, t), e.insertBefore(r, t), e.insertBefore(o, t))));
}
function Np(e, t, n, o) {
  if (!o.buttonsStyling) {
    rt([e, t, n], _.styled);
    return;
  }
  re([e, t, n], _.styled), [[e, "confirm", o.confirmButtonColor], [t, "deny", o.denyButtonColor], [n, "cancel", o.cancelButtonColor]].forEach(([s, a, i]) => {
    i && s.style.setProperty(`--swal2-${a}-button-background-color`, i), Op(s);
  });
}
function Op(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Wo(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    Ur(t)
  );
  Hn(e, n[`show${o}Button`], "inline-block"), Ze(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = _[t], ze(e, n, `${t}Button`);
}
const Pp = (e, t) => {
  const n = Wr();
  n && (Ze(n, t.closeButtonHtml || ""), ze(n, t, "closeButton"), Hn(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, Ip = (e, t) => {
  const n = Fe();
  n && (Sp(n, t.backdrop), $p(n, t.position), Dp(n, t.grow), ze(n, t, "container"));
};
function Sp(e, t) {
  typeof t == "string" ? e.style.background = t : t || re([document.documentElement, document.body], _["no-backdrop"]);
}
function $p(e, t) {
  t && (t in _ ? re(e, _[t]) : (Re('The "position" parameter is not valid, defaulting to "center"'), re(e, _.center)));
}
function Dp(e, t) {
  t && re(e, _[`grow-${t}`]);
}
var le = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap(),
  focusedElement: /* @__PURE__ */ new WeakMap()
};
const Mp = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], Rp = (e, t) => {
  const n = ae();
  if (!n)
    return;
  const o = le.innerParams.get(e), r = !o || t.input !== o.input;
  Mp.forEach((s) => {
    const a = Pt(n, _[s]);
    a && (Up(s, t.inputAttributes), a.className = _[s], r && De(a));
  }), t.input && (r && Bp(t), Vp(t));
}, Bp = (e) => {
  if (!e.input)
    return;
  if (!be[e.input]) {
    Jt(`Unexpected type of input! Expected ${Object.keys(be).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Bi(e.input);
  if (!t)
    return;
  const n = be[e.input](t, e);
  Oe(t), e.inputAutoFocus && setTimeout(() => {
    Di(n);
  });
}, Fp = (e) => {
  for (const {
    name: t
  } of Array.from(e.attributes))
    ["id", "type", "value", "style"].includes(t) || e.removeAttribute(t);
}, Up = (e, t) => {
  const n = ae();
  if (!n)
    return;
  const o = So(n, e);
  if (o) {
    Fp(o);
    for (const r in t)
      o.setAttribute(r, t[r]);
  }
}, Vp = (e) => {
  if (!e.input)
    return;
  const t = Bi(e.input);
  t && ze(t, e, "input");
}, Zr = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, jn = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), r = _["input-label"];
    o.setAttribute("for", e.id), o.className = r, typeof n.customClass == "object" && re(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, Bi = (e) => {
  const t = ae();
  if (t)
    return Pt(t, _[
      /** @type {SwalClass} */
      e
    ] || _.input);
}, fo = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : Hr(t) || Re(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, be = {};
be.text = be.email = be.password = be.number = be.tel = be.url = be.search = be.date = be["datetime-local"] = be.time = be.week = be.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return fo(n, t.inputValue), jn(n, n, t), Zr(n, t), n.type = /** @type {string} */
  t.input, n;
};
be.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return jn(n, n, t), Zr(n, t), n;
};
be.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), o = n.querySelector("input"), r = n.querySelector("output");
  return o && (fo(o, t.inputValue), o.type = /** @type {string} */
  t.input, jn(
    o,
    /** @type {Input} */
    e,
    t
  )), r && fo(r, t.inputValue), /** @type {Input} */
  e;
};
be.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    Ze(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, n.appendChild(o);
  }
  return jn(n, n, t), n;
};
be.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
be.checkbox = (e, t) => {
  const n = ae();
  if (!n)
    throw new Error("Popup not found");
  const o = So(n, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const s = /** @type {HTMLElement} */ e.querySelector("span");
  if (s) {
    const a = t.inputPlaceholder || t.inputLabel;
    a && Ze(s, a);
  }
  return o;
};
be.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  fo(n, t.inputValue), Zr(n, t), jn(n, n, t);
  const o = (r) => parseInt(window.getComputedStyle(r).marginLeft) + parseInt(window.getComputedStyle(r).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const r = ae();
      if (!r)
        return;
      const s = parseInt(window.getComputedStyle(r).width), a = () => {
        if (!document.body.contains(n))
          return;
        const i = n.offsetWidth + o(n), l = ae();
        l && (i > s ? l.style.width = `${i}px` : qt(l, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const Hp = (e, t) => {
  const n = jr();
  n && (Kr(n), ze(n, t, "htmlContainer"), t.html ? (Xr(t.html, n), Oe(n, "block")) : t.text ? (n.textContent = t.text, Oe(n, "block")) : De(n), Rp(e, t));
}, jp = (e, t) => {
  const n = $i();
  n && (Kr(n), Hn(n, !!t.footer, "block"), t.footer && Xr(t.footer, n), ze(n, t, "footer"));
}, Yp = (e, t) => {
  const n = le.innerParams.get(e), o = yn();
  if (!o)
    return;
  if (n && t.icon === n.icon) {
    zs(o, t), qs(o, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    De(o);
    return;
  }
  if (t.icon && Object.keys(mo).indexOf(t.icon) === -1) {
    Jt(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), De(o);
    return;
  }
  Oe(o), zs(o, t), qs(o, t), re(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Fi);
}, qs = (e, t) => {
  for (const [n, o] of Object.entries(mo))
    t.icon !== n && rt(e, o);
  re(e, t.icon && mo[t.icon]), zp(e, t), Fi(), ze(e, t, "icon");
}, Fi = () => {
  const e = ae();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color");
  e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix").forEach((o) => {
    o.style.backgroundColor = t;
  });
}, Wp = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, qp = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, zs = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = Ks(t.iconHtml) : t.icon === "success" ? (o = Wp(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = qp : t.icon && (o = Ks({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && Ze(e, o);
}, zp = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      Ws(e, n, "background-color", t.iconColor);
    Ws(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, Ks = (e) => `<div class="${_["icon-content"]}">${e}</div>`, Kp = (e, t) => {
  const n = Si();
  if (n) {
    if (!t.imageUrl) {
      De(n);
      return;
    }
    Oe(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), qt(n, "width", t.imageWidth), qt(n, "height", t.imageHeight), n.className = _.image, ze(n, t, "image");
  }
};
let Jr = !1, Ui = 0, Vi = 0, Hi = 0, ji = 0;
const Gp = (e) => {
  e.addEventListener("mousedown", wo), document.body.addEventListener("mousemove", po), e.addEventListener("mouseup", ho), e.addEventListener("touchstart", wo), document.body.addEventListener("touchmove", po), e.addEventListener("touchend", ho);
}, Xp = (e) => {
  e.removeEventListener("mousedown", wo), document.body.removeEventListener("mousemove", po), e.removeEventListener("mouseup", ho), e.removeEventListener("touchstart", wo), document.body.removeEventListener("touchmove", po), e.removeEventListener("touchend", ho);
}, wo = (e) => {
  const t = ae();
  if (!t)
    return;
  const n = yn();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Jr = !0;
    const o = Yi(e);
    Ui = o.clientX, Vi = o.clientY, Hi = parseInt(t.style.insetInlineStart) || 0, ji = parseInt(t.style.insetBlockStart) || 0, re(t, "swal2-dragging");
  }
}, po = (e) => {
  const t = ae();
  if (t && Jr) {
    let {
      clientX: n,
      clientY: o
    } = Yi(e);
    const r = n - Ui;
    t.style.insetInlineStart = `${Hi + (B.isRTL ? -r : r)}px`, t.style.insetBlockStart = `${ji + (o - Vi)}px`;
  }
}, ho = () => {
  const e = ae();
  Jr = !1, rt(e, "swal2-dragging");
}, Yi = (e) => {
  const t = e.type.startsWith("touch") ? (
    /** @type {TouchEvent} */
    e.touches[0]
  ) : (
    /** @type {MouseEvent} */
    e
  );
  return {
    clientX: t.clientX,
    clientY: t.clientY
  };
}, Zp = (e, t) => {
  const n = Fe(), o = ae();
  if (!(!n || !o)) {
    if (t.toast) {
      qt(n, "width", t.width), o.style.width = "100%";
      const r = En();
      r && o.insertBefore(r, yn());
    } else
      qt(o, "width", t.width);
    qt(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), De(Oo()), Jp(o, t), t.draggable && !t.toast ? (re(o, _.draggable), Gp(o)) : (rt(o, _.draggable), Xp(o));
  }
}, Jp = (e, t) => {
  const n = t.showClass || {};
  e.className = `${_.popup} ${je(e) ? n.popup : ""}`, t.toast ? (re([document.documentElement, document.body], _["toast-shown"]), re(e, _.toast)) : re(e, _.modal), ze(e, t, "popup"), typeof t.customClass == "string" && re(e, t.customClass), t.icon && re(e, _[`icon-${t.icon}`]);
}, Qp = (e, t) => {
  const n = Yr();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: r
  } = t;
  if (!o || o.length === 0 || r === void 0) {
    De(n);
    return;
  }
  Oe(n), n.textContent = "", r >= o.length && Re("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((s, a) => {
    const i = eh(s);
    if (n.appendChild(i), a === r && re(i, _["active-progress-step"]), a !== o.length - 1) {
      const l = th(t);
      n.appendChild(l);
    }
  });
}, eh = (e) => {
  const t = document.createElement("li");
  return re(t, _["progress-step"]), Ze(t, e), t;
}, th = (e) => {
  const t = document.createElement("li");
  return re(t, _["progress-step-line"]), e.progressStepsDistance && qt(t, "width", e.progressStepsDistance), t;
}, nh = (e, t) => {
  const n = Ii();
  n && (Kr(n), Hn(n, !!(t.title || t.titleText), "block"), t.title && Xr(t.title, n), t.titleText && (n.innerText = t.titleText), ze(n, t, "title"));
}, Wi = (e, t) => {
  var n;
  Zp(e, t), Ip(e, t), Qp(e, t), Yp(e, t), Kp(e, t), nh(e, t), Pp(e, t), Hp(e, t), Lp(e, t), jp(e, t);
  const o = ae();
  typeof t.didRender == "function" && o && t.didRender(o), (n = B.eventEmitter) === null || n === void 0 || n.emit("didRender", o);
}, oh = () => je(ae()), qi = () => {
  var e;
  return (e = gt()) === null || e === void 0 ? void 0 : e.click();
}, rh = () => {
  var e;
  return (e = Qt()) === null || e === void 0 ? void 0 : e.click();
}, sh = () => {
  var e;
  return (e = _n()) === null || e === void 0 ? void 0 : e.click();
}, kn = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), zi = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, ah = (e, t, n) => {
  if (zi(e), !t.toast) {
    const o = (s) => lh(t, s, n);
    e.keydownHandler = o;
    const r = t.keydownListenerCapture ? window : ae();
    if (r) {
      e.keydownTarget = r, e.keydownListenerCapture = t.keydownListenerCapture;
      const s = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", s, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, cr = (e, t) => {
  var n;
  const o = qr();
  return o.length ? (e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus(), !(lp() && o[e] instanceof HTMLIFrameElement)) : ((n = ae()) === null || n === void 0 || n.focus(), !0);
}, Ki = ["ArrowRight", "ArrowDown"], ih = ["ArrowLeft", "ArrowUp"], lh = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? ch(t, e) : t.key === "Tab" ? uh(t) : [...Ki, ...ih].includes(t.key) ? dh(t.key) : t.key === "Escape" && mh(t, e, n)));
}, ch = (e, t) => {
  if (!No(t.allowEnterKey))
    return;
  const n = ae();
  if (!n || !t.input)
    return;
  const o = So(n, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    qi(), e.preventDefault();
  }
}, uh = (e) => {
  const t = e.target, o = qr().findIndex((s) => s === t);
  let r = !0;
  e.shiftKey ? r = cr(o, -1) : r = cr(o, 1), e.stopPropagation(), r && e.preventDefault();
}, dh = (e) => {
  const t = Vn(), n = gt(), o = Qt(), r = _n();
  if (!t || !n || !o || !r)
    return;
  const s = [n, o, r];
  if (document.activeElement instanceof HTMLElement && !s.includes(document.activeElement))
    return;
  const a = Ki.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let l = 0; l < t.children.length; l++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && je(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, mh = (e, t, n) => {
  e.preventDefault(), No(t.allowEscapeKey) && n(kn.esc);
};
var mn = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const fh = () => {
  const e = Fe();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, Gi = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, Qr = typeof window < "u" && !!window.GestureEvent, wh = Qr && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, ph = () => {
  if (Qr && !xt(document.body, _.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, re(document.body, _.iosfix), hh();
  }
}, hh = () => {
  const e = Fe();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = gh(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, gh = (e) => {
  const t = e.target, n = Fe(), o = jr();
  return !n || !o || bh(e) || vh(e) ? !1 : t === n || !lr(n) && t instanceof HTMLElement && !pp(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(lr(o) && // #1944
  o.contains(t));
}, bh = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), vh = (e) => e.touches && e.touches.length > 1, yh = () => {
  if (xt(document.body, _.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    rt(document.body, _.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, _h = () => {
  const e = document.createElement("div");
  e.className = _["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let an = null;
const Eh = (e) => {
  an === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (an = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${an + _h()}px`);
}, kh = () => {
  an !== null && (document.body.style.paddingRight = `${an}px`, an = null);
};
function Xi(e, t, n, o) {
  Io() ? Gs(e, o) : (rp(n).then(() => Gs(e, o)), zi(B)), Qr ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), zr() && (kh(), yh(), Gi()), xh();
}
function xh() {
  rt([document.documentElement, document.body], [_.shown, _["height-auto"], _["no-backdrop"], _["toast-shown"]]);
}
function It(e) {
  e = Ah(e);
  const t = mn.swalPromiseResolve.get(this), n = Ch(this);
  this.isAwaitingPromise ? e.isDismissed || (Yn(this), t(e)) : n && t(e);
}
const Ch = (e) => {
  const t = ae();
  if (!t)
    return !1;
  const n = le.innerParams.get(e);
  if (!n || xt(t, n.hideClass.popup))
    return !1;
  rt(t, n.showClass.popup), re(t, n.hideClass.popup);
  const o = Fe();
  return rt(o, n.showClass.backdrop), re(o, n.hideClass.backdrop), Lh(e, t, n), !0;
};
function Zi(e) {
  const t = mn.swalPromiseReject.get(this);
  Yn(this), t && t(e);
}
const Yn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, le.innerParams.get(e) || e._destroy());
}, Ah = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), Lh = (e, t, n) => {
  var o;
  const r = Fe(), s = Ri(t);
  typeof n.willClose == "function" && n.willClose(t), (o = B.eventEmitter) === null || o === void 0 || o.emit("willClose", t), s && r ? Th(e, t, r, !!n.returnFocus, n.didClose) : r && Xi(e, r, !!n.returnFocus, n.didClose);
}, Th = (e, t, n, o, r) => {
  B.swalCloseEventFinishedCallback = Xi.bind(null, e, n, o, r);
  const s = function(a) {
    if (a.target === t) {
      var i;
      (i = B.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(B), delete B.swalCloseEventFinishedCallback, t.removeEventListener("animationend", s), t.removeEventListener("transitionend", s);
    }
  };
  t.addEventListener("animationend", s), t.addEventListener("transitionend", s);
}, Gs = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = B.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, fn = (e) => {
  let t = ae();
  if (t || new Yt(), t = ae(), !t)
    return;
  const n = En();
  Io() ? De(yn()) : Nh(t, e), Oe(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, Nh = (e, t) => {
  const n = Vn(), o = En();
  !n || !o || (!t && je(gt()) && (t = gt()), Oe(n), t && (De(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), re([e, n], _.loading));
}, Oh = (e, t) => {
  t.input === "select" || t.input === "radio" ? Dh(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (Vr(t.inputValue) || Hr(t.inputValue)) && (fn(gt()), Mh(e, t));
}, Ph = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return Ih(n);
    case "radio":
      return Sh(n);
    case "file":
      return $h(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, Ih = (e) => e.checked ? 1 : 0, Sh = (e) => e.checked ? e.value : null, $h = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, Dh = (e, t) => {
  const n = ae();
  if (!n)
    return;
  const o = (r) => {
    t.input === "select" ? Rh(n, ur(r), t) : t.input === "radio" && Bh(n, ur(r), t);
  };
  Vr(t.inputOptions) || Hr(t.inputOptions) ? (fn(gt()), Fn(t.inputOptions).then((r) => {
    e.hideLoading(), o(r);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : Jt(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Mh = (e, t) => {
  const n = e.getInput();
  n && (De(n), Fn(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, Oe(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    Jt(`Error in inputValue promise: ${o}`), n.value = "", Oe(n), n.focus(), e.hideLoading();
  }));
};
function Rh(e, t, n) {
  const o = Pt(e, _.select);
  if (!o)
    return;
  const r = (s, a, i) => {
    const l = document.createElement("option");
    l.value = i, Ze(l, a), l.selected = Ji(i, n.inputValue), s.appendChild(l);
  };
  t.forEach((s) => {
    const a = s[0], i = s[1];
    if (Array.isArray(i)) {
      const l = document.createElement("optgroup");
      l.label = a, l.disabled = !1, o.appendChild(l), i.forEach((w) => r(l, w[1], w[0]));
    } else
      r(o, i, a);
  }), o.focus();
}
function Bh(e, t, n) {
  const o = Pt(e, _.radio);
  if (!o)
    return;
  t.forEach((s) => {
    const a = s[0], i = s[1], l = document.createElement("input"), w = document.createElement("label");
    l.type = "radio", l.name = _.radio, l.value = a, Ji(a, n.inputValue) && (l.checked = !0);
    const h = document.createElement("span");
    Ze(h, i), h.className = _.label, w.appendChild(l), w.appendChild(h), o.appendChild(w);
  });
  const r = o.querySelectorAll("input");
  r.length && r[0].focus();
}
const ur = (e) => (e instanceof Map ? Array.from(e) : Object.entries(e)).map(([n, o]) => [n, typeof o == "object" ? ur(o) : o]), Ji = (e, t) => !!t && t != null && t.toString() === e.toString(), Fh = (e) => {
  const t = le.innerParams.get(e);
  e.disableButtons(), t.input ? Qi(e, "confirm") : ts(e, !0);
}, Uh = (e) => {
  const t = le.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? Qi(e, "deny") : es(e, !1);
}, Vh = (e, t) => {
  e.disableButtons(), t(kn.cancel);
}, Qi = (e, t) => {
  const n = le.innerParams.get(e);
  if (!n.input) {
    Jt(`The "input" parameter is needed to be set when using returnInputValueOn${Ur(t)}`);
    return;
  }
  const o = e.getInput(), r = Ph(e, n);
  n.inputValidator ? Hh(e, r, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? es(e, r) : ts(e, r);
}, Hh = (e, t, n) => {
  const o = le.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Fn(o.inputValidator(t, o.validationMessage))).then((s) => {
    e.enableButtons(), e.enableInput(), s ? e.showValidationMessage(s) : n === "deny" ? es(e, t) : ts(e, t);
  });
}, es = (e, t) => {
  const n = le.innerParams.get(e);
  n.showLoaderOnDeny && fn(Qt()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Fn(n.preDeny(t, n.validationMessage))).then((r) => {
    r === !1 ? (e.hideLoading(), Yn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof r > "u" ? t : r
      }
    );
  }).catch((r) => el(e, r))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, Xs = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, el = (e, t) => {
  e.rejectPromise(t);
}, ts = (e, t) => {
  const n = le.innerParams.get(e);
  n.showLoaderOnConfirm && fn(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Fn(n.preConfirm(t, n.validationMessage))).then((r) => {
    je(Oo()) || r === !1 ? (e.hideLoading(), Yn(e)) : Xs(e, typeof r > "u" ? t : r);
  }).catch((r) => el(e, r))) : Xs(e, t);
};
function go() {
  const e = le.innerParams.get(this);
  if (!e)
    return;
  const t = le.domCache.get(this);
  De(t.loader), Io() ? e.icon && Oe(yn()) : jh(t), rt([t.popup, t.actions], _.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), this.enableButtons();
}
const jh = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? Oe(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : wp() && De(e.actions);
};
function tl() {
  const e = le.innerParams.get(this), t = le.domCache.get(this);
  return t ? So(t.popup, e.input) : null;
}
function nl(e, t, n) {
  const o = le.domCache.get(e);
  t.forEach((r) => {
    o[r].disabled = n;
  });
}
function ol(e, t) {
  const n = ae();
  !n || !e || (e.type === "radio" ? n.querySelectorAll(`[name="${_.radio}"]`).forEach((r) => {
    r.disabled = t;
  }) : e.disabled = t);
}
function rl() {
  nl(this, ["confirmButton", "denyButton", "cancelButton"], !1);
  const e = le.focusedElement.get(this);
  e instanceof HTMLElement && document.activeElement === document.body && e.focus(), le.focusedElement.delete(this);
}
function sl() {
  le.focusedElement.set(this, document.activeElement), nl(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function al() {
  ol(this.getInput(), !1);
}
function il() {
  ol(this.getInput(), !0);
}
function ll(e) {
  const t = le.domCache.get(this), n = le.innerParams.get(this);
  Ze(t.validationMessage, e), t.validationMessage.className = _["validation-message"], n.customClass && n.customClass.validationMessage && re(t.validationMessage, n.customClass.validationMessage), Oe(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", _["validation-message"]), Di(o), re(o, _.inputerror));
}
function cl() {
  const e = le.domCache.get(this);
  e.validationMessage && De(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), rt(t, _.inputerror));
}
const St = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, Yh = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], Wh = {
  allowEnterKey: void 0
}, qh = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], ul = (e) => Object.prototype.hasOwnProperty.call(St, e), dl = (e) => Yh.indexOf(e) !== -1, ml = (e) => Wh[e], zh = (e) => {
  ul(e) || Re(`Unknown parameter "${e}"`);
}, Kh = (e) => {
  qh.includes(e) && Re(`The parameter "${e}" is incompatible with toasts`);
}, Gh = (e) => {
  const t = ml(e);
  t && Pi(e, t);
}, fl = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Re('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Re(`Invalid theme "${e.theme}"`);
  for (const t in e)
    zh(t), e.toast && Kh(t), Gh(t);
};
function wl(e) {
  const t = Fe(), n = ae(), o = le.innerParams.get(this);
  if (!n || xt(n, o.hideClass.popup)) {
    Re("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const r = Xh(e), s = Object.assign({}, o, r);
  fl(s), t && (t.dataset.swal2Theme = s.theme), Wi(this, s), le.innerParams.set(this, s), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const Xh = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (dl(n)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = o[n];
    } else
      Re(`Invalid parameter to update: ${n}`);
  }), t;
};
function pl() {
  var e;
  const t = le.domCache.get(this), n = le.innerParams.get(this);
  if (!n) {
    hl(this);
    return;
  }
  t.popup && B.swalCloseEventFinishedCallback && (B.swalCloseEventFinishedCallback(), delete B.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = B.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), Zh(this);
}
const Zh = (e) => {
  hl(e), delete e.params, delete B.keydownHandler, delete B.keydownTarget, delete B.currentInstance;
}, hl = (e) => {
  e.isAwaitingPromise ? (qo(le, e), e.isAwaitingPromise = !0) : (qo(mn, e), qo(le, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, qo = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var Jh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: pl,
  close: It,
  closeModal: It,
  closePopup: It,
  closeToast: It,
  disableButtons: sl,
  disableInput: il,
  disableLoading: go,
  enableButtons: rl,
  enableInput: al,
  getInput: tl,
  handleAwaitingPromise: Yn,
  hideLoading: go,
  rejectPromise: Zi,
  resetValidationMessage: cl,
  showValidationMessage: ll,
  update: wl
});
const Qh = (e, t, n) => {
  e.toast ? eg(e, t, n) : (ng(t), og(t), rg(e, t, n));
}, eg = (e, t, n) => {
  t.popup.onclick = () => {
    e && (tg(e) || e.timer || e.input) || n(kn.close);
  };
}, tg = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let bo = !1;
const ng = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (bo = !0);
    };
  };
}, og = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (bo = !0);
    };
  };
}, rg = (e, t, n) => {
  t.container.onclick = (o) => {
    if (bo) {
      bo = !1;
      return;
    }
    o.target === t.container && No(e.allowOutsideClick) && n(kn.backdrop);
  };
}, sg = (e) => typeof e == "object" && e !== null && "jquery" in e, Zs = (e) => e instanceof Element || sg(e), ag = (e) => {
  const t = {};
  return typeof e[0] == "object" && !Zs(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const r = e[o];
    typeof r == "string" || Zs(r) ? t[n] = r : r !== void 0 && Jt(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof r}`);
  }), /** @type {SweetAlertOptions} */
  t;
};
function ig(...e) {
  return new this(...e);
}
function lg(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, r) {
      return super._main(o, Object.assign({}, e, r));
    }
  }
  return t;
}
const cg = () => B.timeout && B.timeout.getTimerLeft(), gl = () => {
  if (B.timeout)
    return hp(), B.timeout.stop();
}, bl = () => {
  if (B.timeout) {
    const e = B.timeout.start();
    return Gr(e), e;
  }
}, ug = () => {
  const e = B.timeout;
  return e && (e.running ? gl() : bl());
}, dg = (e) => {
  if (B.timeout) {
    const t = B.timeout.increase(e);
    return Gr(t, !0), t;
  }
}, mg = () => !!(B.timeout && B.timeout.isRunning());
let Js = !1;
const dr = {};
function fg(e = "data-swal-template") {
  dr[e] = this, Js || (document.body.addEventListener("click", wg), Js = !0);
}
const wg = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in dr) {
      const o = t.getAttribute && t.getAttribute(n);
      if (o) {
        dr[n].fire({
          template: o
        });
        return;
      }
    }
};
class pg {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...r) => {
      this.removeListener(t, o), n.apply(this, r);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (r) {
          console.error(r);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), r = o.indexOf(n);
    r > -1 && o.splice(r, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
B.eventEmitter = new pg();
const hg = (e, t) => {
  B.eventEmitter && B.eventEmitter.on(e, t);
}, gg = (e, t) => {
  B.eventEmitter && B.eventEmitter.once(e, t);
}, bg = (e, t) => {
  if (B.eventEmitter) {
    if (!e) {
      B.eventEmitter.reset();
      return;
    }
    t ? B.eventEmitter.removeListener(e, t) : B.eventEmitter.removeAllListeners(e);
  }
};
var vg = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: ag,
  bindClickHandler: fg,
  clickCancel: sh,
  clickConfirm: qi,
  clickDeny: rh,
  enableLoading: fn,
  fire: ig,
  getActions: Vn,
  getCancelButton: _n,
  getCloseButton: Wr,
  getConfirmButton: gt,
  getContainer: Fe,
  getDenyButton: Qt,
  getFocusableElements: qr,
  getFooter: $i,
  getHtmlContainer: jr,
  getIcon: yn,
  getIconContent: cp,
  getImage: Si,
  getInputLabel: up,
  getLoader: En,
  getPopup: ae,
  getProgressSteps: Yr,
  getTimerLeft: cg,
  getTimerProgressBar: Po,
  getTitle: Ii,
  getValidationMessage: Oo,
  increaseTimer: dg,
  isDeprecatedParameter: ml,
  isLoading: mp,
  isTimerRunning: mg,
  isUpdatableParameter: dl,
  isValidParameter: ul,
  isVisible: oh,
  mixin: lg,
  off: bg,
  on: hg,
  once: gg,
  resumeTimer: bl,
  showLoading: fn,
  stopTimer: gl,
  toggleTimer: ug
});
class yg {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const vl = ["swal-title", "swal-html", "swal-footer"], _g = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return Ng(n), Object.assign(Eg(n), kg(n), xg(n), Cg(n), Ag(n), Lg(n), Tg(n, vl));
}, Eg = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    Gt(o, ["name", "value"]);
    const r = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), s = o.getAttribute("value");
    !r || !s || (r in St && typeof St[
      /** @type {keyof typeof defaultParams} */
      r
    ] == "boolean" ? t[r] = s !== "false" : r in St && typeof St[
      /** @type {keyof typeof defaultParams} */
      r
    ] == "object" ? t[r] = JSON.parse(s) : t[r] = s);
  }), t;
}, kg = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const r = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), s = o.getAttribute("value");
    !r || !s || (t[r] = new Function(`return ${s}`)());
  }), t;
}, xg = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    Gt(o, ["type", "color", "aria-label"]);
    const r = o.getAttribute("type");
    if (!r || !["confirm", "cancel", "deny"].includes(r))
      return;
    t[`${r}ButtonText`] = o.innerHTML, t[`show${Ur(r)}Button`] = !0;
    const s = o.getAttribute("color");
    s !== null && (t[`${r}ButtonColor`] = s);
    const a = o.getAttribute("aria-label");
    a !== null && (t[`${r}ButtonAriaLabel`] = a);
  }), t;
}, Cg = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  if (n) {
    Gt(n, ["src", "width", "height", "alt"]);
    const o = n.getAttribute("src");
    o !== null && (t.imageUrl = o || void 0);
    const r = n.getAttribute("width");
    r !== null && (t.imageWidth = r || void 0);
    const s = n.getAttribute("height");
    s !== null && (t.imageHeight = s || void 0);
    const a = n.getAttribute("alt");
    a !== null && (t.imageAlt = a || void 0);
  }
  return t;
}, Ag = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (Gt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, Lg = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (Gt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((r) => {
    Gt(r, ["value"]);
    const s = r.getAttribute("value");
    if (!s)
      return;
    const a = r.innerHTML;
    t.inputOptions[s] = a;
  })), t;
}, Tg = (e, t) => {
  const n = {};
  for (const o in t) {
    const r = t[o], s = e.querySelector(r);
    s && (Gt(s, []), n[r.replace(/^swal-/, "")] = s.innerHTML.trim());
  }
  return n;
}, Ng = (e) => {
  const t = vl.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Re(`Unrecognized element <${o}>`);
  });
}, Gt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Re([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, yl = 10, Og = (e) => {
  var t, n;
  const o = Fe(), r = ae();
  if (!o || !r)
    return;
  typeof e.willOpen == "function" && e.willOpen(r), (t = B.eventEmitter) === null || t === void 0 || t.emit("willOpen", r);
  const a = window.getComputedStyle(document.body).overflowY;
  if (Sg(o, r, e), setTimeout(() => {
    Pg(o, r);
  }, yl), zr() && (Ig(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, a), fh()), wh && e.backdrop === !1 && r.scrollHeight > o.clientHeight && (o.style.pointerEvents = "auto"), !Io() && !B.previousActiveElement && (B.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const i = e.didOpen;
    setTimeout(() => i(r));
  }
  (n = B.eventEmitter) === null || n === void 0 || n.emit("didOpen", r);
}, vo = (e) => {
  const t = ae();
  if (!t || e.target !== t)
    return;
  const n = Fe();
  n && (t.removeEventListener("animationend", vo), t.removeEventListener("transitionend", vo), n.style.overflowY = "auto", rt(n, _["no-transition"]));
}, Pg = (e, t) => {
  Ri(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", vo), t.addEventListener("transitionend", vo)) : e.style.overflowY = "auto";
}, Ig = (e, t, n) => {
  ph(), t && n !== "hidden" && Eh(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Sg = (e, t, n) => {
  var o;
  (o = n.showClass) !== null && o !== void 0 && o.backdrop && re(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), Oe(t, "grid"), setTimeout(() => {
    var r;
    (r = n.showClass) !== null && r !== void 0 && r.popup && re(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, yl)) : Oe(t, "grid"), re([document.documentElement, document.body], _.shown), n.heightAuto && n.backdrop && !n.toast && re([document.documentElement, document.body], _["height-auto"]);
};
var Qs = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function $g(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Qs.email), e.input === "url" && (e.inputValidator = Qs.url));
}
function Dg(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Re('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Mg(e) {
  $g(e), e.showLoaderOnConfirm && !e.preConfirm && Re(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), Dg(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), xp(e);
}
let ft;
var Gn = /* @__PURE__ */ new WeakMap();
class Ee {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (ep(
      this,
      Gn,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    ft = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, tp(Gn, this, this._main(ft.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (fl(Object.assign({}, n, t)), B.currentInstance) {
      const s = mn.swalPromiseResolve.get(B.currentInstance), {
        isAwaitingPromise: a
      } = B.currentInstance;
      B.currentInstance._destroy(), a || s({
        isDismissed: !0
      }), zr() && Gi();
    }
    B.currentInstance = ft;
    const o = Bg(t, n);
    Mg(o), Object.freeze(o), B.timeout && (B.timeout.stop(), delete B.timeout), clearTimeout(B.restoreFocusTimeout);
    const r = Fg(ft);
    return Wi(ft, o), le.innerParams.set(ft, o), Rg(ft, r, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  // oxlint-disable-next-line unicorn/no-thenable
  then(t) {
    return js(Gn, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return js(Gn, this).finally(t);
  }
}
const Rg = (e, t, n) => new Promise((o, r) => {
  const s = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  mn.swalPromiseResolve.set(e, o), mn.swalPromiseReject.set(e, r), t.confirmButton.onclick = () => {
    Fh(e);
  }, t.denyButton.onclick = () => {
    Uh(e);
  }, t.cancelButton.onclick = () => {
    Vh(e, s);
  }, t.closeButton.onclick = () => {
    s(kn.close);
  }, Qh(n, t, s), ah(B, n, s), Oh(e, n), Og(n), Ug(B, n, s), Vg(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), Bg = (e, t) => {
  const n = _g(e), o = Object.assign({}, St, t, n, e);
  return o.showClass = Object.assign({}, St.showClass, o.showClass), o.hideClass = Object.assign({}, St.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, Fg = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        ae()
      ),
      container: (
        /** @type {HTMLElement} */
        Fe()
      ),
      actions: (
        /** @type {HTMLElement} */
        Vn()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        gt()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        Qt()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        _n()
      ),
      loader: (
        /** @type {HTMLElement} */
        En()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        Wr()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        Oo()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        Yr()
      )
    }
  );
  return le.domCache.set(e, t), t;
}, Ug = (e, t, n) => {
  const o = Po();
  De(o), t.timer && (e.timeout = new yg(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (Oe(o), ze(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && Gr(
      /** @type {number} */
      t.timer
    );
  })));
}, Vg = (e, t) => {
  if (!t.toast) {
    if (!No(t.allowEnterKey)) {
      Pi("allowEnterKey", "preConfirm: () => false"), e.popup.focus();
      return;
    }
    Hg(e) || jg(e, t) || cr(-1, 1);
  }
}, Hg = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && je(n))
      return n.focus(), !0;
  return !1;
}, jg = (e, t) => t.focusDeny && je(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && je(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && je(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1;
Ee.prototype.disableButtons = sl;
Ee.prototype.enableButtons = rl;
Ee.prototype.getInput = tl;
Ee.prototype.disableInput = il;
Ee.prototype.enableInput = al;
Ee.prototype.hideLoading = go;
Ee.prototype.disableLoading = go;
Ee.prototype.showValidationMessage = ll;
Ee.prototype.resetValidationMessage = cl;
Ee.prototype.close = It;
Ee.prototype.closePopup = It;
Ee.prototype.closeModal = It;
Ee.prototype.closeToast = It;
Ee.prototype.rejectPromise = Zi;
Ee.prototype.update = wl;
Ee.prototype._destroy = pl;
Object.assign(Ee, vg);
Object.keys(Jh).forEach((e) => {
  Ee[e] = function(...t) {
    if (ft && ft[e])
      return ft[e](...t);
  };
});
Ee.DismissReason = kn;
Ee.version = "11.26.25";
const Yt = Ee;
Yt.default = Yt;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:auto}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:auto}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const Yg = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
}, Wg = { class: "bg-white rounded-3xl w-full max-w-md shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200" }, qg = { class: "p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50" }, zg = { class: "p-6 space-y-5" }, Kg = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-2xl p-4 flex flex-col gap-1"
}, Gg = { class: "text-sm text-red-600 font-medium" }, Xg = {
  key: 0,
  class: "bg-red-100 px-1.5 py-0.5 rounded mr-1"
}, Zg = {
  key: 0,
  class: "text-xs text-red-500 mt-1 font-medium"
}, Jg = { class: "relative" }, Qg = {
  key: 0,
  class: "absolute right-3 top-1/2 -translate-y-1/2"
}, eb = { class: "p-6 bg-gray-50 flex gap-3" }, tb = ["disabled"], nb = ["disabled"], ob = /* @__PURE__ */ $t({
  __name: "InvoiceModal",
  props: {
    isOpen: { type: Boolean },
    payment: {},
    queryCompanyName: { type: Function },
    createInvoice: { type: Function },
    voidPayment: { type: Function }
  },
  emits: ["close", "success"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = Ve(!1), s = Ve(!1), a = Ve(""), i = ea({
      CarrierNum: "",
      CustomerIdentifier: "",
      CustomerName: "",
      CustomerAddr: "台北市信義區忠孝東路五段",
      CustomerPhone: "0912345678",
      CustomerEmail: "test@example.com"
    });
    zo(() => n.isOpen, (v) => {
      v || (i.CarrierNum = "", i.CustomerIdentifier = "", i.CustomerName = "", a.value = "");
    });
    const l = async (v) => {
      const d = v.target, m = iw(d.value);
      if (d.value = m.value, i.CustomerIdentifier = m.value, a.value = m.error, m.isReady) {
        s.value = !0;
        try {
          const A = await n.queryCompanyName(m.value);
          A && A.Company_Name ? i.CustomerName = A.Company_Name : a.value = "查無此統一編號的公司名稱";
        } catch {
          a.value = "系統查詢名稱失敗，請手動輸入公司名稱";
        } finally {
          s.value = !1;
        }
      }
    }, w = async () => {
      var v, d;
      if (n.payment) {
        if (i.CustomerIdentifier.length === 8 && !i.CustomerName.trim()) {
          Yt.fire({ title: "請輸入買受人名稱（公司全名）", timer: 1e3, showConfirmButton: !1 });
          return;
        }
        r.value = !0;
        try {
          const m = i.CustomerIdentifier.length === 8, A = {
            relate_number: n.payment.merchant_trade_no,
            customer_id: "",
            customer_addr: i.CustomerAddr,
            customer_phone: i.CustomerPhone,
            customer_email: i.CustomerEmail,
            print: i.CarrierNum ? "0" : "1",
            donation: "0",
            carrier_type: !m && i.CarrierNum ? "3" : "",
            carrier_num: m ? "" : i.CarrierNum,
            customer_identifier: i.CustomerIdentifier,
            customer_name: i.CustomerName || "消費者",
            tax_type: "1",
            sales_amount: Number(n.payment.trade_amt),
            items: [{
              item_name: "交易商品",
              item_count: 1,
              item_word: "件",
              item_price: Number(n.payment.trade_amt),
              item_amount: Number(n.payment.trade_amt)
            }]
          };
          await n.createInvoice(A), Yt.fire({ title: "發票開立成功！", timer: 1e3, showConfirmButton: !1 }), o("success");
        } catch (m) {
          Yt.fire({ title: `發票開立失敗: ${((d = (v = m.response) == null ? void 0 : v.data) == null ? void 0 : d.message) || m.message}`, icon: "error", timer: 3e3 });
        } finally {
          r.value = !1;
        }
      }
    }, h = async () => {
      var v, d;
      if (n.payment && confirm("確定要作廢此筆交易嗎？此操作將會把訂單狀態重置為新訂單。")) {
        r.value = !0;
        try {
          await n.voidPayment({
            merchant_trade_no: n.payment.merchant_trade_no,
            ids: n.payment.order_ids || [],
            merchant_id: n.payment.merchant_id
          }), alert("交易已成功作廢，訂單已重置。"), o("success");
        } catch (m) {
          Yt.fire({ title: `作廢失敗: ${((d = (v = m.response) == null ? void 0 : v.data) == null ? void 0 : d.message) || m.message}`, icon: "error", timer: 3e3 });
        } finally {
          r.value = !1;
        }
      }
    };
    return (v, d) => {
      var m, A, g, T, f, b;
      return e.isOpen ? (X(), te("div", Yg, [
        E("div", Wg, [
          E("div", qg, [
            d[6] || (d[6] = E("h3", { class: "text-xl font-black text-gray-700" }, "開立電子發票", -1)),
            E("button", {
              onClick: d[0] || (d[0] = (C) => o("close")),
              class: "text-gray-400 hover:text-gray-600 transition-colors"
            }, [...d[5] || (d[5] = [
              E("svg", {
                class: "w-6 h-6",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                E("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ])])
          ]),
          E("div", zg, [
            ((A = (m = e.payment) == null ? void 0 : m.invoice_transaction) == null ? void 0 : A.status) === "failed" && (e.payment.invoice_transaction.error_message || e.payment.invoice_transaction.error_code) ? (X(), te("div", Kg, [
              d[7] || (d[7] = E("div", { class: "flex items-center gap-1.5 text-red-700" }, [
                E("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  E("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ]),
                E("p", { class: "text-xs font-black uppercase tracking-wider" }, "上次開立失敗")
              ], -1)),
              E("p", Gg, [
                e.payment.invoice_transaction.error_code ? (X(), te("span", Xg, "[" + j(e.payment.invoice_transaction.error_code) + "]", 1)) : Ue("", !0),
                Lt(" " + j(e.payment.invoice_transaction.error_message), 1)
              ])
            ])) : Ue("", !0),
            E("div", null, [
              d[8] || (d[8] = E("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "手機條碼 (CarrierNum)", -1)),
              Mo(E("input", {
                "onUpdate:modelValue": d[1] || (d[1] = (C) => i.CarrierNum = C),
                type: "text",
                maxlength: "8",
                placeholder: "/ABC1234",
                class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
              }, null, 512), [
                [Ro, i.CarrierNum]
              ]),
              d[9] || (d[9] = E("p", { class: "text-[10px] text-gray-700 opacity-50 mt-1.5 ml-1" }, "* 第一碼必須為斜線 /", -1))
            ]),
            E("div", null, [
              d[10] || (d[10] = E("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "買受人統編 (CustomerIdentifier)", -1)),
              Mo(E("input", {
                "onUpdate:modelValue": d[2] || (d[2] = (C) => i.CustomerIdentifier = C),
                onInput: l,
                type: "text",
                maxlength: "8",
                placeholder: "8 位數字統編",
                class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
              }, null, 544), [
                [Ro, i.CustomerIdentifier]
              ]),
              a.value ? (X(), te("p", Zg, j(a.value), 1)) : Ue("", !0)
            ]),
            E("div", null, [
              d[12] || (d[12] = E("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "買受人名稱 (CustomerName)", -1)),
              E("div", Jg, [
                Mo(E("input", {
                  "onUpdate:modelValue": d[3] || (d[3] = (C) => i.CustomerName = C),
                  type: "text",
                  placeholder: "公司全名",
                  class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none"
                }, null, 512), [
                  [Ro, i.CustomerName]
                ]),
                s.value ? (X(), te("div", Qg, [...d[11] || (d[11] = [
                  E("div", { class: "animate-spin rounded-full h-4 w-4 border-2 border-blue-700 border-t-transparent" }, null, -1)
                ])])) : Ue("", !0)
              ])
            ])
          ]),
          E("div", eb, [
            E("button", {
              onClick: d[4] || (d[4] = (C) => o("close")),
              class: "px-4 py-3 rounded-2xl border border-gray-200 text-gray-700 font-bold hover:bg-white transition-colors"
            }, " 取消 "),
            E("button", {
              onClick: h,
              disabled: r.value,
              class: "flex-1 px-4 py-3 rounded-2xl border border-red-200 text-red-700 font-bold hover:bg-red-50 disabled:opacity-50 transition-all"
            }, j(r.value ? "處理中..." : "作廢交易"), 9, tb),
            E("button", {
              onClick: w,
              disabled: r.value || ((T = (g = e.payment) == null ? void 0 : g.invoice_transaction) == null ? void 0 : T.status) === "issued",
              class: "flex-1 px-4 py-3 rounded-2xl bg-blue-700 text-white font-bold hover:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-lg shadow-blue-700/20"
            }, j(r.value ? "處理中..." : ((b = (f = e.payment) == null ? void 0 : f.invoice_transaction) == null ? void 0 : b.status) === "issued" ? "發票已開立" : "確認開立"), 9, nb)
          ])
        ])
      ])) : Ue("", !0);
    };
  }
}), rb = { class: "p-4 sm:p-6 max-w-3xl mx-auto bg-gray-100 min-h-screen" }, sb = { class: "mb-6" }, ab = { class: "text-2xl sm:text-3xl font-black text-gray-700" }, ib = { class: "text-gray-700 mt-1 opacity-70 text-sm sm:text-base" }, lb = { class: "mb-4 flex gap-2" }, cb = ["disabled"], ub = {
  key: 0,
  class: "text-center py-20"
}, db = { class: "mt-4 text-blue-700 font-bold" }, mb = {
  key: 1,
  class: "bg-red-100 text-red-700 p-4 rounded-2xl border border-red-700 shadow-sm"
}, fb = {
  key: 2,
  class: "flex flex-col gap-6"
}, wb = { class: "flex flex-col sm:flex-row items-center justify-between gap-4 bg-white px-6 py-4 rounded-2xl border border-gray-100 shadow-xs mt-2" }, pb = { class: "text-sm text-gray-500" }, hb = { class: "font-bold text-blue-600" }, gb = { class: "font-bold text-gray-800" }, bb = { class: "flex items-center gap-3" }, vb = ["disabled"], yb = ["disabled"], _b = {
  key: 3,
  class: "text-center py-20 text-gray-700 bg-white rounded-3xl border border-gray-100 shadow-sm"
}, Eb = { class: "mt-4 font-medium" }, Cb = /* @__PURE__ */ $t({
  __name: "EcpayPaymentPage",
  props: {
    ecpayApi: {}
  },
  setup(e) {
    const { t } = pn(), n = e, {
      isLoading: o,
      paymentError: r,
      paymentsList: s,
      filterRtnCode: a,
      pagination: i,
      stats: l,
      loadPaymentInfo: w,
      changeFilter: h,
      createInvoice: v,
      queryCompanyName: d,
      voidPayment: m
    } = lw(n.ecpayApi), A = Ve(!1), g = Ve(null), T = (C) => {
      var p;
      String(C.rtn_code) === "1" && ((p = C.invoice_transaction) != null && p.print_html ? window.open(C.invoice_transaction.print_html, "_blank") : (g.value = C, A.value = !0));
    }, f = () => {
      A.value = !1, g.value = null;
    }, b = async () => {
      f(), await w(i.currentPage);
    };
    return mr(async () => {
      await w(1);
    }), (C, p) => (X(), te("div", rb, [
      E("header", sb, [
        E("h1", ab, j(K(t)("ecpay.title") || "交易紀錄管理"), 1),
        E("p", ib, j(K(t)("ecpay.subtitle") || "檢視您系統中的所有綠界付款單據"), 1)
      ]),
      E("div", lb, [
        E("button", {
          onClick: p[0] || (p[0] = (L) => K(h)(void 0)),
          class: nn(["px-4 py-2 rounded-xl font-bold text-sm transition-all", K(a) === void 0 ? "bg-blue-700 text-white shadow-lg shadow-blue-700/20" : "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50"])
        }, " 顯示全部 ", 2),
        E("button", {
          onClick: p[1] || (p[1] = (L) => K(h)("-1")),
          class: nn(["px-4 py-2 rounded-xl font-bold text-sm transition-all", K(a) === "-1" ? "bg-blue-700 text-white shadow-lg shadow-blue-700/20" : "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50"])
        }, " 只顯示作廢 ", 2),
        E("button", {
          onClick: p[2] || (p[2] = (L) => K(w)(K(i).currentPage)),
          disabled: K(o),
          class: "px-4 py-2 rounded-xl font-bold text-sm transition-all bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
        }, [...p[5] || (p[5] = [
          E("svg", {
            class: "inline-block w-4 h-4 mr-1",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            E("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            })
          ], -1),
          Lt(" 重新整理 ", -1)
        ])], 8, cb)
      ]),
      K(o) ? (X(), te("div", ub, [
        p[6] || (p[6] = E("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-4 border-blue-700 border-t-transparent" }, null, -1)),
        E("p", db, j(K(t)("common.loading") || "載入資料中..."), 1)
      ])) : K(r) ? (X(), te("div", mb, j(K(r)), 1)) : K(s).length > 0 ? (X(), te("div", fb, [
        Ko(bw, Nl(Ol(K(l))), null, 16),
        (X(!0), te(In, null, fr(K(s), (L) => (X(), Pl(Jw, {
          key: L.id,
          payment: L,
          onClickCard: T
        }, null, 8, ["payment"]))), 128)),
        E("div", wb, [
          E("p", pb, [
            p[7] || (p[7] = Lt(" 目前在第 ", -1)),
            E("span", hb, j(K(i).currentPage), 1),
            p[8] || (p[8] = Lt(" 頁 / 共 ", -1)),
            E("span", gb, j(K(i).totalPages), 1),
            p[9] || (p[9] = Lt(" 頁 ", -1))
          ]),
          E("div", bb, [
            E("button", {
              disabled: K(i).currentPage <= 1,
              onClick: p[3] || (p[3] = (L) => K(w)(K(i).currentPage - 1)),
              class: "inline-flex items-center rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
            }, " 上一頁 ", 8, vb),
            E("button", {
              disabled: K(i).currentPage >= K(i).totalPages,
              onClick: p[4] || (p[4] = (L) => K(w)(K(i).currentPage + 1)),
              class: "inline-flex items-center rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
            }, " 下一頁 ", 8, yb)
          ])
        ])
      ])) : (X(), te("div", _b, [
        p[10] || (p[10] = E("svg", {
          class: "mx-auto h-12 w-12 text-gray-700",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        }, [
          E("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          })
        ], -1)),
        E("p", Eb, j(K(t)("ecpay.noData") || "暫無任何交易紀錄"), 1)
      ])),
      Ko(ob, {
        "is-open": A.value,
        payment: g.value,
        "query-company-name": K(d),
        "create-invoice": K(v),
        "void-payment": K(m),
        onClose: f,
        onSuccess: b
      }, null, 8, ["is-open", "payment", "query-company-name", "create-invoice", "void-payment"])
    ]));
  }
});
export {
  Cb as EcpayPaymentPage,
  xb as RevenueReportPage
};
